import { faker } from "@faker-js/faker";
import gql from 'graphql-tag';
import * as ApolloReactHooks from '@apollo/client';
export const AgreementFormFragmentDoc = gql `
    fragment AgreementForm on AgreementForm {
  id
  title
  url
  acceptAgreementText
}
    `;
export const CommentWithNotificationFragmentDoc = gql `
    fragment CommentWithNotification on Comment {
  id
  notification {
    id
    viewedAt
  }
}
    `;
export const NoTargetsDisplaySettingsFragmentDoc = gql `
    fragment NoTargetsDisplaySettings on NoTargetsDisplaySettings {
  dailyProgressViewsForMacros
  mealProgressViewsForMacros
}
    `;
export const ExchangeSummaryLabelFragmentDoc = gql `
    fragment ExchangeSummaryLabel on ExchangeAmount {
  id
  __typename
  amount
  exchange {
    __typename
    id
    name
    shortName
    type
    cho
    pro
    fat
    kcal
  }
}
    `;
export const FeatureFlagsFragmentDoc = gql `
    fragment FeatureFlags on FeatureFlags {
  athleteMenuSuggestions
  clientCredentials
  hasRestaurantMenus
  restaurantLogging
  teamworksSchedules
  mealPlanSuggestions
  prepPlan
  foodCategory
  pk2MenuBuilder
  orgGroupRecipes
  orgGroupFoods
  performanceKitchen
  printableTags
  hubMenuCheckIn
  goalTracker
  dietitianOnlyMenus
  bulkOrdering
  ukMealPlanOptionSuggestions
  digitalDisplays
  selfServiceOnboarding
  messaging
  eatingDisorderScreens
  profilesV3Api
  educationResources
  diningOptionInMenu
  dietitianSupportForms
}
    `;
export const MenuItemFoodCategoryFragmentDoc = gql `
    fragment MenuItemFoodCategory on MenuItemFoodCategory {
  category
}
    `;
export const FoodOrRecipePreferencesFragmentDoc = gql `
    fragment FoodOrRecipePreferences on FoodOrRecipe {
  ... on Food {
    __typename
    id
    name
  }
  ... on Recipe {
    __typename
    id
    name
    descendantFoods {
      id
    }
  }
}
    `;
export const ScoringSystemAssignmentFragmentDoc = gql `
    fragment ScoringSystemAssignment on ScoringSystem {
  name
  id
}
    `;
export const ScoreAssignmentFragmentDoc = gql `
    fragment ScoreAssignment on Score {
  value
  scoringSystem {
    ...ScoringSystemAssignment
  }
}
    ${ScoringSystemAssignmentFragmentDoc}`;
export const FoodCategoryNameFragmentDoc = gql `
    fragment FoodCategoryName on MenuItemFoodCategory {
  category
}
    `;
export const MenuItemPreviewFragmentDoc = gql `
    fragment MenuItemPreview on MenuItem {
  id
  __typename
  name
  servingName
  description
  imageUrl
  isOneOff
  defaultAvailableForOrder
  defaultAllowSpecialRequests
  defaultMaxAmount
  isDeleted
  servingAmounts {
    id
    serving {
      id
      foodOrRecipe {
        ...FoodOrRecipePreferences
      }
    }
  }
  score {
    ...ScoreAssignment
  }
  foodCategory {
    ...FoodCategoryName
  }
}
    ${FoodOrRecipePreferencesFragmentDoc}
${ScoreAssignmentFragmentDoc}
${FoodCategoryNameFragmentDoc}`;
export const MenuItemAppearancePreviewFragmentDoc = gql `
    fragment MenuItemAppearancePreview on MenuItemAppearance {
  id
  position
  maxAmount
  availableForOrder
  allowSpecialRequests
  menuItem {
    ...MenuItemPreview
  }
}
    ${MenuItemPreviewFragmentDoc}`;
export const MealMenuDiningStationWithItemPreviewsFragmentDoc = gql `
    fragment MealMenuDiningStationWithItemPreviews on MealMenuDiningStation {
  id
  name
  maxAmount
  position
  menuItemAppearances {
    ...MenuItemAppearancePreview
  }
}
    ${MenuItemAppearancePreviewFragmentDoc}`;
export const MenuOrderRateLimitRemainderFragmentDoc = gql `
    fragment MenuOrderRateLimitRemainder on MenuOrderRateLimitRemainder {
  start
  remaining
}
    `;
export const FoodLimitedAccessFragmentDoc = gql `
    fragment FoodLimitedAccess on Food {
  id
  __typename
  name
  usdaFdcDescription
  exchangeTypes
  thumbnailUrl
  hasFullAccess
  nixItemId
  nixTagId
  org {
    id
    name
  }
  ... on BrandedFood {
    brand {
      id
      name
    }
  }
}
    `;
export const ImageFragmentDoc = gql `
    fragment Image on Image {
  id
  position
  url
}
    `;
export const RecipeIngredientServingFragmentDoc = gql `
    fragment RecipeIngredientServing on Serving {
  id
  __typename
  defaultAmount
  isDefault
  weight
  perRecipeYield
  hasOwnNutrients
  macros {
    cho
    pro
    fat
    kcal
  }
  units
  unit {
    id
    name
  }
  foodOrRecipe {
    ... on Food {
      ...FoodLimitedAccess
    }
    ... on Recipe {
      __typename
      id
      name
      exchangeTypes
      isCurrent
      images {
        ...Image
      }
      descendantFoods {
        id
      }
      createdBy {
        id
        firstName
        lastName
      }
      hasFullAccess
      org {
        id
        name
      }
      score {
        ...ScoreAssignment
      }
    }
  }
}
    ${FoodLimitedAccessFragmentDoc}
${ImageFragmentDoc}
${ScoreAssignmentFragmentDoc}`;
export const RecipeIngredientServingAmountFragmentDoc = gql `
    fragment RecipeIngredientServingAmount on ServingAmount {
  id
  amount
  position
  serving {
    ...RecipeIngredientServing
  }
}
    ${RecipeIngredientServingFragmentDoc}`;
export const RecipeLimitedAccessFragmentDoc = gql `
    fragment RecipeLimitedAccess on Recipe {
  id
  __typename
  name
  exchangeTypes
  isCurrent
  images {
    ...Image
  }
  history {
    fromCompass
  }
  descendantFoods {
    id
    name
    nixItemId
    nixTagId
  }
  createdBy {
    id
    firstName
    lastName
  }
  hasFullAccess
  org {
    id
    name
  }
  score {
    ...ScoreAssignment
  }
  ingredients {
    ...RecipeIngredientServingAmount
  }
}
    ${ImageFragmentDoc}
${ScoreAssignmentFragmentDoc}
${RecipeIngredientServingAmountFragmentDoc}`;
export const FullServingFragmentDoc = gql `
    fragment FullServing on Serving {
  id
  __typename
  units
  defaultAmount
  isDefault
  weight
  perRecipeYield
  hasOwnNutrients
  macros {
    cho
    pro
    fat
    kcal
  }
  unit {
    id
    name
  }
  foodOrRecipe {
    ... on Food {
      ...FoodLimitedAccess
    }
    ... on Recipe {
      ...RecipeLimitedAccess
    }
  }
}
    ${FoodLimitedAccessFragmentDoc}
${RecipeLimitedAccessFragmentDoc}`;
export const FullServingAmountFragmentDoc = gql `
    fragment FullServingAmount on ServingAmount {
  id
  __typename
  amount
  position
  serving {
    ...FullServing
  }
}
    ${FullServingFragmentDoc}`;
export const MenuItemChoiceOptionFormFragmentDoc = gql `
    fragment MenuItemChoiceOptionForm on MenuItemChoiceOption {
  id
  name
  position
  canEditAmount
  defaultAmount
  maxAmount
  servingAmounts {
    ...FullServingAmount
  }
}
    ${FullServingAmountFragmentDoc}`;
export const MenuItemChoiceFormFragmentDoc = gql `
    fragment MenuItemChoiceForm on MenuItemChoice {
  id
  name
  position
  required
  maxOptionsCount
  options {
    ...MenuItemChoiceOptionForm
  }
}
    ${MenuItemChoiceOptionFormFragmentDoc}`;
export const MenuItemFormFragmentDoc = gql `
    fragment MenuItemForm on MenuItem {
  id
  history {
    fromCompass
  }
  __typename
  name
  servingName
  description
  isOneOff
  servingAmounts {
    ...FullServingAmount
  }
  choices {
    ...MenuItemChoiceForm
  }
  imageUrl
  suggestionCategory
  defaultMaxAmount
  defaultAvailableForOrder
  defaultAllowSpecialRequests
  isDeleted
  score {
    ...ScoreAssignment
  }
  foodCategory {
    ...FoodCategoryName
  }
}
    ${FullServingAmountFragmentDoc}
${MenuItemChoiceFormFragmentDoc}
${ScoreAssignmentFragmentDoc}
${FoodCategoryNameFragmentDoc}`;
export const MenuSelectionItemOptionFormFragmentDoc = gql `
    fragment MenuSelectionItemOptionForm on MenuSelectionItemOption {
  amount
  percentConsumed
  menuItemChoiceOption {
    ...MenuItemChoiceOptionForm
  }
}
    ${MenuItemChoiceOptionFormFragmentDoc}`;
export const MenuSelectionItemFormFragmentDoc = gql `
    fragment MenuSelectionItemForm on MenuSelectionItem {
  amount
  percentConsumed
  menuItem {
    ...MenuItemForm
  }
  options {
    ...MenuSelectionItemOptionForm
  }
}
    ${MenuItemFormFragmentDoc}
${MenuSelectionItemOptionFormFragmentDoc}`;
export const MealMenuLogItemFormFragmentDoc = gql `
    fragment MealMenuLogItemForm on MealMenuLogItem {
  id
  ...MenuSelectionItemForm
}
    ${MenuSelectionItemFormFragmentDoc}`;
export const ExchangeFragmentDoc = gql `
    fragment Exchange on Exchange {
  id
  __typename
  name
  shortName
  type
  cho
  pro
  fat
  kcal
}
    `;
export const ExchangeAmountFragmentDoc = gql `
    fragment ExchangeAmount on ExchangeAmount {
  id
  __typename
  amount
  pickListServingIds
  exchange {
    ...Exchange
  }
}
    ${ExchangeFragmentDoc}`;
export const MealTemplateForTargetsFragmentDoc = gql `
    fragment MealTemplateForTargets on MealTemplate {
  id
  ... on MacroMealTemplate {
    __typename
    cho
    pro
    fat
  }
  ... on ExchangeMealTemplate {
    __typename
    exchangeTargets {
      ...ExchangeAmount
    }
  }
}
    ${ExchangeAmountFragmentDoc}`;
export const ViewMealOptionFragmentDoc = gql `
    fragment ViewMealOption on MealOption {
  id
  __typename
  note
  position
  servingAmounts {
    ...FullServingAmount
  }
}
    ${FullServingAmountFragmentDoc}`;
export const MealFragmentDoc = gql `
    fragment Meal on Meal {
  id
  __typename
  name
  start
  end
  type
}
    `;
export const ExchangeMealTemplateViewFragmentDoc = gql `
    fragment ExchangeMealTemplateView on ExchangeMealTemplate {
  id
  __typename
  mealOptions {
    ...ViewMealOption
  }
  exchangeTargets {
    ...ExchangeAmount
  }
  meal {
    ...Meal
  }
}
    ${ViewMealOptionFragmentDoc}
${ExchangeAmountFragmentDoc}
${MealFragmentDoc}`;
export const MacroMealTemplateViewFragmentDoc = gql `
    fragment MacroMealTemplateView on MacroMealTemplate {
  id
  __typename
  mealOptions {
    ...ViewMealOption
  }
  meal {
    ...Meal
  }
  cho
  pro
  fat
  kcal
}
    ${ViewMealOptionFragmentDoc}
${MealFragmentDoc}`;
export const MenuItemWithIdsFragmentDoc = gql `
    fragment MenuItemWithIds on MenuItem {
  id
  choices {
    id
    options {
      id
    }
  }
}
    `;
export const MenuSelectionItemOptionWithIdsFragmentDoc = gql `
    fragment MenuSelectionItemOptionWithIds on MenuSelectionItemOption {
  amount
  menuItemChoiceOption {
    id
  }
  percentConsumed
}
    `;
export const RatingFragmentDoc = gql `
    fragment Rating on MenuItemRating {
  id
  review
  value
}
    `;
export const MenuOrderItemFormFragmentDoc = gql `
    fragment MenuOrderItemForm on MenuOrderItem {
  id
  forOrder
  status
  specialRequests
  rating {
    ...Rating
  }
  ...MenuSelectionItemForm
}
    ${RatingFragmentDoc}
${MenuSelectionItemFormFragmentDoc}`;
export const MenuSelectionFormFragmentDoc = gql `
    fragment MenuSelectionForm on MenuSelection {
  items {
    ...MenuSelectionItemForm
  }
}
    ${MenuSelectionItemFormFragmentDoc}`;
export const MenuSelectItemOptionWithMacrosFragmentDoc = gql `
    fragment MenuSelectItemOptionWithMacros on MenuSelectionItemOption {
  amount
  percentConsumed
  menuItemChoiceOption {
    id
    servingAmounts {
      ...FullServingAmount
    }
  }
}
    ${FullServingAmountFragmentDoc}`;
export const MenuSelectionItemWithMacrosFragmentDoc = gql `
    fragment MenuSelectionItemWithMacros on MenuSelectionItem {
  amount
  percentConsumed
  menuItem {
    id
    servingAmounts {
      ...FullServingAmount
    }
  }
  options {
    ...MenuSelectItemOptionWithMacros
  }
}
    ${FullServingAmountFragmentDoc}
${MenuSelectItemOptionWithMacrosFragmentDoc}`;
export const MenuOrderSuggestionFragmentDoc = gql `
    fragment MenuOrderSuggestion on MenuOrderSuggestion {
  items {
    amount
    percentConsumed
    menuItem {
      ...MenuItemForm
    }
    options {
      amount
      percentConsumed
      menuItemChoiceOption {
        ...MenuItemChoiceOptionForm
      }
    }
  }
}
    ${MenuItemFormFragmentDoc}
${MenuItemChoiceOptionFormFragmentDoc}`;
export const NutrientAmountFragmentDoc = gql `
    fragment NutrientAmount on NutrientAmount {
  amount
  nutrient {
    id
    name
  }
}
    `;
export const ServingWithNutrientAmountsFragmentDoc = gql `
    fragment ServingWithNutrientAmounts on Serving {
  id
  nutrientAmounts {
    ...NutrientAmount
  }
  foodOrRecipe {
    ... on Food {
      id
      name
    }
    ... on Recipe {
      id
      name
    }
  }
}
    ${NutrientAmountFragmentDoc}`;
export const NutrientWithDriFragmentDoc = gql `
    fragment NutrientWithDri on Nutrient {
  id
  name
  unitName
  defaultDietaryReferenceIntake(age: $age, sex: $sex) {
    id
    type
    amount(kcal: $kcal)
  }
}
    `;
export const RestaurantMenuWithItemPreviewsFragmentDoc = gql `
    fragment RestaurantMenuWithItemPreviews on RestaurantMenu {
  id
  sections {
    id
    name
    position
    menuItemAppearances {
      ...MenuItemAppearancePreview
    }
  }
}
    ${MenuItemAppearancePreviewFragmentDoc}`;
export const RestaurantMenuLinkOrderItemFormFragmentDoc = gql `
    fragment RestaurantMenuLinkOrderItemForm on RestaurantMenuLinkOrderItem {
  id
  specialRequests
  ...MenuSelectionItemForm
}
    ${MenuSelectionItemFormFragmentDoc}`;
export const RestaurantMenuLinkOrderFragmentDoc = gql `
    fragment RestaurantMenuLinkOrder on RestaurantMenuLinkOrder {
  id
  items {
    ...RestaurantMenuLinkOrderItemForm
  }
}
    ${RestaurantMenuLinkOrderItemFormFragmentDoc}`;
export const RestaurantMenuLinkPlateOrderItemOptionFormFragmentDoc = gql `
    fragment RestaurantMenuLinkPlateOrderItemOptionForm on RestaurantMenuLinkPlateOrderItemOption {
  amount
  percentConsumed
  menuItemChoiceOption {
    ...MenuItemChoiceOptionForm
  }
}
    ${MenuItemChoiceOptionFormFragmentDoc}`;
export const RestaurantMenuLinkPlateOrderItemFormFragmentDoc = gql `
    fragment RestaurantMenuLinkPlateOrderItemForm on RestaurantMenuLinkPlateOrderItem {
  amount
  percentConsumed
  plateItem {
    id
  }
  menuItem {
    ...MenuItemForm
  }
  options {
    ...RestaurantMenuLinkPlateOrderItemOptionForm
  }
}
    ${MenuItemFormFragmentDoc}
${RestaurantMenuLinkPlateOrderItemOptionFormFragmentDoc}`;
export const RestaurantMenuLinkPlateItemFormFragmentDoc = gql `
    fragment RestaurantMenuLinkPlateItemForm on RestaurantMenuLinkPlateItem {
  id
  position
  specialRequests
  ...MenuSelectionItemForm
}
    ${MenuSelectionItemFormFragmentDoc}`;
export const RestaurantMenuLinkPlateOrderFragmentDoc = gql `
    fragment RestaurantMenuLinkPlateOrder on RestaurantMenuLinkPlateOrder {
  id
  userFullName
  items {
    ...RestaurantMenuLinkPlateOrderItemForm
  }
  plate {
    id
    items {
      ...RestaurantMenuLinkPlateItemForm
    }
    position
  }
  restaurantMenuLink {
    id
  }
}
    ${RestaurantMenuLinkPlateOrderItemFormFragmentDoc}
${RestaurantMenuLinkPlateItemFormFragmentDoc}`;
export const RestaurantMenuLinkWithMyOrdersFragmentDoc = gql `
    fragment RestaurantMenuLinkWithMyOrders on RestaurantMenuLink {
  id
  allowCustomOrders
  allowPlateOrders
  restaurant {
    id
    name
  }
  order: myOrder {
    ...RestaurantMenuLinkOrder
  }
  plateOrder: myPlateOrder {
    ...RestaurantMenuLinkPlateOrder
  }
}
    ${RestaurantMenuLinkOrderFragmentDoc}
${RestaurantMenuLinkPlateOrderFragmentDoc}`;
export const RestaurantMenuLinkWithOrdersForAthleteFragmentDoc = gql `
    fragment RestaurantMenuLinkWithOrdersForAthlete on RestaurantMenuLink {
  id
  allowCustomOrders
  allowPlateOrders
  restaurant {
    id
    name
  }
  order: orderForAthlete(athleteId: $athleteId) {
    ...RestaurantMenuLinkOrder
  }
  plateOrder: plateOrderForAthlete(athleteId: $athleteId) {
    ...RestaurantMenuLinkPlateOrder
  }
}
    ${RestaurantMenuLinkOrderFragmentDoc}
${RestaurantMenuLinkPlateOrderFragmentDoc}`;
export const RestaurantMenuLinkPlateFragmentDoc = gql `
    fragment RestaurantMenuLinkPlate on RestaurantMenuLinkPlate {
  id
  items {
    ...RestaurantMenuLinkPlateItemForm
  }
  position
}
    ${RestaurantMenuLinkPlateItemFormFragmentDoc}`;
export const RestaurantMenuLinkWithItemPreviewsFragmentDoc = gql `
    fragment RestaurantMenuLinkWithItemPreviews on RestaurantMenuLink {
  id
  allowCustomOrders
  allowPlateOrders
  restaurant {
    id
    name
  }
  sections {
    restaurantMenuSection {
      id
      name
      position
    }
    maxAmount
    menuItemAppearances {
      ...MenuItemAppearancePreview
    }
  }
  plates {
    ...RestaurantMenuLinkPlate
  }
}
    ${MenuItemAppearancePreviewFragmentDoc}
${RestaurantMenuLinkPlateFragmentDoc}`;
export const RestaurantMenuLogItemFormFragmentDoc = gql `
    fragment RestaurantMenuLogItemForm on RestaurantMenuLogItem {
  id
  ...MenuSelectionItemForm
}
    ${MenuSelectionItemFormFragmentDoc}`;
export const RestaurantMenuLogFragmentDoc = gql `
    fragment RestaurantMenuLog on RestaurantMenuLog {
  id
  mealTemplate {
    id
  }
  items {
    ...RestaurantMenuLogItemForm
  }
  restaurantMenu {
    id
  }
  dateTime
  timezone
  type
}
    ${RestaurantMenuLogItemFormFragmentDoc}`;
export const ScoringSystemFragmentDoc = gql `
    fragment ScoringSystem on ScoringSystem {
  id
  name
}
    `;
export const ServingWithFoodOrRecipeMacrosFragmentDoc = gql `
    fragment ServingWithFoodOrRecipeMacros on Serving {
  id
  __typename
  macros {
    cho
    pro
    fat
    kcal
  }
  foodOrRecipe {
    __typename
    ... on Food {
      id
      name
      usdaFdcDescription
    }
    ... on Recipe {
      id
      name
      createdBy {
        firstName
        lastName
      }
    }
  }
}
    `;
export const TimelineItemForGroupByDateFragmentDoc = gql `
    fragment TimelineItemForGroupByDate on TimelineItem {
  ... on MealPlanDate {
    date
    timezone
    __typename
  }
  ... on FoodLogMeal {
    id
    __typename
  }
  ... on FoodLogActivity {
    id
    __typename
    date
    startTime
    timezone
  }
  ... on MenuOrder {
    id
    __typename
  }
  ... on MealMenu {
    id
    __typename
  }
  ... on RestaurantMenuLog {
    id
    __typename
  }
}
    `;
export const NotificationTimelineFragmentDoc = gql `
    fragment NotificationTimeline on Notification {
  id
  __typename
  viewedAt
}
    `;
export const TimelineMealForGroupByDateFragmentDoc = gql `
    fragment TimelineMealForGroupByDate on TimelineMeal {
  id
  start
  timezone
  notifications {
    ...NotificationTimeline
  }
}
    ${NotificationTimelineFragmentDoc}`;
export const MealTemplateSharedTimelineFragmentDoc = gql `
    fragment MealTemplateSharedTimeline on MealTemplate {
  id
  meal {
    id
    name
    start
    end
    type
  }
  ... on MacroMealTemplate {
    __typename
  }
  ... on ExchangeMealTemplate {
    __typename
  }
}
    `;
export const ActivityTemplateSharedTimelineFragmentDoc = gql `
    fragment ActivityTemplateSharedTimeline on ActivityTemplate {
  id
  __typename
  activity {
    id
    name
    start
    end
    type
  }
}
    `;
export const MealPlanSharedTimelineFragmentDoc = gql `
    fragment MealPlanSharedTimeline on MealPlan {
  id
  mealTemplates {
    ...MealTemplateSharedTimeline
  }
  activityTemplates {
    ...ActivityTemplateSharedTimeline
  }
}
    ${MealTemplateSharedTimelineFragmentDoc}
${ActivityTemplateSharedTimelineFragmentDoc}`;
export const MealPlanDateSharedTimelineFragmentDoc = gql `
    fragment MealPlanDateSharedTimeline on MealPlanDate {
  __typename
  date
  timezone
  mealPlan {
    ...MealPlanSharedTimeline
  }
}
    ${MealPlanSharedTimelineFragmentDoc}`;
export const MealMenuSharedTimelineFragmentDoc = gql `
    fragment MealMenuSharedTimeline on MealMenu {
  id
  __typename
  mealType: type
  timezone
  name
  start
  durationInMinutes
  prepTimeInMinutes
  lastOrderTimeBeforeEndInMinutes
  isLogOnly
  isInHouseMenuOrderable
  isRestaurantMenuOrderable
  isViewOnlyForMe
  isDiningOptionEnabled
  isBulkOrderable
  restaurantMenuLinks {
    id
    allowCustomOrders
    allowPlateOrders
    restaurant {
      id
      name
    }
  }
}
    `;
export const RestaurantMenuLogSharedTimelineFragmentDoc = gql `
    fragment RestaurantMenuLogSharedTimeline on RestaurantMenuLog {
  id
  __typename
  mealType: type
  dateTime
  timezone
  items {
    id
    ...MenuSelectionItemForm
  }
}
    ${MenuSelectionItemFormFragmentDoc}`;
export const MealMenuWithTimesFragmentDoc = gql `
    fragment MealMenuWithTimes on MealMenu {
  id
  timezone
  name
  start
  durationInMinutes
  prepTimeInMinutes
  lastOrderTimeBeforeEndInMinutes
  isViewOnlyForMe
  theme
  isDiningOptionEnabled
}
    `;
export const RestaurantMenuLinkPlateOrderSharedTimelineFragmentDoc = gql `
    fragment RestaurantMenuLinkPlateOrderSharedTimeline on RestaurantMenuLinkPlateOrder {
  ...RestaurantMenuLinkPlateOrder
  mealMenu {
    ...MealMenuWithTimes
  }
  restaurantMenuLink {
    id
    restaurant {
      id
      name
    }
  }
}
    ${RestaurantMenuLinkPlateOrderFragmentDoc}
${MealMenuWithTimesFragmentDoc}`;
export const RestaurantMenuLinkOrderSharedTimelineFragmentDoc = gql `
    fragment RestaurantMenuLinkOrderSharedTimeline on RestaurantMenuLinkOrder {
  ...RestaurantMenuLinkOrder
  mealMenu {
    id
  }
  restaurantMenuLink {
    id
    restaurant {
      id
      name
    }
  }
}
    ${RestaurantMenuLinkOrderFragmentDoc}`;
export const MenuOrderSharedTimelineFragmentDoc = gql `
    fragment MenuOrderSharedTimeline on MenuOrder {
  id
  __typename
  mealMenu {
    id
  }
}
    `;
export const MealMenuLogSharedTimelineFragmentDoc = gql `
    fragment MealMenuLogSharedTimeline on MealMenuLog {
  id
  __typename
  mealMenu {
    id
  }
}
    `;
export const TimelineMealSharedTimelineFragmentDoc = gql `
    fragment TimelineMealSharedTimeline on TimelineMeal {
  id
  __typename
  name
  type
  timezone
  start
  durationInMinutes
  mealTemplate {
    id
  }
  mealMenus {
    ...MealMenuSharedTimeline
  }
  servingAmounts {
    ...FullServingAmount
  }
  restaurantMenuLogs {
    ...RestaurantMenuLogSharedTimeline
  }
  restaurantMenuLinkPlateOrders {
    ...RestaurantMenuLinkPlateOrderSharedTimeline
  }
  restaurantMenuLinkOrders {
    ...RestaurantMenuLinkOrderSharedTimeline
  }
  menuOrders {
    ...MenuOrderSharedTimeline
  }
  mealMenuLogs {
    ...MealMenuLogSharedTimeline
  }
}
    ${MealMenuSharedTimelineFragmentDoc}
${FullServingAmountFragmentDoc}
${RestaurantMenuLogSharedTimelineFragmentDoc}
${RestaurantMenuLinkPlateOrderSharedTimelineFragmentDoc}
${RestaurantMenuLinkOrderSharedTimelineFragmentDoc}
${MenuOrderSharedTimelineFragmentDoc}
${MealMenuLogSharedTimelineFragmentDoc}`;
export const FoodLogActivitySharedTimelineFragmentDoc = gql `
    fragment FoodLogActivitySharedTimeline on FoodLogActivity {
  id
  __typename
  name
  activityType: type
  startTime
  endTime
  timezone
  activityTemplate {
    id
  }
}
    `;
export const UnitFragmentDoc = gql `
    fragment Unit on Unit {
  id
  name
}
    `;
export const UnitWithConversionsFragmentDoc = gql `
    fragment UnitWithConversions on Unit {
  id
  name
  conversionsFrom {
    id
    fromQuantity
    toQuantity
    toUnit {
      ...Unit
      isProductionOnly
    }
  }
}
    ${UnitFragmentDoc}`;
export const AthleteFragmentDoc = gql `
    fragment Athlete on Athlete {
  id
  __typename
  firstName
  lastName
  sex
  birthDate
  phoneNumber
  email
  headshotUrl
  secaUid
  inbodyUid
  isArchived
  activationLinkSent
  jerseyNumber
  isProfileNotemealOnly
}
    `;
export const MealPlanFragmentDoc = gql `
    fragment MealPlan on MealPlan {
  id
  __typename
  name
  isShared
  isAutoSuggestionsEnabled
  description
  usesDateRange
  dates
  startDate
  endDate
  type
  createdAt
  updatedAt
  exchangeSet {
    id
  }
}
    `;
export const MacroMathFragmentDoc = gql `
    fragment MacroMath on MacroMath {
  gPerKg
  leftOverRatio
}
    `;
export const MacroProtocolFragmentDoc = gql `
    fragment MacroProtocol on MacroProtocol {
  id
  __typename
  cho {
    ...MacroMath
  }
  pro {
    ...MacroMath
  }
  fat {
    ...MacroMath
  }
  weightTarget
  weightTargetInKg
}
    ${MacroMathFragmentDoc}`;
export const AnthropometryEntryFragmentDoc = gql `
    fragment AnthropometryEntry on AnthropometryEntry {
  id
  __typename
  height
  weight
  leanBodyMass
  bodyFatMass
  percentBodyFat
  datetime
  type
  sex
  comment
  boneMineralDensity
  boneMineralDensityZScore
  boneMineralDensityTScore
  boneMineralContent
  boneArea
  boneMass
  dryLeanMass
  skeletalMuscleMass
  trunkFat
  visceralFatArea
  heightInCm
  weightInKg
  leanBodyMassInKg
  bodyFatMassInKg
  skeletalMuscleMassInKg
  trunkFatInKg
  dryLeanMassInKg
}
    `;
export const CalorieBudgetFragmentDoc = gql `
    fragment CalorieBudget on CalorieBudget {
  id
  __typename
  rmrMethod
  rmrCalories
  activityFactor
  kcalOffset
}
    `;
export const GoalFragmentDoc = gql `
    fragment Goal on Goal {
  id
  __typename
  kcalOffset
  start
  end
}
    `;
export const GoalTypeFragmentDoc = gql `
    fragment GoalType on GoalType {
  id
  __typename
  name
  defaultKcalOffset
}
    `;
export const FullGoalFragmentDoc = gql `
    fragment FullGoal on Goal {
  ...Goal
  type {
    ...GoalType
  }
}
    ${GoalFragmentDoc}
${GoalTypeFragmentDoc}`;
export const FullCalorieBudgetFragmentDoc = gql `
    fragment FullCalorieBudget on CalorieBudget {
  ...CalorieBudget
  goalSnapshot {
    ...FullGoal
  }
}
    ${CalorieBudgetFragmentDoc}
${FullGoalFragmentDoc}`;
export const FullMacroProtocolFragmentDoc = gql `
    fragment FullMacroProtocol on MacroProtocol {
  ...MacroProtocol
  anthropometrySnapshot {
    ...AnthropometryEntry
  }
  calorieBudget {
    ...FullCalorieBudget
  }
}
    ${MacroProtocolFragmentDoc}
${AnthropometryEntryFragmentDoc}
${FullCalorieBudgetFragmentDoc}`;
export const MealPlanSearchFormFragmentDoc = gql `
    fragment MealPlanSearchForm on MealPlan {
  ...MealPlan
  macroProtocol {
    ...FullMacroProtocol
  }
}
    ${MealPlanFragmentDoc}
${FullMacroProtocolFragmentDoc}`;
export const AthleteWithMealPlansFragmentDoc = gql `
    fragment AthleteWithMealPlans on Athlete {
  ...Athlete
  mealPlans {
    ...MealPlanSearchForm
  }
}
    ${AthleteFragmentDoc}
${MealPlanSearchFormFragmentDoc}`;
export const PositionFragmentDoc = gql `
    fragment Position on Position {
  id
  __typename
  name
}
    `;
export const AthleteWithGoalAndAnthroFragmentDoc = gql `
    fragment AthleteWithGoalAndAnthro on Athlete {
  ...Athlete
  position {
    ...Position
  }
  mostRecentAnthropometryEntry {
    ...AnthropometryEntry
  }
  currentGoal {
    ...FullGoal
  }
}
    ${AthleteFragmentDoc}
${PositionFragmentDoc}
${AnthropometryEntryFragmentDoc}
${FullGoalFragmentDoc}`;
export const ExchangeRatioFragmentDoc = gql `
    fragment ExchangeRatio on ExchangeRatio {
  __typename
  ratio
  exchange {
    ...Exchange
  }
}
    ${ExchangeFragmentDoc}`;
export const FoodOrRecipeExchangeRatiosFragmentDoc = gql `
    fragment FoodOrRecipeExchangeRatios on FoodOrRecipeExchangeRatios {
  id
  __typename
  foodOrRecipeId
  exchangeRatios {
    ...ExchangeRatio
  }
}
    ${ExchangeRatioFragmentDoc}`;
export const FoodPreviewFragmentDoc = gql `
    fragment FoodPreview on Food {
  id
  name
}
    `;
export const BrandedFoodFragmentDoc = gql `
    fragment BrandedFood on BrandedFood {
  id
  __typename
  name
  exchangeTypes
  usdaFdcDescription
  usdaFdcFoodCategoryId
  usdaFdcDataType
  usdaFdcId
  isRecipeIngredientOnly
  nixItemId
  nixTagId
  choPer100g
  proPer100g
  fatPer100g
  kcalPer100g
  thumbnailUrl
  groceryListCategory {
    id
    name
  }
}
    `;
export const GenericFoodFragmentDoc = gql `
    fragment GenericFood on GenericFood {
  id
  __typename
  name
  exchangeTypes
  nixItemId
  nixTagId
  usdaFdcDescription
  usdaFdcFoodCategoryId
  usdaFdcDataType
  usdaFdcId
  isRecipeIngredientOnly
  choPer100g
  proPer100g
  fatPer100g
  kcalPer100g
  thumbnailUrl
  groceryListCategory {
    id
    name
  }
  owner {
    id
    firstName
    lastName
  }
  orgGroup {
    id
    name
  }
}
    `;
export const FoodFragmentDoc = gql `
    fragment Food on Food {
  id
  __typename
  name
  exchangeTypes
  nixItemId
  nixTagId
  usdaFdcDescription
  usdaFdcFoodCategoryId
  usdaFdcDataType
  usdaFdcId
  isRecipeIngredientOnly
  choPer100g
  proPer100g
  fatPer100g
  kcalPer100g
  thumbnailUrl
  locales
}
    `;
export const BrandFragmentDoc = gql `
    fragment Brand on Brand {
  id
  __typename
  name
  usdaManufacturerName
  foodCount
}
    `;
export const FoodWithDefaultServingFragmentDoc = gql `
    fragment FoodWithDefaultServing on Food {
  ...Food
  defaultServing {
    ...FullServing
  }
  hasFullAccess
  org {
    id
    name
  }
  ... on BrandedFood {
    __typename
    brand {
      ...Brand
    }
  }
  ... on GenericFood {
    __typename
    orgGroup {
      id
      name
    }
  }
}
    ${FoodFragmentDoc}
${FullServingFragmentDoc}
${BrandFragmentDoc}`;
export const ServingFragmentDoc = gql `
    fragment Serving on Serving {
  id
  __typename
  units
  defaultAmount
  isDefault
  weight
  usdaWeightSeq
  perRecipeYield
  isRecipeServingOnly
  hasOwnNutrients
}
    `;
export const ServingWithFoodOrRecipeFragmentDoc = gql `
    fragment ServingWithFoodOrRecipe on Serving {
  ...Serving
  macros {
    cho
    pro
    fat
    kcal
  }
  customUnits
  unitPrefix
  unitSuffix
  unit {
    id
    name
  }
  foodOrRecipe {
    ... on Food {
      ...Food
      hasFullAccess
      org {
        id
        name
      }
      ... on BrandedFood {
        brand {
          id
          name
        }
      }
    }
    ... on Recipe {
      ...RecipeLimitedAccess
    }
  }
}
    ${ServingFragmentDoc}
${FoodFragmentDoc}
${RecipeLimitedAccessFragmentDoc}`;
export const FoodWithServingsFragmentDoc = gql `
    fragment FoodWithServings on Food {
  ...Food
  showGramServing
  showOunceServing
  servings {
    ...ServingWithFoodOrRecipe
  }
}
    ${FoodFragmentDoc}
${ServingWithFoodOrRecipeFragmentDoc}`;
export const FullFoodGroupFragmentDoc = gql `
    fragment FullFoodGroup on FoodGroup {
  id
  __typename
  name
  source
  foodsCount
}
    `;
export const FoodLogNotificationSettingsFragmentDoc = gql `
    fragment FoodLogNotificationSettings on FoodLogNotificationSettings {
  edits
  imageUploads
  messages
}
    `;
export const ExchangeSetFragmentDoc = gql `
    fragment ExchangeSet on ExchangeSet {
  id
  __typename
  name
  createdBy {
    id
    firstName
    lastName
  }
}
    `;
export const ExchangeSetWithExchangesFragmentDoc = gql `
    fragment ExchangeSetWithExchanges on ExchangeSet {
  ...ExchangeSet
  exchanges {
    ...Exchange
  }
}
    ${ExchangeSetFragmentDoc}
${ExchangeFragmentDoc}`;
export const BasicMealPlanFragmentDoc = gql `
    fragment BasicMealPlan on MealPlan {
  ...MealPlan
  exchangeSet {
    ...ExchangeSetWithExchanges
  }
}
    ${MealPlanFragmentDoc}
${ExchangeSetWithExchangesFragmentDoc}`;
export const CopyableMealPlanFragmentDoc = gql `
    fragment CopyableMealPlan on MealPlan {
  ...BasicMealPlan
  macroProtocol {
    ...MacroProtocol
    calorieBudget {
      ...CalorieBudget
    }
  }
}
    ${BasicMealPlanFragmentDoc}
${MacroProtocolFragmentDoc}
${CalorieBudgetFragmentDoc}`;
export const ScheduleFragmentDoc = gql `
    fragment Schedule on Schedule {
  id
  __typename
  name
  activityFactor
}
    `;
export const FullFoodGroupWithFoodsFragmentDoc = gql `
    fragment FullFoodGroupWithFoods on FoodGroup {
  id
  __typename
  name
  source
  foodsCount
  foods {
    ...FoodLimitedAccess
  }
}
    ${FoodLimitedAccessFragmentDoc}`;
export const EventFragmentDoc = gql `
    fragment Event on Event {
  __typename
  type
  datetime
}
    `;
export const EditExchangeAmountFragmentDoc = gql `
    fragment EditExchangeAmount on ExchangeAmount {
  ...ExchangeAmount
  amountInput @client
}
    ${ExchangeAmountFragmentDoc}`;
export const PreviewMealPlanFragmentDoc = gql `
    fragment PreviewMealPlan on MealPlan {
  ...BasicMealPlan
  macroProtocol {
    ...FullMacroProtocol
  }
  schedule {
    ...Schedule
  }
  avoidedFoodGroups {
    ...FullFoodGroupWithFoods
  }
  promotedFoodGroups {
    ...FullFoodGroupWithFoods
  }
  avoidedFoods {
    ...FoodLimitedAccess
  }
  promotedFoods {
    ...FoodLimitedAccess
  }
  mostRecentEvent {
    ...Event
  }
  exchangeTargets {
    ...EditExchangeAmount
  }
}
    ${BasicMealPlanFragmentDoc}
${FullMacroProtocolFragmentDoc}
${ScheduleFragmentDoc}
${FullFoodGroupWithFoodsFragmentDoc}
${FoodLimitedAccessFragmentDoc}
${EventFragmentDoc}
${EditExchangeAmountFragmentDoc}`;
export const EditMealPlanFragmentDoc = gql `
    fragment EditMealPlan on MealPlan {
  id
  isAutosaving @client
  exchangeTargets {
    ...EditExchangeAmount
  }
}
    ${EditExchangeAmountFragmentDoc}`;
export const AthleteWithFoodPrefsFragmentDoc = gql `
    fragment AthleteWithFoodPrefs on Athlete {
  ...Athlete
  likedFoods {
    ...Food
  }
  dislikedFoods {
    ...Food
  }
  likedFoodGroups {
    ...FullFoodGroupWithFoods
  }
  dislikedFoodGroups {
    ...FullFoodGroupWithFoods
  }
}
    ${AthleteFragmentDoc}
${FoodFragmentDoc}
${FullFoodGroupWithFoodsFragmentDoc}`;
export const MacroMealPlanDisplaySettingsFragmentDoc = gql `
    fragment MacroMealPlanDisplaySettings on MacroMealPlanDisplaySettings {
  __typename
  dailyProgressViews
  mealProgressViews
}
    `;
export const ExchangeMealPlanDisplaySettingsFragmentDoc = gql `
    fragment ExchangeMealPlanDisplaySettings on ExchangeMealPlanDisplaySettings {
  __typename
  dailyProgressViewsForExchanges
  mealProgressViewsForExchanges
  dailyProgressViewsForMacros
  mealProgressViewsForMacros
}
    `;
export const ExchangeServingListFragmentDoc = gql `
    fragment ExchangeServingList on ExchangeServingList {
  id
  __typename
  name
}
    `;
export const FullExchangeServingListFragmentDoc = gql `
    fragment FullExchangeServingList on ExchangeServingList {
  ...ExchangeServingList
  servingAmounts {
    ...FullServingAmount
  }
}
    ${ExchangeServingListFragmentDoc}
${FullServingAmountFragmentDoc}`;
export const FullExchangeFragmentDoc = gql `
    fragment FullExchange on Exchange {
  ...Exchange
  exchangeServingList {
    ...FullExchangeServingList
  }
}
    ${ExchangeFragmentDoc}
${FullExchangeServingListFragmentDoc}`;
export const FullExchangeSetWithoutExchangeRatiosFragmentDoc = gql `
    fragment FullExchangeSetWithoutExchangeRatios on ExchangeSet {
  ...ExchangeSet
  exchanges {
    ...FullExchange
  }
}
    ${ExchangeSetFragmentDoc}
${FullExchangeFragmentDoc}`;
export const FullExchangeSetFragmentDoc = gql `
    fragment FullExchangeSet on ExchangeSet {
  ...FullExchangeSetWithoutExchangeRatios
  foodOrRecipeExchangeRatios @client {
    id
    foodOrRecipeId
    __typename
    exchangeRatios {
      __typename
      ratio
      exchange {
        ...Exchange
      }
    }
  }
}
    ${FullExchangeSetWithoutExchangeRatiosFragmentDoc}
${ExchangeFragmentDoc}`;
export const ActivityFragmentDoc = gql `
    fragment Activity on Activity {
  id
  __typename
  name
  start
  end
  type
}
    `;
export const ActivityTemplateFragmentDoc = gql `
    fragment ActivityTemplate on ActivityTemplate {
  id
  __typename
  activity {
    ...Activity
  }
}
    ${ActivityFragmentDoc}`;
export const MealTemplateFragmentDoc = gql `
    fragment MealTemplate on MealTemplate {
  id
  __typename
  meal {
    ...Meal
  }
}
    ${MealFragmentDoc}`;
export const EditMealTemplateFragmentDoc = gql `
    fragment EditMealTemplate on MealTemplate {
  id
  isAutosaving @client
  selectedMealOptionId @client
  newMealOptionIds @client
}
    `;
export const MealOptionFragmentDoc = gql `
    fragment MealOption on MealOption {
  id
  __typename
  note
  position
  name
}
    `;
export const FullMealOptionFragmentDoc = gql `
    fragment FullMealOption on MealOption {
  ...MealOption
  servingAmounts {
    ...FullServingAmount
  }
}
    ${MealOptionFragmentDoc}
${FullServingAmountFragmentDoc}`;
export const EditMealOptionFragmentDoc = gql `
    fragment EditMealOption on MealOption {
  id
  isAutosaving @client
}
    `;
export const EditFullMealOptionFragmentDoc = gql `
    fragment EditFullMealOption on MealOption {
  ...FullMealOption
  ...EditMealOption
}
    ${FullMealOptionFragmentDoc}
${EditMealOptionFragmentDoc}`;
export const MealOptionPendingFragmentDoc = gql `
    fragment MealOptionPending on MealOptionPending {
  id
  __typename
  note
  name
}
    `;
export const FullMealOptionPendingFragmentDoc = gql `
    fragment FullMealOptionPending on MealOptionPending {
  ...MealOptionPending
  servingAmounts {
    ...FullServingAmount
  }
}
    ${MealOptionPendingFragmentDoc}
${FullServingAmountFragmentDoc}`;
export const EditMealOptionPendingFragmentDoc = gql `
    fragment EditMealOptionPending on MealOptionPending {
  id
  isAutosaving @client
}
    `;
export const EditFullMealOptionPendingFragmentDoc = gql `
    fragment EditFullMealOptionPending on MealOptionPending {
  ...FullMealOptionPending
  ...EditMealOptionPending
}
    ${FullMealOptionPendingFragmentDoc}
${EditMealOptionPendingFragmentDoc}`;
export const EditFullMealTemplateFragmentDoc = gql `
    fragment EditFullMealTemplate on MealTemplate {
  ...MealTemplate
  ...EditMealTemplate
  mealOptions {
    ...EditFullMealOption
  }
  pendingMealOptions {
    ...EditFullMealOptionPending
  }
}
    ${MealTemplateFragmentDoc}
${EditMealTemplateFragmentDoc}
${EditFullMealOptionFragmentDoc}
${EditFullMealOptionPendingFragmentDoc}`;
export const MacroMealTemplateFragmentDoc = gql `
    fragment MacroMealTemplate on MacroMealTemplate {
  ...MealTemplate
  __typename
  cho
  pro
  fat
  kcal
}
    ${MealTemplateFragmentDoc}`;
export const EditMacroMealTemplateFragmentDoc = gql `
    fragment EditMacroMealTemplate on MacroMealTemplate {
  ...EditMealTemplate
  choInput @client
  proInput @client
  fatInput @client
}
    ${EditMealTemplateFragmentDoc}`;
export const EditFullMacroMealTemplateFragmentDoc = gql `
    fragment EditFullMacroMealTemplate on MacroMealTemplate {
  ...EditFullMealTemplate
  ...MacroMealTemplate
  ...EditMacroMealTemplate
}
    ${EditFullMealTemplateFragmentDoc}
${MacroMealTemplateFragmentDoc}
${EditMacroMealTemplateFragmentDoc}`;
export const ExchangeMealTemplateFragmentDoc = gql `
    fragment ExchangeMealTemplate on ExchangeMealTemplate {
  ...MealTemplate
  __typename
}
    ${MealTemplateFragmentDoc}`;
export const EditExchangeMealTemplateFragmentDoc = gql `
    fragment EditExchangeMealTemplate on ExchangeMealTemplate {
  ...EditMealTemplate
  exchangeTargets {
    ...EditExchangeAmount
  }
}
    ${EditMealTemplateFragmentDoc}
${EditExchangeAmountFragmentDoc}`;
export const EditFullExchangeMealTemplateFragmentDoc = gql `
    fragment EditFullExchangeMealTemplate on ExchangeMealTemplate {
  ...EditFullMealTemplate
  ...ExchangeMealTemplate
  ...EditExchangeMealTemplate
}
    ${EditFullMealTemplateFragmentDoc}
${ExchangeMealTemplateFragmentDoc}
${EditExchangeMealTemplateFragmentDoc}`;
export const EditFullMealPlanFragmentDoc = gql `
    fragment EditFullMealPlan on MealPlan {
  ...PreviewMealPlan
  ...EditMealPlan
  athlete {
    ...AthleteWithFoodPrefs
    macroDisplaySettings {
      ...MacroMealPlanDisplaySettings
    }
    exchangeDisplaySettings {
      ...ExchangeMealPlanDisplaySettings
    }
  }
  exchangeSet {
    ...FullExchangeSet
  }
  activityTemplates {
    ...ActivityTemplate
  }
  events {
    ...Event
  }
  mealTemplates {
    ... on MacroMealTemplate {
      ...EditFullMacroMealTemplate
    }
    ... on ExchangeMealTemplate {
      ...EditFullExchangeMealTemplate
    }
  }
}
    ${PreviewMealPlanFragmentDoc}
${EditMealPlanFragmentDoc}
${AthleteWithFoodPrefsFragmentDoc}
${MacroMealPlanDisplaySettingsFragmentDoc}
${ExchangeMealPlanDisplaySettingsFragmentDoc}
${FullExchangeSetFragmentDoc}
${ActivityTemplateFragmentDoc}
${EventFragmentDoc}
${EditFullMacroMealTemplateFragmentDoc}
${EditFullExchangeMealTemplateFragmentDoc}`;
export const FullMealTemplateFragmentDoc = gql `
    fragment FullMealTemplate on MealTemplate {
  ...MealTemplate
  mealOptions {
    ...FullMealOption
  }
  pendingMealOptions {
    ...FullMealOptionPending
  }
}
    ${MealTemplateFragmentDoc}
${FullMealOptionFragmentDoc}
${FullMealOptionPendingFragmentDoc}`;
export const FullMacroMealTemplateFragmentDoc = gql `
    fragment FullMacroMealTemplate on MacroMealTemplate {
  ...FullMealTemplate
  ...MacroMealTemplate
}
    ${FullMealTemplateFragmentDoc}
${MacroMealTemplateFragmentDoc}`;
export const FullExchangeMealTemplateFragmentDoc = gql `
    fragment FullExchangeMealTemplate on ExchangeMealTemplate {
  ...FullMealTemplate
  ...ExchangeMealTemplate
  exchangeTargets {
    ...ExchangeAmount
  }
}
    ${FullMealTemplateFragmentDoc}
${ExchangeMealTemplateFragmentDoc}
${ExchangeAmountFragmentDoc}`;
export const FullMealPlanFragmentDoc = gql `
    fragment FullMealPlan on MealPlan {
  ...PreviewMealPlan
  athlete {
    ...AthleteWithFoodPrefs
    macroDisplaySettings {
      ...MacroMealPlanDisplaySettings
    }
    exchangeDisplaySettings {
      ...ExchangeMealPlanDisplaySettings
    }
  }
  exchangeSet {
    ...FullExchangeSet
  }
  activityTemplates {
    ...ActivityTemplate
  }
  events {
    ...Event
  }
  mealTemplates {
    ... on MacroMealTemplate {
      ...FullMacroMealTemplate
    }
    ... on ExchangeMealTemplate {
      ...FullExchangeMealTemplate
    }
  }
}
    ${PreviewMealPlanFragmentDoc}
${AthleteWithFoodPrefsFragmentDoc}
${MacroMealPlanDisplaySettingsFragmentDoc}
${ExchangeMealPlanDisplaySettingsFragmentDoc}
${FullExchangeSetFragmentDoc}
${ActivityTemplateFragmentDoc}
${EventFragmentDoc}
${FullMacroMealTemplateFragmentDoc}
${FullExchangeMealTemplateFragmentDoc}`;
export const ExportMealTemplateFragmentDoc = gql `
    fragment ExportMealTemplate on MealTemplate {
  ...MealTemplate
  mealOptions {
    ...ViewMealOption
  }
}
    ${MealTemplateFragmentDoc}
${ViewMealOptionFragmentDoc}`;
export const NoteFragmentDoc = gql `
    fragment Note on Note {
  id
  __typename
  datetime
  content
}
    `;
export const NoteTypeFragmentDoc = gql `
    fragment NoteType on NoteType {
  id
  __typename
  name
}
    `;
export const NoteWithTypeFragmentDoc = gql `
    fragment NoteWithType on Note {
  ...Note
  type {
    ...NoteType
  }
}
    ${NoteFragmentDoc}
${NoteTypeFragmentDoc}`;
export const FullNoteFragmentDoc = gql `
    fragment FullNote on Note {
  ...NoteWithType
  athlete {
    ...Athlete
  }
}
    ${NoteWithTypeFragmentDoc}
${AthleteFragmentDoc}`;
export const NutrientDietaryReferenceIntakeFragmentDoc = gql `
    fragment NutrientDietaryReferenceIntake on NutrientDietaryReferenceIntake {
  id
  type
}
    `;
export const RecipeFoodCategoryFragmentDoc = gql `
    fragment RecipeFoodCategory on RecipeFoodCategory {
  category
}
    `;
export const RecipeFragmentDoc = gql `
    fragment Recipe on Recipe {
  id
  __typename
  name
  steps
  note
  exchangeTypes
  cho
  pro
  fat
  prepTimeInMinutes
  cookTimeInMinutes
  isCurrent
  images {
    ...Image
  }
  isShared
  createdBy {
    id
    firstName
    lastName
  }
  mealTypes
  score {
    ...ScoreAssignment
  }
  foodCategory {
    ...RecipeFoodCategory
  }
}
    ${ImageFragmentDoc}
${ScoreAssignmentFragmentDoc}
${RecipeFoodCategoryFragmentDoc}`;
export const ServingAmountWithFoodOrRecipeFragmentDoc = gql `
    fragment ServingAmountWithFoodOrRecipe on ServingAmount {
  id
  __typename
  amount
  position
  serving {
    ...ServingWithFoodOrRecipe
  }
}
    ${ServingWithFoodOrRecipeFragmentDoc}`;
export const RecipeWithIngredientsFragmentDoc = gql `
    fragment RecipeWithIngredients on Recipe {
  ...Recipe
  ingredients {
    ...ServingAmountWithFoodOrRecipe
  }
}
    ${RecipeFragmentDoc}
${ServingAmountWithFoodOrRecipeFragmentDoc}`;
export const RecipeWithServingsFragmentDoc = gql `
    fragment RecipeWithServings on Recipe {
  ...RecipeWithIngredients
  hasFullAccess
  descendantRecipes {
    ...RecipeWithIngredients
  }
  servings {
    ...ServingWithFoodOrRecipe
  }
}
    ${RecipeWithIngredientsFragmentDoc}
${ServingWithFoodOrRecipeFragmentDoc}`;
export const FullScheduleFragmentDoc = gql `
    fragment FullSchedule on Schedule {
  ...Schedule
  meals {
    ...Meal
  }
  activities {
    ...Activity
  }
  mealPlans {
    ...MealPlan
  }
}
    ${ScheduleFragmentDoc}
${MealFragmentDoc}
${ActivityFragmentDoc}
${MealPlanFragmentDoc}`;
export const ServingWithMacrosFragmentDoc = gql `
    fragment ServingWithMacros on Serving {
  ...Serving
  macros {
    cho
    pro
    fat
    kcal
  }
}
    ${ServingFragmentDoc}`;
export const ExcessiveServingFragmentDoc = gql `
    fragment ExcessiveServing on Serving {
  ...Serving
  customUnits
  unitPrefix
  unitSuffix
  unit {
    id
    name
  }
  macros {
    cho
    pro
    fat
    kcal
  }
  foodOrRecipe {
    ... on Food {
      ...Food
      ... on BrandedFood {
        brand {
          id
          name
        }
      }
    }
    ... on Recipe {
      ...RecipeWithIngredients
      descendantFoods {
        ...Food
      }
      descendantRecipes {
        ...RecipeWithIngredients
      }
    }
  }
}
    ${ServingFragmentDoc}
${FoodFragmentDoc}
${RecipeWithIngredientsFragmentDoc}`;
export const ExcessiveServingAmountFragmentDoc = gql `
    fragment ExcessiveServingAmount on ServingAmount {
  id
  __typename
  amount
  position
  serving {
    ...ExcessiveServing
  }
}
    ${ExcessiveServingFragmentDoc}`;
export const TeamFragmentDoc = gql `
    fragment Team on Team {
  id
  __typename
  gender
  name
}
    `;
export const SportFragmentDoc = gql `
    fragment Sport on Sport {
  id
  __typename
  name
}
    `;
export const FullSportFragmentDoc = gql `
    fragment FullSport on Sport {
  ...Sport
  positions {
    ...Position
  }
}
    ${SportFragmentDoc}
${PositionFragmentDoc}`;
export const TeamWithSportFragmentDoc = gql `
    fragment TeamWithSport on Team {
  ...Team
  sport {
    ...FullSport
  }
}
    ${TeamFragmentDoc}
${FullSportFragmentDoc}`;
export const UsdaFoodFragmentDoc = gql `
    fragment USDAFood on USDAFood {
  id
  __typename
  allHighlightFields
  brandOwner
  dataType
  description
  gtinUpc
  ingredients
  publishedDate
  score
}
    `;
export const UsdaFoodNutrientFragmentDoc = gql `
    fragment USDAFoodNutrient on USDAFoodNutrient {
  id
  amount
  dataPoints
  unitName
  max
  min
  median
  name
  footnote
  __typename
}
    `;
export const UsdaFoodServingFragmentDoc = gql `
    fragment USDAFoodServing on USDAFoodServing {
  __typename
  idx
  cho
  pro
  fat
  weight
  defaultAmount
  units
  isDefault
  usdaWeightSeq
}
    `;
export const UsdaFoodDetailFragmentDoc = gql `
    fragment USDAFoodDetail on USDAFoodDetail {
  __typename
  id
  usdaFdcFoodCategoryId
  usdaFdcDataType
  cho {
    ...USDAFoodNutrient
  }
  pro {
    ...USDAFoodNutrient
  }
  fat {
    ...USDAFoodNutrient
  }
  foodNutrients {
    ...USDAFoodNutrient
  }
  servings {
    ...USDAFoodServing
  }
}
    ${UsdaFoodNutrientFragmentDoc}
${UsdaFoodServingFragmentDoc}`;
export const AthleteWithAnthroFragmentDoc = gql `
    fragment AthleteWithAnthro on Athlete {
  ...Athlete
  position {
    ...Position
  }
  mostRecentAnthropometryEntry {
    ...AnthropometryEntry
  }
}
    ${AthleteFragmentDoc}
${PositionFragmentDoc}
${AnthropometryEntryFragmentDoc}`;
export const MealPlanWithAthleteFragmentDoc = gql `
    fragment MealPlanWithAthlete on MealPlan {
  ...MealPlanSearchForm
  athlete {
    ...Athlete
  }
}
    ${MealPlanSearchFormFragmentDoc}
${AthleteFragmentDoc}`;
export const SimpleFoodGroupFragmentDoc = gql `
    fragment SimpleFoodGroup on FoodGroup {
  id
  name
}
    `;
export const MealPlanBulkCopyTeamPreviewFragmentDoc = gql `
    fragment MealPlanBulkCopyTeamPreview on Team {
  name
  id
}
    `;
export const NutritionixCommonFoodFragmentDoc = gql `
    fragment NutritionixCommonFood on NutritionixCommonFood {
  id
  __typename
  name
  nixTagId
  thumbnailUrl
}
    `;
export const NutritionixBrandedFoodFragmentDoc = gql `
    fragment NutritionixBrandedFood on NutritionixBrandedFood {
  id
  __typename
  name
  nixItemId
  brand {
    id
    __typename
    name
    type
  }
  thumbnailUrl
}
    `;
export const UnsubmittedAgreementFormForUserDocument = gql `
    query UnsubmittedAgreementFormForUser($orgId: ID!) {
  unsubmittedAgreementFormForUser(orgId: $orgId) {
    ...AgreementForm
  }
}
    ${AgreementFormFragmentDoc}`;
/**
 * __useUnsubmittedAgreementFormForUserQuery__
 *
 * To run a query within a React component, call `useUnsubmittedAgreementFormForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnsubmittedAgreementFormForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnsubmittedAgreementFormForUserQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useUnsubmittedAgreementFormForUserQuery(baseOptions) {
    return ApolloReactHooks.useQuery(UnsubmittedAgreementFormForUserDocument, baseOptions);
}
export function useUnsubmittedAgreementFormForUserLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(UnsubmittedAgreementFormForUserDocument, baseOptions);
}
export const AddAgreementFormSubmissionDocument = gql `
    mutation AddAgreementFormSubmission($input: AddAgreementFormSubmissionInput!) {
  addAgreementFormSubmission(input: $input) {
    agreementForm {
      ...AgreementForm
    }
  }
}
    ${AgreementFormFragmentDoc}`;
/**
 * __useAddAgreementFormSubmissionMutation__
 *
 * To run a mutation, you first call `useAddAgreementFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAgreementFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAgreementFormSubmissionMutation, { data, loading, error }] = useAddAgreementFormSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAgreementFormSubmissionMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddAgreementFormSubmissionDocument, baseOptions);
}
export const RecipesByIdWithIngredientsDocument = gql `
    query RecipesByIdWithIngredients($ids: [ID!]!) {
  recipesById(ids: $ids) {
    ...RecipeWithServings
  }
}
    ${RecipeWithServingsFragmentDoc}`;
/**
 * __useRecipesByIdWithIngredientsQuery__
 *
 * To run a query within a React component, call `useRecipesByIdWithIngredientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipesByIdWithIngredientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipesByIdWithIngredientsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRecipesByIdWithIngredientsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(RecipesByIdWithIngredientsDocument, baseOptions);
}
export function useRecipesByIdWithIngredientsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(RecipesByIdWithIngredientsDocument, baseOptions);
}
export const MyFeatureFlagsDocument = gql `
    query MyFeatureFlags {
  myFeatureFlags {
    ...FeatureFlags
  }
}
    ${FeatureFlagsFragmentDoc}`;
/**
 * __useMyFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useMyFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyFeatureFlagsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(MyFeatureFlagsDocument, baseOptions);
}
export function useMyFeatureFlagsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(MyFeatureFlagsDocument, baseOptions);
}
export const MealMenuOrderRateLimitDocument = gql `
    query MealMenuOrderRateLimit($mealMenuId: ID!) {
  mealMenu(mealMenuId: $mealMenuId) {
    id
    orderRateLimit {
      limit
      excludedTeamIds
    }
  }
  menuOrderRateLimitRemainders(mealMenuId: $mealMenuId) {
    ...MenuOrderRateLimitRemainder
  }
}
    ${MenuOrderRateLimitRemainderFragmentDoc}`;
/**
 * __useMealMenuOrderRateLimitQuery__
 *
 * To run a query within a React component, call `useMealMenuOrderRateLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useMealMenuOrderRateLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMealMenuOrderRateLimitQuery({
 *   variables: {
 *      mealMenuId: // value for 'mealMenuId'
 *   },
 * });
 */
export function useMealMenuOrderRateLimitQuery(baseOptions) {
    return ApolloReactHooks.useQuery(MealMenuOrderRateLimitDocument, baseOptions);
}
export function useMealMenuOrderRateLimitLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(MealMenuOrderRateLimitDocument, baseOptions);
}
export const MenuOrderSuggestionsDocument = gql `
    query MenuOrderSuggestions($targetMacros: MacrosInput!, $mealMenuId: ID!, $avoidFoodGroupIds: [ID!]!, $limit: Int) {
  menuOrderSuggestions(
    targetMacros: $targetMacros
    mealMenuId: $mealMenuId
    limit: $limit
    avoidFoodGroupIds: $avoidFoodGroupIds
  ) {
    ...MenuOrderSuggestion
  }
}
    ${MenuOrderSuggestionFragmentDoc}`;
/**
 * __useMenuOrderSuggestionsQuery__
 *
 * To run a query within a React component, call `useMenuOrderSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuOrderSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuOrderSuggestionsQuery({
 *   variables: {
 *      targetMacros: // value for 'targetMacros'
 *      mealMenuId: // value for 'mealMenuId'
 *      avoidFoodGroupIds: // value for 'avoidFoodGroupIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMenuOrderSuggestionsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(MenuOrderSuggestionsDocument, baseOptions);
}
export function useMenuOrderSuggestionsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(MenuOrderSuggestionsDocument, baseOptions);
}
export const RestaurantMenuLinkSuggestionsDocument = gql `
    query RestaurantMenuLinkSuggestions($targetMacros: MacrosInput!, $restaurantMenuLinkId: ID!, $avoidFoodGroupIds: [ID!]!, $limit: Int) {
  restauranMenuLinkSuggestions(
    targetMacros: $targetMacros
    restaurantMenuLinkId: $restaurantMenuLinkId
    limit: $limit
    avoidFoodGroupIds: $avoidFoodGroupIds
  ) {
    ...MenuOrderSuggestion
  }
}
    ${MenuOrderSuggestionFragmentDoc}`;
/**
 * __useRestaurantMenuLinkSuggestionsQuery__
 *
 * To run a query within a React component, call `useRestaurantMenuLinkSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantMenuLinkSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantMenuLinkSuggestionsQuery({
 *   variables: {
 *      targetMacros: // value for 'targetMacros'
 *      restaurantMenuLinkId: // value for 'restaurantMenuLinkId'
 *      avoidFoodGroupIds: // value for 'avoidFoodGroupIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRestaurantMenuLinkSuggestionsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(RestaurantMenuLinkSuggestionsDocument, baseOptions);
}
export function useRestaurantMenuLinkSuggestionsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(RestaurantMenuLinkSuggestionsDocument, baseOptions);
}
export const RestaurantMenuSuggestionsDocument = gql `
    query RestaurantMenuSuggestions($targetMacros: MacrosInput!, $restaurantMenuId: ID!, $avoidFoodGroupIds: [ID!]!, $limit: Int) {
  restaurantMenuSuggestions(
    targetMacros: $targetMacros
    restaurantMenuId: $restaurantMenuId
    limit: $limit
    avoidFoodGroupIds: $avoidFoodGroupIds
  ) {
    ...MenuOrderSuggestion
  }
}
    ${MenuOrderSuggestionFragmentDoc}`;
/**
 * __useRestaurantMenuSuggestionsQuery__
 *
 * To run a query within a React component, call `useRestaurantMenuSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantMenuSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantMenuSuggestionsQuery({
 *   variables: {
 *      targetMacros: // value for 'targetMacros'
 *      restaurantMenuId: // value for 'restaurantMenuId'
 *      avoidFoodGroupIds: // value for 'avoidFoodGroupIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRestaurantMenuSuggestionsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(RestaurantMenuSuggestionsDocument, baseOptions);
}
export function useRestaurantMenuSuggestionsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(RestaurantMenuSuggestionsDocument, baseOptions);
}
export const RecordMenuOrderSuggestionsViewDocument = gql `
    mutation RecordMenuOrderSuggestionsView($input: RecordMenuOrderSuggestionsViewInput!) {
  recordMenuOrderSuggestionsView(input: $input)
}
    `;
/**
 * __useRecordMenuOrderSuggestionsViewMutation__
 *
 * To run a mutation, you first call `useRecordMenuOrderSuggestionsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordMenuOrderSuggestionsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordMenuOrderSuggestionsViewMutation, { data, loading, error }] = useRecordMenuOrderSuggestionsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordMenuOrderSuggestionsViewMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RecordMenuOrderSuggestionsViewDocument, baseOptions);
}
export const RecordMenuOrderSuggestionDecisionDocument = gql `
    mutation RecordMenuOrderSuggestionDecision($input: RecordMenuOrderSuggestionDecisionInput!) {
  recordMenuOrderSuggestionDecision(input: $input)
}
    `;
/**
 * __useRecordMenuOrderSuggestionDecisionMutation__
 *
 * To run a mutation, you first call `useRecordMenuOrderSuggestionDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordMenuOrderSuggestionDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordMenuOrderSuggestionDecisionMutation, { data, loading, error }] = useRecordMenuOrderSuggestionDecisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordMenuOrderSuggestionDecisionMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RecordMenuOrderSuggestionDecisionDocument, baseOptions);
}
export const NutrientsWithDriDocument = gql `
    query NutrientsWithDri($age: Int, $sex: SexType, $kcal: Float) {
  nutrients {
    ...NutrientWithDri
  }
}
    ${NutrientWithDriFragmentDoc}`;
/**
 * __useNutrientsWithDriQuery__
 *
 * To run a query within a React component, call `useNutrientsWithDriQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutrientsWithDriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutrientsWithDriQuery({
 *   variables: {
 *      age: // value for 'age'
 *      sex: // value for 'sex'
 *      kcal: // value for 'kcal'
 *   },
 * });
 */
export function useNutrientsWithDriQuery(baseOptions) {
    return ApolloReactHooks.useQuery(NutrientsWithDriDocument, baseOptions);
}
export function useNutrientsWithDriLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(NutrientsWithDriDocument, baseOptions);
}
export const ServingsWithNutrientAmountsDocument = gql `
    query ServingsWithNutrientAmounts($servingIds: [ID!]!) {
  servings(ids: $servingIds) {
    ...ServingWithNutrientAmounts
  }
}
    ${ServingWithNutrientAmountsFragmentDoc}`;
/**
 * __useServingsWithNutrientAmountsQuery__
 *
 * To run a query within a React component, call `useServingsWithNutrientAmountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServingsWithNutrientAmountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServingsWithNutrientAmountsQuery({
 *   variables: {
 *      servingIds: // value for 'servingIds'
 *   },
 * });
 */
export function useServingsWithNutrientAmountsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(ServingsWithNutrientAmountsDocument, baseOptions);
}
export function useServingsWithNutrientAmountsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(ServingsWithNutrientAmountsDocument, baseOptions);
}
export const ConvertedServingDocument = gql `
    query ConvertedServing($input: ConvertedServingInput!) {
  convertedServing(input: $input) {
    ...ServingWithFoodOrRecipe
  }
}
    ${ServingWithFoodOrRecipeFragmentDoc}`;
/**
 * __useConvertedServingQuery__
 *
 * To run a query within a React component, call `useConvertedServingQuery` and pass it any options that fit your needs.
 * When your component renders, `useConvertedServingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConvertedServingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConvertedServingQuery(baseOptions) {
    return ApolloReactHooks.useQuery(ConvertedServingDocument, baseOptions);
}
export function useConvertedServingLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(ConvertedServingDocument, baseOptions);
}
export const UnitsDocument = gql `
    query Units {
  units {
    ...Unit
  }
}
    ${UnitFragmentDoc}`;
/**
 * __useUnitsQuery__
 *
 * To run a query within a React component, call `useUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnitsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(UnitsDocument, baseOptions);
}
export function useUnitsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(UnitsDocument, baseOptions);
}
export const UnitConversionsFromDocument = gql `
    query UnitConversionsFrom($id: ID!) {
  unit(id: $id) {
    ...UnitWithConversions
  }
}
    ${UnitWithConversionsFragmentDoc}`;
/**
 * __useUnitConversionsFromQuery__
 *
 * To run a query within a React component, call `useUnitConversionsFromQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitConversionsFromQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitConversionsFromQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnitConversionsFromQuery(baseOptions) {
    return ApolloReactHooks.useQuery(UnitConversionsFromDocument, baseOptions);
}
export function useUnitConversionsFromLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(UnitConversionsFromDocument, baseOptions);
}
export const UnitsWithConversionsDocument = gql `
    query UnitsWithConversions {
  units {
    ...UnitWithConversions
  }
}
    ${UnitWithConversionsFragmentDoc}`;
/**
 * __useUnitsWithConversionsQuery__
 *
 * To run a query within a React component, call `useUnitsWithConversionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitsWithConversionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitsWithConversionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnitsWithConversionsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(UnitsWithConversionsDocument, baseOptions);
}
export function useUnitsWithConversionsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(UnitsWithConversionsDocument, baseOptions);
}
export const GetUserLocaleDocument = gql `
    query GetUserLocale {
  myUser {
    id
    locale {
      id
      code
    }
  }
}
    `;
/**
 * __useGetUserLocaleQuery__
 *
 * To run a query within a React component, call `useGetUserLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLocaleQuery(baseOptions) {
    return ApolloReactHooks.useQuery(GetUserLocaleDocument, baseOptions);
}
export function useGetUserLocaleLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(GetUserLocaleDocument, baseOptions);
}
export const RecipeWithFullIngredientsDocument = gql `
    query RecipeWithFullIngredients($id: ID!) {
  recipe(id: $id) {
    id
    ingredients {
      ...FullServingAmount
    }
  }
}
    ${FullServingAmountFragmentDoc}`;
/**
 * __useRecipeWithFullIngredientsQuery__
 *
 * To run a query within a React component, call `useRecipeWithFullIngredientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipeWithFullIngredientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipeWithFullIngredientsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecipeWithFullIngredientsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(RecipeWithFullIngredientsDocument, baseOptions);
}
export function useRecipeWithFullIngredientsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(RecipeWithFullIngredientsDocument, baseOptions);
}
export const AddAthleteDislikedFoodDocument = gql `
    mutation AddAthleteDislikedFood($input: AthleteFoodPreferenceInput!) {
  addAthleteDislikedFood(input: $input) {
    athlete {
      id
      dislikedFoods {
        ...Food
      }
    }
  }
}
    ${FoodFragmentDoc}`;
/**
 * __useAddAthleteDislikedFoodMutation__
 *
 * To run a mutation, you first call `useAddAthleteDislikedFoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAthleteDislikedFoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAthleteDislikedFoodMutation, { data, loading, error }] = useAddAthleteDislikedFoodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAthleteDislikedFoodMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddAthleteDislikedFoodDocument, baseOptions);
}
export const AddAthleteDislikedFoodGroupDocument = gql `
    mutation AddAthleteDislikedFoodGroup($input: AthleteFoodGroupPreferenceInput!) {
  addAthleteDislikedFoodGroup(input: $input) {
    athlete {
      id
      dislikedFoodGroups {
        ...FullFoodGroup
      }
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useAddAthleteDislikedFoodGroupMutation__
 *
 * To run a mutation, you first call `useAddAthleteDislikedFoodGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAthleteDislikedFoodGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAthleteDislikedFoodGroupMutation, { data, loading, error }] = useAddAthleteDislikedFoodGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAthleteDislikedFoodGroupMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddAthleteDislikedFoodGroupDocument, baseOptions);
}
export const AddAthleteEmailDocument = gql `
    mutation AddAthleteEmail($input: AddAthleteEmailInput!) {
  addAthleteEmail(input: $input) {
    athlete {
      ...Athlete
    }
  }
}
    ${AthleteFragmentDoc}`;
/**
 * __useAddAthleteEmailMutation__
 *
 * To run a mutation, you first call `useAddAthleteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAthleteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAthleteEmailMutation, { data, loading, error }] = useAddAthleteEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAthleteEmailMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddAthleteEmailDocument, baseOptions);
}
export const AddAthleteLikedFoodDocument = gql `
    mutation AddAthleteLikedFood($input: AthleteFoodPreferenceInput!) {
  addAthleteLikedFood(input: $input) {
    athlete {
      id
      likedFoods {
        ...Food
      }
    }
  }
}
    ${FoodFragmentDoc}`;
/**
 * __useAddAthleteLikedFoodMutation__
 *
 * To run a mutation, you first call `useAddAthleteLikedFoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAthleteLikedFoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAthleteLikedFoodMutation, { data, loading, error }] = useAddAthleteLikedFoodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAthleteLikedFoodMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddAthleteLikedFoodDocument, baseOptions);
}
export const AddAthleteLikedFoodGroupDocument = gql `
    mutation AddAthleteLikedFoodGroup($input: AthleteFoodGroupPreferenceInput!) {
  addAthleteLikedFoodGroup(input: $input) {
    athlete {
      id
      likedFoodGroups {
        ...FullFoodGroup
      }
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useAddAthleteLikedFoodGroupMutation__
 *
 * To run a mutation, you first call `useAddAthleteLikedFoodGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAthleteLikedFoodGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAthleteLikedFoodGroupMutation, { data, loading, error }] = useAddAthleteLikedFoodGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAthleteLikedFoodGroupMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddAthleteLikedFoodGroupDocument, baseOptions);
}
export const AddAthletePhoneNumberDocument = gql `
    mutation AddAthletePhoneNumber($input: AddAthletePhoneNumberInput!) {
  addAthletePhoneNumber(input: $input) {
    athlete {
      ...Athlete
    }
  }
}
    ${AthleteFragmentDoc}`;
/**
 * __useAddAthletePhoneNumberMutation__
 *
 * To run a mutation, you first call `useAddAthletePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAthletePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAthletePhoneNumberMutation, { data, loading, error }] = useAddAthletePhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAthletePhoneNumberMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddAthletePhoneNumberDocument, baseOptions);
}
export const AddEventDocument = gql `
    mutation AddEvent($input: AddEventInput!) {
  addEvent(input: $input) {
    event {
      ...Event
    }
  }
}
    ${EventFragmentDoc}`;
/**
 * __useAddEventMutation__
 *
 * To run a mutation, you first call `useAddEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventMutation, { data, loading, error }] = useAddEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEventMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddEventDocument, baseOptions);
}
export const AddMealOptionDocument = gql `
    mutation AddMealOption($input: AddMealOptionInput!) {
  addMealOption(input: $input) {
    mealOption {
      ...FullMealOption
    }
  }
}
    ${FullMealOptionFragmentDoc}`;
/**
 * __useAddMealOptionMutation__
 *
 * To run a mutation, you first call `useAddMealOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMealOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMealOptionMutation, { data, loading, error }] = useAddMealOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMealOptionMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddMealOptionDocument, baseOptions);
}
export const ArchiveAthleteDocument = gql `
    mutation ArchiveAthlete($input: ArchiveAthleteInput!) {
  archiveAthlete(input: $input) {
    athlete {
      id
    }
  }
}
    `;
/**
 * __useArchiveAthleteMutation__
 *
 * To run a mutation, you first call `useArchiveAthleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAthleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAthleteMutation, { data, loading, error }] = useArchiveAthleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveAthleteMutation(baseOptions) {
    return ApolloReactHooks.useMutation(ArchiveAthleteDocument, baseOptions);
}
export const CopyExchangeSetDocument = gql `
    mutation CopyExchangeSet($input: CopyExchangeSetInput!) {
  copyExchangeSet(input: $input) {
    exchangeSet {
      ...FullExchangeSet
    }
  }
}
    ${FullExchangeSetFragmentDoc}`;
/**
 * __useCopyExchangeSetMutation__
 *
 * To run a mutation, you first call `useCopyExchangeSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyExchangeSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyExchangeSetMutation, { data, loading, error }] = useCopyExchangeSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyExchangeSetMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CopyExchangeSetDocument, baseOptions);
}
export const CreateOrgMembershipForAthleteDocument = gql `
    mutation CreateOrgMembershipForAthlete($input: CreateOrgMembershipForAthleteInput!) {
  createOrgMembershipForAthlete(input: $input) {
    athlete {
      id
      activationLinkSent
      user {
        id
        username
      }
      orgMembership {
        id
        isActive
      }
    }
    generatedSelfServiceActivationLink
  }
}
    `;
/**
 * __useCreateOrgMembershipForAthleteMutation__
 *
 * To run a mutation, you first call `useCreateOrgMembershipForAthleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgMembershipForAthleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgMembershipForAthleteMutation, { data, loading, error }] = useCreateOrgMembershipForAthleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrgMembershipForAthleteMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateOrgMembershipForAthleteDocument, baseOptions);
}
export const CreateAthletesDocument = gql `
    mutation CreateAthletes($input: [CreateAthleteInput!]!) {
  createAthletes(input: $input) {
    athletes {
      ...Athlete
    }
  }
}
    ${AthleteFragmentDoc}`;
/**
 * __useCreateAthletesMutation__
 *
 * To run a mutation, you first call `useCreateAthletesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAthletesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAthletesMutation, { data, loading, error }] = useCreateAthletesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAthletesMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateAthletesDocument, baseOptions);
}
export const CreateBrandDocument = gql `
    mutation CreateBrand($input: CreateBrandInput!) {
  createBrand(input: $input) {
    brand {
      ...Brand
    }
  }
}
    ${BrandFragmentDoc}`;
/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateBrandDocument, baseOptions);
}
export const CreateFoodServingsDocument = gql `
    mutation CreateFoodServings($input: CreateFoodServingsInput!) {
  createFoodServings(input: $input) {
    servings {
      ...Serving
    }
  }
}
    ${ServingFragmentDoc}`;
/**
 * __useCreateFoodServingsMutation__
 *
 * To run a mutation, you first call `useCreateFoodServingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFoodServingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFoodServingsMutation, { data, loading, error }] = useCreateFoodServingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFoodServingsMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateFoodServingsDocument, baseOptions);
}
export const CreateGoalDocument = gql `
    mutation CreateGoal($input: CreateGoalInput!) {
  createGoal(input: $input) {
    goal {
      ...FullGoal
    }
  }
}
    ${FullGoalFragmentDoc}`;
/**
 * __useCreateGoalMutation__
 *
 * To run a mutation, you first call `useCreateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalMutation, { data, loading, error }] = useCreateGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGoalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateGoalDocument, baseOptions);
}
export const CreateMetricAnthropometryEntriesDocument = gql `
    mutation CreateMetricAnthropometryEntries($input: [CreateMetricAnthropometryEntryInput!]!) {
  createMetricAnthropometryEntries(input: $input) {
    anthropometryEntries {
      ...AnthropometryEntry
    }
  }
}
    ${AnthropometryEntryFragmentDoc}`;
/**
 * __useCreateMetricAnthropometryEntriesMutation__
 *
 * To run a mutation, you first call `useCreateMetricAnthropometryEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricAnthropometryEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricAnthropometryEntriesMutation, { data, loading, error }] = useCreateMetricAnthropometryEntriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMetricAnthropometryEntriesMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateMetricAnthropometryEntriesDocument, baseOptions);
}
export const CreateMetricAnthropometryEntryDocument = gql `
    mutation CreateMetricAnthropometryEntry($input: CreateMetricAnthropometryEntryInput!) {
  createMetricAnthropometryEntry(input: $input) {
    anthropometryEntry {
      ...AnthropometryEntry
    }
  }
}
    ${AnthropometryEntryFragmentDoc}`;
/**
 * __useCreateMetricAnthropometryEntryMutation__
 *
 * To run a mutation, you first call `useCreateMetricAnthropometryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricAnthropometryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricAnthropometryEntryMutation, { data, loading, error }] = useCreateMetricAnthropometryEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMetricAnthropometryEntryMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateMetricAnthropometryEntryDocument, baseOptions);
}
export const CreateMetricAthletesDocument = gql `
    mutation CreateMetricAthletes($input: [CreateMetricAthleteInput!]!) {
  createMetricAthletes(input: $input) {
    athletes {
      ...Athlete
    }
  }
}
    ${AthleteFragmentDoc}`;
/**
 * __useCreateMetricAthletesMutation__
 *
 * To run a mutation, you first call `useCreateMetricAthletesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricAthletesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricAthletesMutation, { data, loading, error }] = useCreateMetricAthletesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMetricAthletesMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateMetricAthletesDocument, baseOptions);
}
export const CreateNoteDocument = gql `
    mutation CreateNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    note {
      ...NoteWithType
    }
  }
}
    ${NoteWithTypeFragmentDoc}`;
/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateNoteDocument, baseOptions);
}
export const CreateNoteTypeDocument = gql `
    mutation CreateNoteType($input: CreateNoteTypeInput!) {
  createNoteType(input: $input) {
    noteType {
      ...NoteType
    }
  }
}
    ${NoteTypeFragmentDoc}`;
/**
 * __useCreateNoteTypeMutation__
 *
 * To run a mutation, you first call `useCreateNoteTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteTypeMutation, { data, loading, error }] = useCreateNoteTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteTypeMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateNoteTypeDocument, baseOptions);
}
export const CreateOrgFoodGroupDocument = gql `
    mutation CreateOrgFoodGroup($input: CreateFoodGroupInput!) {
  createOrgFoodGroup(input: $input) {
    foodGroup {
      ...FullFoodGroup
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useCreateOrgFoodGroupMutation__
 *
 * To run a mutation, you first call `useCreateOrgFoodGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgFoodGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgFoodGroupMutation, { data, loading, error }] = useCreateOrgFoodGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrgFoodGroupMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateOrgFoodGroupDocument, baseOptions);
}
export const CreateOrgFoodServingsDocument = gql `
    mutation CreateOrgFoodServings($input: CreateFoodServingsInput!) {
  createOrgFoodServings(input: $input) {
    servings {
      ...Serving
    }
  }
}
    ${ServingFragmentDoc}`;
/**
 * __useCreateOrgFoodServingsMutation__
 *
 * To run a mutation, you first call `useCreateOrgFoodServingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgFoodServingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgFoodServingsMutation, { data, loading, error }] = useCreateOrgFoodServingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrgFoodServingsMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateOrgFoodServingsDocument, baseOptions);
}
export const CreateSharedFoodGroupDocument = gql `
    mutation CreateSharedFoodGroup($input: CreateFoodGroupInput!) {
  createSharedFoodGroup(input: $input) {
    foodGroup {
      ...FullFoodGroup
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useCreateSharedFoodGroupMutation__
 *
 * To run a mutation, you first call `useCreateSharedFoodGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharedFoodGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharedFoodGroupMutation, { data, loading, error }] = useCreateSharedFoodGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSharedFoodGroupMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateSharedFoodGroupDocument, baseOptions);
}
export const DeleteAnthropometryEntryDocument = gql `
    mutation DeleteAnthropometryEntry($input: DeleteAnthropometryEntryInput!) {
  deleteAnthropometryEntry(input: $input) {
    anthropometryEntryId
  }
}
    `;
/**
 * __useDeleteAnthropometryEntryMutation__
 *
 * To run a mutation, you first call `useDeleteAnthropometryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnthropometryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnthropometryEntryMutation, { data, loading, error }] = useDeleteAnthropometryEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnthropometryEntryMutation(baseOptions) {
    return ApolloReactHooks.useMutation(DeleteAnthropometryEntryDocument, baseOptions);
}
export const DeleteMealPlansDocument = gql `
    mutation DeleteMealPlans($input: DeleteMealPlansInput!) {
  deleteMealPlans(input: $input) {
    mealPlanIds
  }
}
    `;
/**
 * __useDeleteMealPlansMutation__
 *
 * To run a mutation, you first call `useDeleteMealPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMealPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMealPlansMutation, { data, loading, error }] = useDeleteMealPlansMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMealPlansMutation(baseOptions) {
    return ApolloReactHooks.useMutation(DeleteMealPlansDocument, baseOptions);
}
export const DeleteNoteDocument = gql `
    mutation DeleteNote($input: DeleteNoteInput!) {
  deleteNote(input: $input) {
    noteId
  }
}
    `;
/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions) {
    return ApolloReactHooks.useMutation(DeleteNoteDocument, baseOptions);
}
export const DeleteOrgFoodDocument = gql `
    mutation DeleteOrgFood($input: DeleteFoodInput!) {
  deleteOrgFood(input: $input) {
    foodId
  }
}
    `;
/**
 * __useDeleteOrgFoodMutation__
 *
 * To run a mutation, you first call `useDeleteOrgFoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrgFoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrgFoodMutation, { data, loading, error }] = useDeleteOrgFoodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrgFoodMutation(baseOptions) {
    return ApolloReactHooks.useMutation(DeleteOrgFoodDocument, baseOptions);
}
export const DeprecateSharedFoodDocument = gql `
    mutation DeprecateSharedFood($input: DeprecateFoodInput!) {
  deprecateSharedFood(input: $input) {
    foodId
  }
}
    `;
/**
 * __useDeprecateSharedFoodMutation__
 *
 * To run a mutation, you first call `useDeprecateSharedFoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeprecateSharedFoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deprecateSharedFoodMutation, { data, loading, error }] = useDeprecateSharedFoodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeprecateSharedFoodMutation(baseOptions) {
    return ApolloReactHooks.useMutation(DeprecateSharedFoodDocument, baseOptions);
}
export const EditAnthropometryEntryDocument = gql `
    mutation EditAnthropometryEntry($input: EditAnthropometryEntryInput!) {
  editAnthropometryEntry(input: $input) {
    anthropometryEntry {
      ...AnthropometryEntry
    }
  }
}
    ${AnthropometryEntryFragmentDoc}`;
/**
 * __useEditAnthropometryEntryMutation__
 *
 * To run a mutation, you first call `useEditAnthropometryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAnthropometryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAnthropometryEntryMutation, { data, loading, error }] = useEditAnthropometryEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAnthropometryEntryMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditAnthropometryEntryDocument, baseOptions);
}
export const EditAnthropometryEntryCommentDocument = gql `
    mutation EditAnthropometryEntryComment($input: EditAnthropometryEntryCommentInput!) {
  editAnthropometryEntryComment(input: $input) {
    anthropometryEntry {
      ...AnthropometryEntry
    }
  }
}
    ${AnthropometryEntryFragmentDoc}`;
/**
 * __useEditAnthropometryEntryCommentMutation__
 *
 * To run a mutation, you first call `useEditAnthropometryEntryCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAnthropometryEntryCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAnthropometryEntryCommentMutation, { data, loading, error }] = useEditAnthropometryEntryCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAnthropometryEntryCommentMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditAnthropometryEntryCommentDocument, baseOptions);
}
export const EditBrandDocument = gql `
    mutation EditBrand($input: EditBrandInput!) {
  editBrand(input: $input) {
    brand {
      ...Brand
    }
  }
}
    ${BrandFragmentDoc}`;
/**
 * __useEditBrandMutation__
 *
 * To run a mutation, you first call `useEditBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBrandMutation, { data, loading, error }] = useEditBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBrandMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditBrandDocument, baseOptions);
}
export const EditExchangeMealTemplateDocument = gql `
    mutation EditExchangeMealTemplate($input: EditExchangeMealTemplateInput!) {
  editExchangeMealTemplate(input: $input) {
    exchangeMealTemplate {
      ...EditFullExchangeMealTemplate
    }
  }
}
    ${EditFullExchangeMealTemplateFragmentDoc}`;
/**
 * __useEditExchangeMealTemplateMutation__
 *
 * To run a mutation, you first call `useEditExchangeMealTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditExchangeMealTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editExchangeMealTemplateMutation, { data, loading, error }] = useEditExchangeMealTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditExchangeMealTemplateMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditExchangeMealTemplateDocument, baseOptions);
}
export const EditExchangeMealTemplatesDocument = gql `
    mutation EditExchangeMealTemplates($input: [EditExchangeMealTemplateInput!]!) {
  editExchangeMealTemplates(input: $input) {
    exchangeMealTemplates {
      ...EditFullExchangeMealTemplate
    }
  }
}
    ${EditFullExchangeMealTemplateFragmentDoc}`;
/**
 * __useEditExchangeMealTemplatesMutation__
 *
 * To run a mutation, you first call `useEditExchangeMealTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditExchangeMealTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editExchangeMealTemplatesMutation, { data, loading, error }] = useEditExchangeMealTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditExchangeMealTemplatesMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditExchangeMealTemplatesDocument, baseOptions);
}
export const EditFoodServingDocument = gql `
    mutation EditFoodServing($input: EditFoodServingInput!) {
  editFoodServing(input: $input) {
    serving {
      ...Serving
    }
  }
}
    ${ServingFragmentDoc}`;
/**
 * __useEditFoodServingMutation__
 *
 * To run a mutation, you first call `useEditFoodServingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFoodServingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFoodServingMutation, { data, loading, error }] = useEditFoodServingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditFoodServingMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditFoodServingDocument, baseOptions);
}
export const EditMacroMealTemplateDocument = gql `
    mutation EditMacroMealTemplate($input: EditMacroMealTemplateInput!) {
  editMacroMealTemplate(input: $input) {
    macroMealTemplate {
      ...MacroMealTemplate
    }
  }
}
    ${MacroMealTemplateFragmentDoc}`;
/**
 * __useEditMacroMealTemplateMutation__
 *
 * To run a mutation, you first call `useEditMacroMealTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMacroMealTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMacroMealTemplateMutation, { data, loading, error }] = useEditMacroMealTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMacroMealTemplateMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMacroMealTemplateDocument, baseOptions);
}
export const EditMacroMealTemplatesDocument = gql `
    mutation EditMacroMealTemplates($input: [EditMacroMealTemplateInput!]!) {
  editMacroMealTemplates(input: $input) {
    macroMealTemplates {
      ...MacroMealTemplate
    }
  }
}
    ${MacroMealTemplateFragmentDoc}`;
/**
 * __useEditMacroMealTemplatesMutation__
 *
 * To run a mutation, you first call `useEditMacroMealTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMacroMealTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMacroMealTemplatesMutation, { data, loading, error }] = useEditMacroMealTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMacroMealTemplatesMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMacroMealTemplatesDocument, baseOptions);
}
export const EditMacroProtocolDocument = gql `
    mutation EditMacroProtocol($input: EditMacroProtocolInput!) {
  editMacroProtocol(input: $input) {
    macroProtocol {
      ...FullMacroProtocol
    }
  }
}
    ${FullMacroProtocolFragmentDoc}`;
/**
 * __useEditMacroProtocolMutation__
 *
 * To run a mutation, you first call `useEditMacroProtocolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMacroProtocolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMacroProtocolMutation, { data, loading, error }] = useEditMacroProtocolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMacroProtocolMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMacroProtocolDocument, baseOptions);
}
export const EditMacroProtocolWithNewGoalDocument = gql `
    mutation EditMacroProtocolWithNewGoal($input: EditMacroProtocolWithNewGoalInput!) {
  editMacroProtocolWithNewGoal(input: $input) {
    macroProtocol {
      ...FullMacroProtocol
    }
  }
}
    ${FullMacroProtocolFragmentDoc}`;
/**
 * __useEditMacroProtocolWithNewGoalMutation__
 *
 * To run a mutation, you first call `useEditMacroProtocolWithNewGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMacroProtocolWithNewGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMacroProtocolWithNewGoalMutation, { data, loading, error }] = useEditMacroProtocolWithNewGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMacroProtocolWithNewGoalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMacroProtocolWithNewGoalDocument, baseOptions);
}
export const EditMacroProtocolWithOldGoalDocument = gql `
    mutation EditMacroProtocolWithOldGoal($input: EditMacroProtocolWithOldGoalInput!) {
  editMacroProtocolWithOldGoal(input: $input) {
    macroProtocol {
      ...FullMacroProtocol
    }
  }
}
    ${FullMacroProtocolFragmentDoc}`;
/**
 * __useEditMacroProtocolWithOldGoalMutation__
 *
 * To run a mutation, you first call `useEditMacroProtocolWithOldGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMacroProtocolWithOldGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMacroProtocolWithOldGoalMutation, { data, loading, error }] = useEditMacroProtocolWithOldGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMacroProtocolWithOldGoalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMacroProtocolWithOldGoalDocument, baseOptions);
}
export const EditMealOptionDocument = gql `
    mutation EditMealOption($input: EditMealOptionInput!) {
  editMealOption(input: $input) {
    mealOption {
      ...FullMealOption
    }
  }
}
    ${FullMealOptionFragmentDoc}`;
/**
 * __useEditMealOptionMutation__
 *
 * To run a mutation, you first call `useEditMealOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMealOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMealOptionMutation, { data, loading, error }] = useEditMealOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMealOptionMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMealOptionDocument, baseOptions);
}
export const EditMealOptionPendingDocument = gql `
    mutation EditMealOptionPending($input: EditMealOptionPendingInput!) {
  editMealOptionPending(input: $input) {
    mealOptionPending {
      ...FullMealOptionPending
    }
  }
}
    ${FullMealOptionPendingFragmentDoc}`;
/**
 * __useEditMealOptionPendingMutation__
 *
 * To run a mutation, you first call `useEditMealOptionPendingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMealOptionPendingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMealOptionPendingMutation, { data, loading, error }] = useEditMealOptionPendingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMealOptionPendingMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMealOptionPendingDocument, baseOptions);
}
export const EditMealPlanExchangeTargetsDocument = gql `
    mutation EditMealPlanExchangeTargets($input: EditMealPlanExchangeTargetsInput!) {
  editMealPlanExchangeTargets(input: $input) {
    mealPlan {
      id
      exchangeTargets {
        ...EditExchangeAmount
      }
    }
  }
}
    ${EditExchangeAmountFragmentDoc}`;
/**
 * __useEditMealPlanExchangeTargetsMutation__
 *
 * To run a mutation, you first call `useEditMealPlanExchangeTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMealPlanExchangeTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMealPlanExchangeTargetsMutation, { data, loading, error }] = useEditMealPlanExchangeTargetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMealPlanExchangeTargetsMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMealPlanExchangeTargetsDocument, baseOptions);
}
export const EditMealPlanIsSharedDocument = gql `
    mutation EditMealPlanIsShared($input: EditMealPlanIsSharedInput!) {
  editMealPlanIsShared(input: $input) {
    mealPlan {
      ...BasicMealPlan
    }
  }
}
    ${BasicMealPlanFragmentDoc}`;
/**
 * __useEditMealPlanIsSharedMutation__
 *
 * To run a mutation, you first call `useEditMealPlanIsSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMealPlanIsSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMealPlanIsSharedMutation, { data, loading, error }] = useEditMealPlanIsSharedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMealPlanIsSharedMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMealPlanIsSharedDocument, baseOptions);
}
export const EditMealPlansIsSharedDocument = gql `
    mutation EditMealPlansIsShared($input: EditMealPlansIsSharedInput!) {
  editMealPlansIsShared(input: $input) {
    mealPlans {
      id
      isShared
    }
  }
}
    `;
/**
 * __useEditMealPlansIsSharedMutation__
 *
 * To run a mutation, you first call `useEditMealPlansIsSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMealPlansIsSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMealPlansIsSharedMutation, { data, loading, error }] = useEditMealPlansIsSharedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMealPlansIsSharedMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMealPlansIsSharedDocument, baseOptions);
}
export const EditMetricAnthropometryEntriesDocument = gql `
    mutation EditMetricAnthropometryEntries($input: [EditMetricAnthropometryEntryInput!]!) {
  editMetricAnthropometryEntries(input: $input) {
    anthropometryEntries {
      ...AnthropometryEntry
    }
  }
}
    ${AnthropometryEntryFragmentDoc}`;
/**
 * __useEditMetricAnthropometryEntriesMutation__
 *
 * To run a mutation, you first call `useEditMetricAnthropometryEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMetricAnthropometryEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMetricAnthropometryEntriesMutation, { data, loading, error }] = useEditMetricAnthropometryEntriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMetricAnthropometryEntriesMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMetricAnthropometryEntriesDocument, baseOptions);
}
export const EditMetricAnthropometryEntryDocument = gql `
    mutation EditMetricAnthropometryEntry($input: EditMetricAnthropometryEntryInput!) {
  editMetricAnthropometryEntry(input: $input) {
    anthropometryEntry {
      ...AnthropometryEntry
    }
  }
}
    ${AnthropometryEntryFragmentDoc}`;
/**
 * __useEditMetricAnthropometryEntryMutation__
 *
 * To run a mutation, you first call `useEditMetricAnthropometryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMetricAnthropometryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMetricAnthropometryEntryMutation, { data, loading, error }] = useEditMetricAnthropometryEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMetricAnthropometryEntryMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMetricAnthropometryEntryDocument, baseOptions);
}
export const EditMetricAthletesDocument = gql `
    mutation EditMetricAthletes($input: [EditAthleteAndMetricAnthroInput!]!) {
  editMetricAthletes(input: $input) {
    athletes {
      ...Athlete
    }
  }
}
    ${AthleteFragmentDoc}`;
/**
 * __useEditMetricAthletesMutation__
 *
 * To run a mutation, you first call `useEditMetricAthletesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMetricAthletesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMetricAthletesMutation, { data, loading, error }] = useEditMetricAthletesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMetricAthletesMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMetricAthletesDocument, baseOptions);
}
export const EditMetricMacroProtocolDocument = gql `
    mutation EditMetricMacroProtocol($input: EditMetricMacroProtocolInput!) {
  editMetricMacroProtocol(input: $input) {
    macroProtocol {
      ...FullMacroProtocol
    }
  }
}
    ${FullMacroProtocolFragmentDoc}`;
/**
 * __useEditMetricMacroProtocolMutation__
 *
 * To run a mutation, you first call `useEditMetricMacroProtocolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMetricMacroProtocolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMetricMacroProtocolMutation, { data, loading, error }] = useEditMetricMacroProtocolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMetricMacroProtocolMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMetricMacroProtocolDocument, baseOptions);
}
export const EditNoteDocument = gql `
    mutation EditNote($input: EditNoteInput!) {
  editNote(input: $input) {
    note {
      ...NoteWithType
    }
  }
}
    ${NoteWithTypeFragmentDoc}`;
/**
 * __useEditNoteMutation__
 *
 * To run a mutation, you first call `useEditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNoteMutation, { data, loading, error }] = useEditNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditNoteMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditNoteDocument, baseOptions);
}
export const EditNoteTypeDocument = gql `
    mutation EditNoteType($input: EditNoteTypeInput!) {
  editNoteType(input: $input) {
    noteType {
      ...NoteType
    }
  }
}
    ${NoteTypeFragmentDoc}`;
/**
 * __useEditNoteTypeMutation__
 *
 * To run a mutation, you first call `useEditNoteTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNoteTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNoteTypeMutation, { data, loading, error }] = useEditNoteTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditNoteTypeMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditNoteTypeDocument, baseOptions);
}
export const EditOrgFoodGroupDocument = gql `
    mutation EditOrgFoodGroup($input: EditFoodGroupInput!) {
  editOrgFoodGroup(input: $input) {
    foodGroup {
      ...FullFoodGroup
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useEditOrgFoodGroupMutation__
 *
 * To run a mutation, you first call `useEditOrgFoodGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrgFoodGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrgFoodGroupMutation, { data, loading, error }] = useEditOrgFoodGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrgFoodGroupMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditOrgFoodGroupDocument, baseOptions);
}
export const EditOrgFoodServingDocument = gql `
    mutation EditOrgFoodServing($input: EditFoodServingInput!) {
  editOrgFoodServing(input: $input) {
    serving {
      ...Serving
    }
  }
}
    ${ServingFragmentDoc}`;
/**
 * __useEditOrgFoodServingMutation__
 *
 * To run a mutation, you first call `useEditOrgFoodServingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrgFoodServingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrgFoodServingMutation, { data, loading, error }] = useEditOrgFoodServingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrgFoodServingMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditOrgFoodServingDocument, baseOptions);
}
export const EditSharedFoodGroupDocument = gql `
    mutation EditSharedFoodGroup($input: EditFoodGroupInput!) {
  editSharedFoodGroup(input: $input) {
    foodGroup {
      ...FullFoodGroup
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useEditSharedFoodGroupMutation__
 *
 * To run a mutation, you first call `useEditSharedFoodGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSharedFoodGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSharedFoodGroupMutation, { data, loading, error }] = useEditSharedFoodGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSharedFoodGroupMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditSharedFoodGroupDocument, baseOptions);
}
export const CreateExchangeSetDocument = gql `
    mutation CreateExchangeSet($input: CreateExchangeSetInput!) {
  createExchangeSet(input: $input) {
    exchangeSet {
      ...FullExchangeSet
    }
  }
}
    ${FullExchangeSetFragmentDoc}`;
/**
 * __useCreateExchangeSetMutation__
 *
 * To run a mutation, you first call `useCreateExchangeSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExchangeSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExchangeSetMutation, { data, loading, error }] = useCreateExchangeSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExchangeSetMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CreateExchangeSetDocument, baseOptions);
}
export const EditExchangeSetDocument = gql `
    mutation EditExchangeSet($input: EditExchangeSetInput!) {
  editExchangeSet(input: $input) {
    exchangeSet {
      ...FullExchangeSet
    }
  }
}
    ${FullExchangeSetFragmentDoc}`;
/**
 * __useEditExchangeSetMutation__
 *
 * To run a mutation, you first call `useEditExchangeSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditExchangeSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editExchangeSetMutation, { data, loading, error }] = useEditExchangeSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditExchangeSetMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditExchangeSetDocument, baseOptions);
}
export const AddNixCommonFoodDocument = gql `
    mutation AddNixCommonFood($input: AddNixCommonFoodInput!) {
  addNixCommonFood(input: $input) {
    food {
      ...FoodWithDefaultServing
    }
  }
}
    ${FoodWithDefaultServingFragmentDoc}`;
/**
 * __useAddNixCommonFoodMutation__
 *
 * To run a mutation, you first call `useAddNixCommonFoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNixCommonFoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNixCommonFoodMutation, { data, loading, error }] = useAddNixCommonFoodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNixCommonFoodMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddNixCommonFoodDocument, baseOptions);
}
export const AddNixBrandedFoodDocument = gql `
    mutation AddNixBrandedFood($input: AddNixBrandedFoodInput!) {
  addNixBrandedFood(input: $input) {
    food {
      ...FoodWithDefaultServing
    }
  }
}
    ${FoodWithDefaultServingFragmentDoc}`;
/**
 * __useAddNixBrandedFoodMutation__
 *
 * To run a mutation, you first call `useAddNixBrandedFoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNixBrandedFoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNixBrandedFoodMutation, { data, loading, error }] = useAddNixBrandedFoodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNixBrandedFoodMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddNixBrandedFoodDocument, baseOptions);
}
export const RemoveAthleteDislikedFoodDocument = gql `
    mutation RemoveAthleteDislikedFood($input: AthleteFoodPreferenceInput!) {
  removeAthleteDislikedFood(input: $input) {
    athlete {
      id
      dislikedFoods {
        ...Food
      }
    }
  }
}
    ${FoodFragmentDoc}`;
/**
 * __useRemoveAthleteDislikedFoodMutation__
 *
 * To run a mutation, you first call `useRemoveAthleteDislikedFoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAthleteDislikedFoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAthleteDislikedFoodMutation, { data, loading, error }] = useRemoveAthleteDislikedFoodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAthleteDislikedFoodMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RemoveAthleteDislikedFoodDocument, baseOptions);
}
export const RemoveAthleteDislikedFoodGroupDocument = gql `
    mutation RemoveAthleteDislikedFoodGroup($input: AthleteFoodGroupPreferenceInput!) {
  removeAthleteDislikedFoodGroup(input: $input) {
    athlete {
      id
      dislikedFoodGroups {
        ...FullFoodGroup
      }
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useRemoveAthleteDislikedFoodGroupMutation__
 *
 * To run a mutation, you first call `useRemoveAthleteDislikedFoodGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAthleteDislikedFoodGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAthleteDislikedFoodGroupMutation, { data, loading, error }] = useRemoveAthleteDislikedFoodGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAthleteDislikedFoodGroupMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RemoveAthleteDislikedFoodGroupDocument, baseOptions);
}
export const RemoveAthleteLikedFoodDocument = gql `
    mutation RemoveAthleteLikedFood($input: AthleteFoodPreferenceInput!) {
  removeAthleteLikedFood(input: $input) {
    athlete {
      id
      likedFoods {
        ...Food
      }
    }
  }
}
    ${FoodFragmentDoc}`;
/**
 * __useRemoveAthleteLikedFoodMutation__
 *
 * To run a mutation, you first call `useRemoveAthleteLikedFoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAthleteLikedFoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAthleteLikedFoodMutation, { data, loading, error }] = useRemoveAthleteLikedFoodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAthleteLikedFoodMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RemoveAthleteLikedFoodDocument, baseOptions);
}
export const RemoveAthleteLikedFoodGroupDocument = gql `
    mutation RemoveAthleteLikedFoodGroup($input: AthleteFoodGroupPreferenceInput!) {
  removeAthleteLikedFoodGroup(input: $input) {
    athlete {
      id
      likedFoodGroups {
        ...FullFoodGroup
      }
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useRemoveAthleteLikedFoodGroupMutation__
 *
 * To run a mutation, you first call `useRemoveAthleteLikedFoodGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAthleteLikedFoodGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAthleteLikedFoodGroupMutation, { data, loading, error }] = useRemoveAthleteLikedFoodGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAthleteLikedFoodGroupMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RemoveAthleteLikedFoodGroupDocument, baseOptions);
}
export const RemoveMealOptionDocument = gql `
    mutation RemoveMealOption($input: RemoveMealOptionInput!) {
  removeMealOption(input: $input) {
    mealOptionId
  }
}
    `;
/**
 * __useRemoveMealOptionMutation__
 *
 * To run a mutation, you first call `useRemoveMealOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMealOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMealOptionMutation, { data, loading, error }] = useRemoveMealOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMealOptionMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RemoveMealOptionDocument, baseOptions);
}
export const RemoveMealOptionPendingDocument = gql `
    mutation RemoveMealOptionPending($input: RemoveMealOptionPendingInput!) {
  removeMealOptionPending(input: $input) {
    mealOptionPendingId
  }
}
    `;
/**
 * __useRemoveMealOptionPendingMutation__
 *
 * To run a mutation, you first call `useRemoveMealOptionPendingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMealOptionPendingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMealOptionPendingMutation, { data, loading, error }] = useRemoveMealOptionPendingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMealOptionPendingMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RemoveMealOptionPendingDocument, baseOptions);
}
export const ShareMealOptionPendingDocument = gql `
    mutation ShareMealOptionPending($input: ShareMealOptionPendingInput!) {
  shareMealOptionPending(input: $input) {
    mealOption {
      ...FullMealOption
    }
  }
}
    ${FullMealOptionFragmentDoc}`;
/**
 * __useShareMealOptionPendingMutation__
 *
 * To run a mutation, you first call `useShareMealOptionPendingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareMealOptionPendingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareMealOptionPendingMutation, { data, loading, error }] = useShareMealOptionPendingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareMealOptionPendingMutation(baseOptions) {
    return ApolloReactHooks.useMutation(ShareMealOptionPendingDocument, baseOptions);
}
export const TextMealPlanToAthleteDocument = gql `
    mutation TextMealPlanToAthlete($input: TextMealPlanToAthleteInput!) {
  textMealPlanToAthlete(input: $input) {
    result
  }
}
    `;
/**
 * __useTextMealPlanToAthleteMutation__
 *
 * To run a mutation, you first call `useTextMealPlanToAthleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTextMealPlanToAthleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [textMealPlanToAthleteMutation, { data, loading, error }] = useTextMealPlanToAthleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTextMealPlanToAthleteMutation(baseOptions) {
    return ApolloReactHooks.useMutation(TextMealPlanToAthleteDocument, baseOptions);
}
export const TextMealPlansToAthletesDocument = gql `
    mutation TextMealPlansToAthletes($input: TextMealPlansToAthletesInput!) {
  textMealPlansToAthletes(input: $input) {
    result
  }
}
    `;
/**
 * __useTextMealPlansToAthletesMutation__
 *
 * To run a mutation, you first call `useTextMealPlansToAthletesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTextMealPlansToAthletesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [textMealPlansToAthletesMutation, { data, loading, error }] = useTextMealPlansToAthletesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTextMealPlansToAthletesMutation(baseOptions) {
    return ApolloReactHooks.useMutation(TextMealPlansToAthletesDocument, baseOptions);
}
export const UnarchiveAthleteDocument = gql `
    mutation UnarchiveAthlete($input: UnarchiveAthleteInput!) {
  unarchiveAthlete(input: $input) {
    athlete {
      ...AthleteWithGoalAndAnthro
      anthropometryEntries {
        ...AnthropometryEntry
      }
      orgMembership {
        id
        isActive
      }
    }
  }
}
    ${AthleteWithGoalAndAnthroFragmentDoc}
${AnthropometryEntryFragmentDoc}`;
/**
 * __useUnarchiveAthleteMutation__
 *
 * To run a mutation, you first call `useUnarchiveAthleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveAthleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveAthleteMutation, { data, loading, error }] = useUnarchiveAthleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveAthleteMutation(baseOptions) {
    return ApolloReactHooks.useMutation(UnarchiveAthleteDocument, baseOptions);
}
export const AddMealOptionLocalDocument = gql `
    mutation AddMealOptionLocal($mealTemplateId: ID!, $type: String!) {
  addMealOptionLocal(mealTemplateId: $mealTemplateId, type: $type) @client
}
    `;
/**
 * __useAddMealOptionLocalMutation__
 *
 * To run a mutation, you first call `useAddMealOptionLocalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMealOptionLocalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMealOptionLocalMutation, { data, loading, error }] = useAddMealOptionLocalMutation({
 *   variables: {
 *      mealTemplateId: // value for 'mealTemplateId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddMealOptionLocalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(AddMealOptionLocalDocument, baseOptions);
}
export const CalculateExchangeTotalsDocument = gql `
    mutation CalculateExchangeTotals($mealPlanId: ID!) {
  calculateExchangeTotals(mealPlanId: $mealPlanId) @client
}
    `;
/**
 * __useCalculateExchangeTotalsMutation__
 *
 * To run a mutation, you first call `useCalculateExchangeTotalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateExchangeTotalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateExchangeTotalsMutation, { data, loading, error }] = useCalculateExchangeTotalsMutation({
 *   variables: {
 *      mealPlanId: // value for 'mealPlanId'
 *   },
 * });
 */
export function useCalculateExchangeTotalsMutation(baseOptions) {
    return ApolloReactHooks.useMutation(CalculateExchangeTotalsDocument, baseOptions);
}
export const ChangeExchangeTargetDocument = gql `
    mutation ChangeExchangeTarget($mealTemplateId: ID!, $exchangeId: ID!, $target: String!, $pickListServingIds: [ID!]) {
  changeExchangeTarget(
    mealTemplateId: $mealTemplateId
    exchangeId: $exchangeId
    target: $target
    pickListServingIds: $pickListServingIds
  ) @client
}
    `;
/**
 * __useChangeExchangeTargetMutation__
 *
 * To run a mutation, you first call `useChangeExchangeTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeExchangeTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeExchangeTargetMutation, { data, loading, error }] = useChangeExchangeTargetMutation({
 *   variables: {
 *      mealTemplateId: // value for 'mealTemplateId'
 *      exchangeId: // value for 'exchangeId'
 *      target: // value for 'target'
 *      pickListServingIds: // value for 'pickListServingIds'
 *   },
 * });
 */
export function useChangeExchangeTargetMutation(baseOptions) {
    return ApolloReactHooks.useMutation(ChangeExchangeTargetDocument, baseOptions);
}
export const ChangeExchangeTargetTotalDocument = gql `
    mutation ChangeExchangeTargetTotal($mealPlanId: ID!, $exchangeId: ID!, $target: String!) {
  changeExchangeTargetTotal(
    mealPlanId: $mealPlanId
    exchangeId: $exchangeId
    target: $target
  ) @client
}
    `;
/**
 * __useChangeExchangeTargetTotalMutation__
 *
 * To run a mutation, you first call `useChangeExchangeTargetTotalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeExchangeTargetTotalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeExchangeTargetTotalMutation, { data, loading, error }] = useChangeExchangeTargetTotalMutation({
 *   variables: {
 *      mealPlanId: // value for 'mealPlanId'
 *      exchangeId: // value for 'exchangeId'
 *      target: // value for 'target'
 *   },
 * });
 */
export function useChangeExchangeTargetTotalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(ChangeExchangeTargetTotalDocument, baseOptions);
}
export const ChangeMacroTargetDocument = gql `
    mutation ChangeMacroTarget($mealTemplateId: ID!, $macro: MacroType!, $target: String!) {
  changeMacroTarget(
    mealTemplateId: $mealTemplateId
    macro: $macro
    target: $target
  ) @client
}
    `;
/**
 * __useChangeMacroTargetMutation__
 *
 * To run a mutation, you first call `useChangeMacroTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMacroTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMacroTargetMutation, { data, loading, error }] = useChangeMacroTargetMutation({
 *   variables: {
 *      mealTemplateId: // value for 'mealTemplateId'
 *      macro: // value for 'macro'
 *      target: // value for 'target'
 *   },
 * });
 */
export function useChangeMacroTargetMutation(baseOptions) {
    return ApolloReactHooks.useMutation(ChangeMacroTargetDocument, baseOptions);
}
export const DeselectNegativeFoodsDocument = gql `
    mutation DeselectNegativeFoods($mealPlanId: ID!) {
  deselectNegativeFoods(mealPlanId: $mealPlanId) @client
}
    `;
/**
 * __useDeselectNegativeFoodsMutation__
 *
 * To run a mutation, you first call `useDeselectNegativeFoodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeselectNegativeFoodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deselectNegativeFoodsMutation, { data, loading, error }] = useDeselectNegativeFoodsMutation({
 *   variables: {
 *      mealPlanId: // value for 'mealPlanId'
 *   },
 * });
 */
export function useDeselectNegativeFoodsMutation(baseOptions) {
    return ApolloReactHooks.useMutation(DeselectNegativeFoodsDocument, baseOptions);
}
export const DistributeExchangeTargetsDocument = gql `
    mutation DistributeExchangeTargets($mealPlanId: ID!) {
  distributeExchangeTargets(mealPlanId: $mealPlanId) @client
}
    `;
/**
 * __useDistributeExchangeTargetsMutation__
 *
 * To run a mutation, you first call `useDistributeExchangeTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDistributeExchangeTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [distributeExchangeTargetsMutation, { data, loading, error }] = useDistributeExchangeTargetsMutation({
 *   variables: {
 *      mealPlanId: // value for 'mealPlanId'
 *   },
 * });
 */
export function useDistributeExchangeTargetsMutation(baseOptions) {
    return ApolloReactHooks.useMutation(DistributeExchangeTargetsDocument, baseOptions);
}
export const DistributeMacroTargetsDocument = gql `
    mutation DistributeMacroTargets($mealPlanId: ID!) {
  distributeMacroTargets(mealPlanId: $mealPlanId) @client
}
    `;
/**
 * __useDistributeMacroTargetsMutation__
 *
 * To run a mutation, you first call `useDistributeMacroTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDistributeMacroTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [distributeMacroTargetsMutation, { data, loading, error }] = useDistributeMacroTargetsMutation({
 *   variables: {
 *      mealPlanId: // value for 'mealPlanId'
 *   },
 * });
 */
export function useDistributeMacroTargetsMutation(baseOptions) {
    return ApolloReactHooks.useMutation(DistributeMacroTargetsDocument, baseOptions);
}
export const EditMealOptionLocalDocument = gql `
    mutation EditMealOptionLocal($input: EditMealOptionLocalInput!) {
  editMealOptionLocal(input: $input) @client
}
    `;
/**
 * __useEditMealOptionLocalMutation__
 *
 * To run a mutation, you first call `useEditMealOptionLocalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMealOptionLocalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMealOptionLocalMutation, { data, loading, error }] = useEditMealOptionLocalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMealOptionLocalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMealOptionLocalDocument, baseOptions);
}
export const EditMealOptionPendingLocalDocument = gql `
    mutation EditMealOptionPendingLocal($input: EditMealOptionPendingLocalInput!) {
  editMealOptionPendingLocal(input: $input) @client
}
    `;
/**
 * __useEditMealOptionPendingLocalMutation__
 *
 * To run a mutation, you first call `useEditMealOptionPendingLocalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMealOptionPendingLocalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMealOptionPendingLocalMutation, { data, loading, error }] = useEditMealOptionPendingLocalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMealOptionPendingLocalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(EditMealOptionPendingLocalDocument, baseOptions);
}
export const RemoveMealOptionLocalDocument = gql `
    mutation RemoveMealOptionLocal($mealTemplateId: ID!, $type: String!, $mealOptionId: ID!) {
  removeMealOptionLocal(
    mealTemplateId: $mealTemplateId
    type: $type
    mealOptionId: $mealOptionId
  ) @client
}
    `;
/**
 * __useRemoveMealOptionLocalMutation__
 *
 * To run a mutation, you first call `useRemoveMealOptionLocalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMealOptionLocalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMealOptionLocalMutation, { data, loading, error }] = useRemoveMealOptionLocalMutation({
 *   variables: {
 *      mealTemplateId: // value for 'mealTemplateId'
 *      type: // value for 'type'
 *      mealOptionId: // value for 'mealOptionId'
 *   },
 * });
 */
export function useRemoveMealOptionLocalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RemoveMealOptionLocalDocument, baseOptions);
}
export const RemoveMealOptionPendingLocalDocument = gql `
    mutation RemoveMealOptionPendingLocal($mealTemplateId: ID!, $type: String!, $mealOptionPendingId: ID!) {
  removeMealOptionPendingLocal(
    mealTemplateId: $mealTemplateId
    type: $type
    mealOptionPendingId: $mealOptionPendingId
  ) @client
}
    `;
/**
 * __useRemoveMealOptionPendingLocalMutation__
 *
 * To run a mutation, you first call `useRemoveMealOptionPendingLocalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMealOptionPendingLocalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMealOptionPendingLocalMutation, { data, loading, error }] = useRemoveMealOptionPendingLocalMutation({
 *   variables: {
 *      mealTemplateId: // value for 'mealTemplateId'
 *      type: // value for 'type'
 *      mealOptionPendingId: // value for 'mealOptionPendingId'
 *   },
 * });
 */
export function useRemoveMealOptionPendingLocalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(RemoveMealOptionPendingLocalDocument, baseOptions);
}
export const SelectMealOptionDocument = gql `
    mutation SelectMealOption($mealTemplateId: ID!, $type: String!, $mealOptionId: ID!) {
  selectMealOption(
    mealTemplateId: $mealTemplateId
    type: $type
    mealOptionId: $mealOptionId
  ) @client
}
    `;
/**
 * __useSelectMealOptionMutation__
 *
 * To run a mutation, you first call `useSelectMealOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectMealOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectMealOptionMutation, { data, loading, error }] = useSelectMealOptionMutation({
 *   variables: {
 *      mealTemplateId: // value for 'mealTemplateId'
 *      type: // value for 'type'
 *      mealOptionId: // value for 'mealOptionId'
 *   },
 * });
 */
export function useSelectMealOptionMutation(baseOptions) {
    return ApolloReactHooks.useMutation(SelectMealOptionDocument, baseOptions);
}
export const ShareMealOptionPendingLocalDocument = gql `
    mutation ShareMealOptionPendingLocal($mealTemplateId: ID!, $mealOptionPendingId: ID!) {
  shareMealOptionPendingLocal(
    mealTemplateId: $mealTemplateId
    mealOptionPendingId: $mealOptionPendingId
  ) @client
}
    `;
/**
 * __useShareMealOptionPendingLocalMutation__
 *
 * To run a mutation, you first call `useShareMealOptionPendingLocalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareMealOptionPendingLocalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareMealOptionPendingLocalMutation, { data, loading, error }] = useShareMealOptionPendingLocalMutation({
 *   variables: {
 *      mealTemplateId: // value for 'mealTemplateId'
 *      mealOptionPendingId: // value for 'mealOptionPendingId'
 *   },
 * });
 */
export function useShareMealOptionPendingLocalMutation(baseOptions) {
    return ApolloReactHooks.useMutation(ShareMealOptionPendingLocalDocument, baseOptions);
}
export const AllAthletesDocument = gql `
    query AllAthletes {
  athletes {
    ...AthleteWithAnthro
    team {
      ...TeamWithSport
    }
    position {
      ...Position
    }
  }
}
    ${AthleteWithAnthroFragmentDoc}
${TeamWithSportFragmentDoc}
${PositionFragmentDoc}`;
/**
 * __useAllAthletesQuery__
 *
 * To run a query within a React component, call `useAllAthletesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAthletesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAthletesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAthletesQuery(baseOptions) {
    return ApolloReactHooks.useQuery(AllAthletesDocument, baseOptions);
}
export function useAllAthletesLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(AllAthletesDocument, baseOptions);
}
export const AllAthletesAndAnthropometryEntriesDocument = gql `
    query AllAthletesAndAnthropometryEntries {
  athletes {
    ...Athlete
    mostRecentAnthropometryEntry {
      id
      height
    }
    team {
      ...TeamWithSport
    }
    position {
      ...Position
    }
    anthropometryEntries {
      ...AnthropometryEntry
    }
  }
}
    ${AthleteFragmentDoc}
${TeamWithSportFragmentDoc}
${PositionFragmentDoc}
${AnthropometryEntryFragmentDoc}`;
/**
 * __useAllAthletesAndAnthropometryEntriesQuery__
 *
 * To run a query within a React component, call `useAllAthletesAndAnthropometryEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAthletesAndAnthropometryEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAthletesAndAnthropometryEntriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAthletesAndAnthropometryEntriesQuery(baseOptions) {
    return ApolloReactHooks.useQuery(AllAthletesAndAnthropometryEntriesDocument, baseOptions);
}
export function useAllAthletesAndAnthropometryEntriesLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(AllAthletesAndAnthropometryEntriesDocument, baseOptions);
}
export const AthleteAnthropometryDocument = gql `
    query AthleteAnthropometry($id: ID!) {
  athlete(id: $id) {
    ...Athlete
    anthropometryEntries {
      ...AnthropometryEntry
    }
  }
}
    ${AthleteFragmentDoc}
${AnthropometryEntryFragmentDoc}`;
/**
 * __useAthleteAnthropometryQuery__
 *
 * To run a query within a React component, call `useAthleteAnthropometryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAthleteAnthropometryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAthleteAnthropometryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAthleteAnthropometryQuery(baseOptions) {
    return ApolloReactHooks.useQuery(AthleteAnthropometryDocument, baseOptions);
}
export function useAthleteAnthropometryLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(AthleteAnthropometryDocument, baseOptions);
}
export const AthleteNotesDocument = gql `
    query AthleteNotes($id: ID!) {
  athlete(id: $id) {
    ...Athlete
    notes {
      ...NoteWithType
    }
  }
}
    ${AthleteFragmentDoc}
${NoteWithTypeFragmentDoc}`;
/**
 * __useAthleteNotesQuery__
 *
 * To run a query within a React component, call `useAthleteNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAthleteNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAthleteNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAthleteNotesQuery(baseOptions) {
    return ApolloReactHooks.useQuery(AthleteNotesDocument, baseOptions);
}
export function useAthleteNotesLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(AthleteNotesDocument, baseOptions);
}
export const AthletesMealPlansDocument = gql `
    query AthletesMealPlans {
  athletes {
    ...AthleteWithMealPlans
  }
}
    ${AthleteWithMealPlansFragmentDoc}`;
/**
 * __useAthletesMealPlansQuery__
 *
 * To run a query within a React component, call `useAthletesMealPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAthletesMealPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAthletesMealPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useAthletesMealPlansQuery(baseOptions) {
    return ApolloReactHooks.useQuery(AthletesMealPlansDocument, baseOptions);
}
export function useAthletesMealPlansLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(AthletesMealPlansDocument, baseOptions);
}
export const MealPlanForCopyCursorConnectionDocument = gql `
    query MealPlanForCopyCursorConnection($pagination: CursorPaginationInput!, $athleteName: String, $mealPlanName: String) {
  mealPlanForCopyCursorConnection(
    input: $pagination
    athleteName: $athleteName
    mealPlanName: $mealPlanName
  ) {
    edges {
      ...MealPlanWithAthlete
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${MealPlanWithAthleteFragmentDoc}`;
/**
 * __useMealPlanForCopyCursorConnectionQuery__
 *
 * To run a query within a React component, call `useMealPlanForCopyCursorConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMealPlanForCopyCursorConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMealPlanForCopyCursorConnectionQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      athleteName: // value for 'athleteName'
 *      mealPlanName: // value for 'mealPlanName'
 *   },
 * });
 */
export function useMealPlanForCopyCursorConnectionQuery(baseOptions) {
    return ApolloReactHooks.useQuery(MealPlanForCopyCursorConnectionDocument, baseOptions);
}
export function useMealPlanForCopyCursorConnectionLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(MealPlanForCopyCursorConnectionDocument, baseOptions);
}
export const AthletesPreviewDocument = gql `
    query AthletesPreview {
  athletes {
    ...Athlete
  }
}
    ${AthleteFragmentDoc}`;
/**
 * __useAthletesPreviewQuery__
 *
 * To run a query within a React component, call `useAthletesPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAthletesPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAthletesPreviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useAthletesPreviewQuery(baseOptions) {
    return ApolloReactHooks.useQuery(AthletesPreviewDocument, baseOptions);
}
export function useAthletesPreviewLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(AthletesPreviewDocument, baseOptions);
}
export const AthleteSearchDocument = gql `
    query AthleteSearch($query: String!, $limit: Int) {
  athleteSearch(query: $query, limit: $limit) {
    ...Athlete
  }
}
    ${AthleteFragmentDoc}`;
/**
 * __useAthleteSearchQuery__
 *
 * To run a query within a React component, call `useAthleteSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAthleteSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAthleteSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAthleteSearchQuery(baseOptions) {
    return ApolloReactHooks.useQuery(AthleteSearchDocument, baseOptions);
}
export function useAthleteSearchLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(AthleteSearchDocument, baseOptions);
}
export const TeamAthletesSelectFieldDocument = gql `
    query TeamAthletesSelectField($teamId: ID!) {
  team(id: $teamId) {
    athletes {
      ...Athlete
    }
  }
}
    ${AthleteFragmentDoc}`;
/**
 * __useTeamAthletesSelectFieldQuery__
 *
 * To run a query within a React component, call `useTeamAthletesSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamAthletesSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamAthletesSelectFieldQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTeamAthletesSelectFieldQuery(baseOptions) {
    return ApolloReactHooks.useQuery(TeamAthletesSelectFieldDocument, baseOptions);
}
export function useTeamAthletesSelectFieldLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(TeamAthletesSelectFieldDocument, baseOptions);
}
export const BrandsDocument = gql `
    query Brands($searchTerm: String!, $limit: Int) {
  brands(searchTerm: $searchTerm, limit: $limit) {
    ...Brand
  }
}
    ${BrandFragmentDoc}`;
/**
 * __useBrandsQuery__
 *
 * To run a query within a React component, call `useBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBrandsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(BrandsDocument, baseOptions);
}
export function useBrandsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(BrandsDocument, baseOptions);
}
export const GetEditMealPlanDocument = gql `
    query GetEditMealPlan($mealPlanId: ID!) {
  mealPlan(id: $mealPlanId) {
    ...EditFullMealPlan
  }
}
    ${EditFullMealPlanFragmentDoc}`;
/**
 * __useGetEditMealPlanQuery__
 *
 * To run a query within a React component, call `useGetEditMealPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditMealPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditMealPlanQuery({
 *   variables: {
 *      mealPlanId: // value for 'mealPlanId'
 *   },
 * });
 */
export function useGetEditMealPlanQuery(baseOptions) {
    return ApolloReactHooks.useQuery(GetEditMealPlanDocument, baseOptions);
}
export function useGetEditMealPlanLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(GetEditMealPlanDocument, baseOptions);
}
export const ExchangeSetDocument = gql `
    query ExchangeSet($id: ID!) {
  exchangeSet(id: $id) {
    ...FullExchangeSet
  }
}
    ${FullExchangeSetFragmentDoc}`;
/**
 * __useExchangeSetQuery__
 *
 * To run a query within a React component, call `useExchangeSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useExchangeSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExchangeSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExchangeSetQuery(baseOptions) {
    return ApolloReactHooks.useQuery(ExchangeSetDocument, baseOptions);
}
export function useExchangeSetLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(ExchangeSetDocument, baseOptions);
}
export const ExchangeSetsDocument = gql `
    query ExchangeSets {
  exchangeSets {
    ...ExchangeSetWithExchanges
  }
}
    ${ExchangeSetWithExchangesFragmentDoc}`;
/**
 * __useExchangeSetsQuery__
 *
 * To run a query within a React component, call `useExchangeSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExchangeSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExchangeSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExchangeSetsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(ExchangeSetsDocument, baseOptions);
}
export function useExchangeSetsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(ExchangeSetsDocument, baseOptions);
}
export const FoodGroupDocument = gql `
    query FoodGroup($id: ID!) {
  foodGroup(id: $id) {
    ...FullFoodGroupWithFoods
  }
}
    ${FullFoodGroupWithFoodsFragmentDoc}`;
/**
 * __useFoodGroupQuery__
 *
 * To run a query within a React component, call `useFoodGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFoodGroupQuery(baseOptions) {
    return ApolloReactHooks.useQuery(FoodGroupDocument, baseOptions);
}
export function useFoodGroupLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(FoodGroupDocument, baseOptions);
}
export const FoodGroupsDocument = gql `
    query FoodGroups($searchTerm: String!, $limit: Int) {
  foodGroups(searchTerm: $searchTerm, limit: $limit) {
    ...SimpleFoodGroup
  }
}
    ${SimpleFoodGroupFragmentDoc}`;
/**
 * __useFoodGroupsQuery__
 *
 * To run a query within a React component, call `useFoodGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodGroupsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFoodGroupsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(FoodGroupsDocument, baseOptions);
}
export function useFoodGroupsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(FoodGroupsDocument, baseOptions);
}
export const SharedFoodGroupsTableDocument = gql `
    query SharedFoodGroupsTable($query: String, $input: OffsetPaginationInput!, $sortOrder: SortOrder!) {
  sharedFoodGroupsOffsetConnection(
    query: $query
    input: $input
    sortOrder: $sortOrder
  ) {
    pageInfo {
      hasNextPage
      total
      endOffset
    }
    edges {
      ...FullFoodGroup
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useSharedFoodGroupsTableQuery__
 *
 * To run a query within a React component, call `useSharedFoodGroupsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFoodGroupsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFoodGroupsTableQuery({
 *   variables: {
 *      query: // value for 'query'
 *      input: // value for 'input'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSharedFoodGroupsTableQuery(baseOptions) {
    return ApolloReactHooks.useQuery(SharedFoodGroupsTableDocument, baseOptions);
}
export function useSharedFoodGroupsTableLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(SharedFoodGroupsTableDocument, baseOptions);
}
export const OrgFoodGroupsTableDocument = gql `
    query OrgFoodGroupsTable($query: String, $input: OffsetPaginationInput!, $sortOrder: SortOrder!) {
  orgFoodGroupsOffsetConnection(
    query: $query
    input: $input
    sortOrder: $sortOrder
  ) {
    pageInfo {
      hasNextPage
      total
      endOffset
    }
    edges {
      ...FullFoodGroup
    }
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useOrgFoodGroupsTableQuery__
 *
 * To run a query within a React component, call `useOrgFoodGroupsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgFoodGroupsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgFoodGroupsTableQuery({
 *   variables: {
 *      query: // value for 'query'
 *      input: // value for 'input'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useOrgFoodGroupsTableQuery(baseOptions) {
    return ApolloReactHooks.useQuery(OrgFoodGroupsTableDocument, baseOptions);
}
export function useOrgFoodGroupsTableLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(OrgFoodGroupsTableDocument, baseOptions);
}
export const SharedFoodGroupsCursorConnectionDocument = gql `
    query SharedFoodGroupsCursorConnection($searchText: String!, $pagination: CursorPaginationInput!) {
  sharedFoodGroupsCursorConnection(
    searchText: $searchText
    pagination: $pagination
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      ...SimpleFoodGroup
    }
  }
}
    ${SimpleFoodGroupFragmentDoc}`;
/**
 * __useSharedFoodGroupsCursorConnectionQuery__
 *
 * To run a query within a React component, call `useSharedFoodGroupsCursorConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFoodGroupsCursorConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFoodGroupsCursorConnectionQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSharedFoodGroupsCursorConnectionQuery(baseOptions) {
    return ApolloReactHooks.useQuery(SharedFoodGroupsCursorConnectionDocument, baseOptions);
}
export function useSharedFoodGroupsCursorConnectionLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(SharedFoodGroupsCursorConnectionDocument, baseOptions);
}
export const FoodOrRecipeDocument = gql `
    query FoodOrRecipe($id: ID!) {
  foodOrRecipe(id: $id) {
    ... on Food {
      ...FoodWithServings
    }
    ... on Recipe {
      ...RecipeWithServings
    }
  }
}
    ${FoodWithServingsFragmentDoc}
${RecipeWithServingsFragmentDoc}`;
/**
 * __useFoodOrRecipeQuery__
 *
 * To run a query within a React component, call `useFoodOrRecipeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodOrRecipeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodOrRecipeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFoodOrRecipeQuery(baseOptions) {
    return ApolloReactHooks.useQuery(FoodOrRecipeDocument, baseOptions);
}
export function useFoodOrRecipeLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(FoodOrRecipeDocument, baseOptions);
}
export const FoodsWithDefaultServingOnlyDocument = gql `
    query FoodsWithDefaultServingOnly($searchTerm: String!, $limit: Int, $localeCodes: [String!], $dataSources: [FoodDataSource!]) {
  foods(
    searchTerm: $searchTerm
    limit: $limit
    localeCodes: $localeCodes
    dataSources: $dataSources
  ) {
    ...FoodWithDefaultServing
  }
}
    ${FoodWithDefaultServingFragmentDoc}`;
/**
 * __useFoodsWithDefaultServingOnlyQuery__
 *
 * To run a query within a React component, call `useFoodsWithDefaultServingOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodsWithDefaultServingOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodsWithDefaultServingOnlyQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *      localeCodes: // value for 'localeCodes'
 *      dataSources: // value for 'dataSources'
 *   },
 * });
 */
export function useFoodsWithDefaultServingOnlyQuery(baseOptions) {
    return ApolloReactHooks.useQuery(FoodsWithDefaultServingOnlyDocument, baseOptions);
}
export function useFoodsWithDefaultServingOnlyLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(FoodsWithDefaultServingOnlyDocument, baseOptions);
}
export const RestaurantFoodsWithDefaultServingOnlyDocument = gql `
    query RestaurantFoodsWithDefaultServingOnly($searchTerm: String!, $limit: Int, $restaurantId: ID!) {
  restaurantFoods(
    searchTerm: $searchTerm
    limit: $limit
    restaurantId: $restaurantId
  ) {
    ...FoodWithDefaultServing
  }
}
    ${FoodWithDefaultServingFragmentDoc}`;
/**
 * __useRestaurantFoodsWithDefaultServingOnlyQuery__
 *
 * To run a query within a React component, call `useRestaurantFoodsWithDefaultServingOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantFoodsWithDefaultServingOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantFoodsWithDefaultServingOnlyQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useRestaurantFoodsWithDefaultServingOnlyQuery(baseOptions) {
    return ApolloReactHooks.useQuery(RestaurantFoodsWithDefaultServingOnlyDocument, baseOptions);
}
export function useRestaurantFoodsWithDefaultServingOnlyLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(RestaurantFoodsWithDefaultServingOnlyDocument, baseOptions);
}
export const GenericFoodsDocument = gql `
    query GenericFoods($searchTerm: String!, $limit: Int) {
  genericFoods(searchTerm: $searchTerm, limit: $limit) {
    ...Food
  }
}
    ${FoodFragmentDoc}`;
/**
 * __useGenericFoodsQuery__
 *
 * To run a query within a React component, call `useGenericFoodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericFoodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericFoodsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGenericFoodsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(GenericFoodsDocument, baseOptions);
}
export function useGenericFoodsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(GenericFoodsDocument, baseOptions);
}
export const GoalTypesDocument = gql `
    query GoalTypes {
  goalTypes {
    ...GoalType
  }
}
    ${GoalTypeFragmentDoc}`;
/**
 * __useGoalTypesQuery__
 *
 * To run a query within a React component, call `useGoalTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoalTypesQuery(baseOptions) {
    return ApolloReactHooks.useQuery(GoalTypesDocument, baseOptions);
}
export function useGoalTypesLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(GoalTypesDocument, baseOptions);
}
export const GroceryListCategoriesDocument = gql `
    query GroceryListCategories {
  groceryListCategories {
    id
    name
  }
}
    `;
/**
 * __useGroceryListCategoriesQuery__
 *
 * To run a query within a React component, call `useGroceryListCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroceryListCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroceryListCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGroceryListCategoriesQuery(baseOptions) {
    return ApolloReactHooks.useQuery(GroceryListCategoriesDocument, baseOptions);
}
export function useGroceryListCategoriesLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(GroceryListCategoriesDocument, baseOptions);
}
export const MealPlanBulkCopyChooseAthletesContainerDocument = gql `
    query MealPlanBulkCopyChooseAthletesContainer($teamId: ID!) {
  team(id: $teamId) {
    ...Team
    athletes {
      ...AthleteWithGoalAndAnthro
    }
  }
  exchangeSets {
    ...ExchangeSet
  }
}
    ${TeamFragmentDoc}
${AthleteWithGoalAndAnthroFragmentDoc}
${ExchangeSetFragmentDoc}`;
/**
 * __useMealPlanBulkCopyChooseAthletesContainerQuery__
 *
 * To run a query within a React component, call `useMealPlanBulkCopyChooseAthletesContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMealPlanBulkCopyChooseAthletesContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMealPlanBulkCopyChooseAthletesContainerQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useMealPlanBulkCopyChooseAthletesContainerQuery(baseOptions) {
    return ApolloReactHooks.useQuery(MealPlanBulkCopyChooseAthletesContainerDocument, baseOptions);
}
export function useMealPlanBulkCopyChooseAthletesContainerLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(MealPlanBulkCopyChooseAthletesContainerDocument, baseOptions);
}
export const MealPlanBulkCopyDocument = gql `
    query MealPlanBulkCopy {
  teams {
    ...MealPlanBulkCopyTeamPreview
  }
  exchangeSets {
    ...ExchangeSet
  }
}
    ${MealPlanBulkCopyTeamPreviewFragmentDoc}
${ExchangeSetFragmentDoc}`;
/**
 * __useMealPlanBulkCopyQuery__
 *
 * To run a query within a React component, call `useMealPlanBulkCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMealPlanBulkCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMealPlanBulkCopyQuery({
 *   variables: {
 *   },
 * });
 */
export function useMealPlanBulkCopyQuery(baseOptions) {
    return ApolloReactHooks.useQuery(MealPlanBulkCopyDocument, baseOptions);
}
export function useMealPlanBulkCopyLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(MealPlanBulkCopyDocument, baseOptions);
}
export const NoteTypesDocument = gql `
    query NoteTypes {
  noteTypes {
    ...NoteType
  }
}
    ${NoteTypeFragmentDoc}`;
/**
 * __useNoteTypesQuery__
 *
 * To run a query within a React component, call `useNoteTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNoteTypesQuery(baseOptions) {
    return ApolloReactHooks.useQuery(NoteTypesDocument, baseOptions);
}
export function useNoteTypesLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(NoteTypesDocument, baseOptions);
}
export const OrgFoodGroupsDocument = gql `
    query OrgFoodGroups($searchTerm: String!, $limit: Int) {
  orgFoodGroups(searchTerm: $searchTerm, limit: $limit) {
    ...FullFoodGroup
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useOrgFoodGroupsQuery__
 *
 * To run a query within a React component, call `useOrgFoodGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgFoodGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgFoodGroupsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrgFoodGroupsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(OrgFoodGroupsDocument, baseOptions);
}
export function useOrgFoodGroupsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(OrgFoodGroupsDocument, baseOptions);
}
export const PingDocument = gql `
    query Ping {
  ping
}
    `;
/**
 * __usePingQuery__
 *
 * To run a query within a React component, call `usePingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingQuery({
 *   variables: {
 *   },
 * });
 */
export function usePingQuery(baseOptions) {
    return ApolloReactHooks.useQuery(PingDocument, baseOptions);
}
export function usePingLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(PingDocument, baseOptions);
}
export const RecipesDocument = gql `
    query Recipes($searchTerm: String!, $limit: Int) {
  recipes(searchTerm: $searchTerm, limit: $limit) {
    ...RecipeWithServings
    hasFullAccess
    org {
      id
      name
    }
    descendantFoods {
      ...Food
    }
    history {
      fromCompass
    }
  }
  orgGroupRecipes(searchTerm: $searchTerm, limit: $limit) {
    ...RecipeWithServings
    hasFullAccess
    org {
      id
      name
    }
    descendantFoods {
      ...Food
    }
    orgGroup {
      name
    }
    history {
      fromCompass
    }
  }
}
    ${RecipeWithServingsFragmentDoc}
${FoodFragmentDoc}`;
/**
 * __useRecipesQuery__
 *
 * To run a query within a React component, call `useRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecipesQuery(baseOptions) {
    return ApolloReactHooks.useQuery(RecipesDocument, baseOptions);
}
export function useRecipesLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(RecipesDocument, baseOptions);
}
export const SchedulesDefaultAndTeamDocument = gql `
    query SchedulesDefaultAndTeam($teamId: ID!) {
  schedules {
    ...FullSchedule
  }
  schedulesForTeam(teamId: $teamId) {
    ...FullSchedule
  }
}
    ${FullScheduleFragmentDoc}`;
/**
 * __useSchedulesDefaultAndTeamQuery__
 *
 * To run a query within a React component, call `useSchedulesDefaultAndTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulesDefaultAndTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulesDefaultAndTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useSchedulesDefaultAndTeamQuery(baseOptions) {
    return ApolloReactHooks.useQuery(SchedulesDefaultAndTeamDocument, baseOptions);
}
export function useSchedulesDefaultAndTeamLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(SchedulesDefaultAndTeamDocument, baseOptions);
}
export const SharedFoodGroupsDocument = gql `
    query SharedFoodGroups($searchTerm: String!, $limit: Int) {
  sharedFoodGroups(searchTerm: $searchTerm, limit: $limit) {
    ...FullFoodGroup
  }
}
    ${FullFoodGroupFragmentDoc}`;
/**
 * __useSharedFoodGroupsQuery__
 *
 * To run a query within a React component, call `useSharedFoodGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFoodGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFoodGroupsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSharedFoodGroupsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(SharedFoodGroupsDocument, baseOptions);
}
export function useSharedFoodGroupsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(SharedFoodGroupsDocument, baseOptions);
}
export const SimpleFoodsDocument = gql `
    query SimpleFoods($searchTerm: String!, $limit: Int, $localeCodes: [String!], $dataSources: [FoodDataSource!]) {
  foods(
    searchTerm: $searchTerm
    limit: $limit
    localeCodes: $localeCodes
    dataSources: $dataSources
  ) {
    ...Food
    ... on BrandedFood {
      __typename
    }
    ... on GenericFood {
      __typename
    }
  }
}
    ${FoodFragmentDoc}`;
/**
 * __useSimpleFoodsQuery__
 *
 * To run a query within a React component, call `useSimpleFoodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleFoodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleFoodsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *      localeCodes: // value for 'localeCodes'
 *      dataSources: // value for 'dataSources'
 *   },
 * });
 */
export function useSimpleFoodsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(SimpleFoodsDocument, baseOptions);
}
export function useSimpleFoodsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(SimpleFoodsDocument, baseOptions);
}
export const SlackFoodRequestsUrlDocument = gql `
    query SlackFoodRequestsUrl {
  slackFoodRequestsUrl
}
    `;
/**
 * __useSlackFoodRequestsUrlQuery__
 *
 * To run a query within a React component, call `useSlackFoodRequestsUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlackFoodRequestsUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlackFoodRequestsUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useSlackFoodRequestsUrlQuery(baseOptions) {
    return ApolloReactHooks.useQuery(SlackFoodRequestsUrlDocument, baseOptions);
}
export function useSlackFoodRequestsUrlLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(SlackFoodRequestsUrlDocument, baseOptions);
}
export const SportsDocument = gql `
    query Sports {
  sports {
    ...FullSport
  }
}
    ${FullSportFragmentDoc}`;
/**
 * __useSportsQuery__
 *
 * To run a query within a React component, call `useSportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSportsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(SportsDocument, baseOptions);
}
export function useSportsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(SportsDocument, baseOptions);
}
export const TeamAnthropometryDocument = gql `
    query TeamAnthropometry($id: ID!) {
  team(id: $id) {
    ...TeamWithSport
    athletes {
      ...Athlete
      position {
        ...Position
      }
      anthropometryEntries {
        ...AnthropometryEntry
      }
    }
  }
}
    ${TeamWithSportFragmentDoc}
${AthleteFragmentDoc}
${PositionFragmentDoc}
${AnthropometryEntryFragmentDoc}`;
/**
 * __useTeamAnthropometryQuery__
 *
 * To run a query within a React component, call `useTeamAnthropometryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamAnthropometryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamAnthropometryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamAnthropometryQuery(baseOptions) {
    return ApolloReactHooks.useQuery(TeamAnthropometryDocument, baseOptions);
}
export function useTeamAnthropometryLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(TeamAnthropometryDocument, baseOptions);
}
export const TeamRosterDocument = gql `
    query TeamRoster($id: ID!) {
  team(id: $id) {
    ...TeamWithSport
    athletes {
      ...Athlete
      position {
        ...Position
      }
    }
  }
}
    ${TeamWithSportFragmentDoc}
${AthleteFragmentDoc}
${PositionFragmentDoc}`;
/**
 * __useTeamRosterQuery__
 *
 * To run a query within a React component, call `useTeamRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamRosterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamRosterQuery(baseOptions) {
    return ApolloReactHooks.useQuery(TeamRosterDocument, baseOptions);
}
export function useTeamRosterLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(TeamRosterDocument, baseOptions);
}
export const NutritionixInstantSearchDocument = gql `
    query NutritionixInstantSearch($query: String!, $region: Int!, $localeCode: String!) {
  nutritionixBrandedInstantSearch(query: $query, region: $region) @rest(type: "NutritionixBrandedInstantSearchPayload", method: "GET", path: "/search/instant?query={args.query}&branded_region={args.region}&common=false", endpoint: "v2") {
    branded {
      ...NutritionixBrandedFood
    }
  }
  nutritionixCommonInstantSearch(query: $query, localeCode: $localeCode) @rest(type: "NutritionixCommonInstantSearchPayload", method: "GET", path: "/search/instant?query={args.query}&locale={args.localeCode}&branded=false", endpoint: "v2") {
    common {
      ...NutritionixCommonFood
    }
  }
}
    ${NutritionixBrandedFoodFragmentDoc}
${NutritionixCommonFoodFragmentDoc}`;
/**
 * __useNutritionixInstantSearchQuery__
 *
 * To run a query within a React component, call `useNutritionixInstantSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutritionixInstantSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutritionixInstantSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      region: // value for 'region'
 *      localeCode: // value for 'localeCode'
 *   },
 * });
 */
export function useNutritionixInstantSearchQuery(baseOptions) {
    return ApolloReactHooks.useQuery(NutritionixInstantSearchDocument, baseOptions);
}
export function useNutritionixInstantSearchLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(NutritionixInstantSearchDocument, baseOptions);
}
export const NutritionixBrandedInstantSearchDocument = gql `
    query NutritionixBrandedInstantSearch($query: String!, $region: Int!) {
  nutritionixBrandedInstantSearch(query: $query, region: $region) @rest(type: "NutritionixBrandedInstantSearchPayload", method: "GET", path: "/search/instant?query={args.query}&branded_region={args.region}&common=false", endpoint: "v2") {
    branded {
      ...NutritionixBrandedFood
    }
  }
}
    ${NutritionixBrandedFoodFragmentDoc}`;
/**
 * __useNutritionixBrandedInstantSearchQuery__
 *
 * To run a query within a React component, call `useNutritionixBrandedInstantSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutritionixBrandedInstantSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutritionixBrandedInstantSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useNutritionixBrandedInstantSearchQuery(baseOptions) {
    return ApolloReactHooks.useQuery(NutritionixBrandedInstantSearchDocument, baseOptions);
}
export function useNutritionixBrandedInstantSearchLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(NutritionixBrandedInstantSearchDocument, baseOptions);
}
export const NutritionixV1RestaurantSearchDocument = gql `
    query NutritionixV1RestaurantSearch($input: NutritionixV1RestaurantSearchInput!) {
  nutritionixV1RestaurantSearch(input: $input) @rest(type: "NutritionixV1RestaurantSearchPayload", method: "POST", path: "/", endpoint: "v1_search") {
    total
    branded {
      ...NutritionixBrandedFood
    }
  }
}
    ${NutritionixBrandedFoodFragmentDoc}`;
/**
 * __useNutritionixV1RestaurantSearchQuery__
 *
 * To run a query within a React component, call `useNutritionixV1RestaurantSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutritionixV1RestaurantSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutritionixV1RestaurantSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNutritionixV1RestaurantSearchQuery(baseOptions) {
    return ApolloReactHooks.useQuery(NutritionixV1RestaurantSearchDocument, baseOptions);
}
export function useNutritionixV1RestaurantSearchLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(NutritionixV1RestaurantSearchDocument, baseOptions);
}
export const UsdaFoodDetailsDocument = gql `
    query USDAFoodDetails($usdaFdcId: ID!, $apiKey: String!) {
  usdaFoodDetail(usdaFdcId: $usdaFdcId, apiKey: $apiKey) @rest(type: "USDAFoodDetail", method: "GET", path: "/{args.usdaFdcId}?api_key={args.apiKey}", endpoint: "v1") {
    ...USDAFoodDetail
  }
}
    ${UsdaFoodDetailFragmentDoc}`;
/**
 * __useUsdaFoodDetailsQuery__
 *
 * To run a query within a React component, call `useUsdaFoodDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsdaFoodDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsdaFoodDetailsQuery({
 *   variables: {
 *      usdaFdcId: // value for 'usdaFdcId'
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useUsdaFoodDetailsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(UsdaFoodDetailsDocument, baseOptions);
}
export function useUsdaFoodDetailsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(UsdaFoodDetailsDocument, baseOptions);
}
export const UsdaFoodsDocument = gql `
    query USDAFoods($searchTerm: String!, $apiKey: String!, $brandOwner: String!, $includedDataTypes: String!) {
  usdaFoods(
    searchTerm: $searchTerm
    apiKey: $apiKey
    brandOwner: $brandOwner
    includedDataTypes: $includedDataTypes
  ) @rest(type: "[USDAFood]", method: "GET", path: "/search?generalSearchInput={args.searchTerm}&api_key={args.apiKey}&brandOwner={args.brandOwner}&includeDataTypeList={args.includedDataTypes}", endpoint: "v1") {
    ...USDAFood
  }
}
    ${UsdaFoodFragmentDoc}`;
/**
 * __useUsdaFoodsQuery__
 *
 * To run a query within a React component, call `useUsdaFoodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsdaFoodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsdaFoodsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      apiKey: // value for 'apiKey'
 *      brandOwner: // value for 'brandOwner'
 *      includedDataTypes: // value for 'includedDataTypes'
 *   },
 * });
 */
export function useUsdaFoodsQuery(baseOptions) {
    return ApolloReactHooks.useQuery(UsdaFoodsDocument, baseOptions);
}
export function useUsdaFoodsLazyQuery(baseOptions) {
    return ApolloReactHooks.useLazyQuery(UsdaFoodsDocument, baseOptions);
}
export const AgreementFormFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        title: faker.internet.password(10, false, /[0-9A-Z]/),
        url: faker.internet.password(10, false, /[0-9A-Z]/),
        acceptAgreementText: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const CommentWithNotificationFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        notification: {
            id: faker.datatype.uuid(),
            viewedAt: faker.datatype.datetime().toISOString(),
        },
    };
};
export const MacroMealPlanDisplaySettingsFragmentFactory = () => {
    return {
        __typename: "MacroMealPlanDisplaySettings",
        dailyProgressViews: faker.helpers.arrayElement(["all", "hideNumbers", "none"]),
        mealProgressViews: faker.helpers.arrayElement(["all", "hideNumbers", "none"]),
    };
};
export const ExchangeMealPlanDisplaySettingsFragmentFactory = () => {
    return {
        __typename: "ExchangeMealPlanDisplaySettings",
        dailyProgressViewsForExchanges: faker.helpers.arrayElement(["all", "none"]),
        mealProgressViewsForExchanges: faker.helpers.arrayElement(["all", "none"]),
        dailyProgressViewsForMacros: faker.helpers.arrayElement(["all", "hideNumbers", "none"]),
        mealProgressViewsForMacros: faker.helpers.arrayElement(["all", "hideNumbers", "none"]),
    };
};
export const NoTargetsDisplaySettingsFragmentFactory = () => {
    return {
        dailyProgressViewsForMacros: faker.helpers.arrayElement(["all", "hideNumbers", "none"]),
        mealProgressViewsForMacros: faker.helpers.arrayElement(["all", "hideNumbers", "none"]),
    };
};
export const ExchangeSummaryLabelFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ExchangeAmount",
        amount: faker.datatype.float(),
        exchange: {
            __typename: "Exchange",
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
            shortName: faker.internet.password(10, false, /[0-9A-Z]/),
            type: faker.helpers.arrayElement(["starch", "fruit", "vegetable", "protein", "dairy", "fat"]),
            cho: faker.datatype.float(),
            pro: faker.datatype.float(),
            fat: faker.datatype.float(),
            kcal: faker.datatype.float(),
        },
    };
};
export const FeatureFlagsFragmentFactory = () => {
    return {
        athleteMenuSuggestions: faker.datatype.boolean(),
        clientCredentials: faker.datatype.boolean(),
        hasRestaurantMenus: faker.datatype.boolean(),
        restaurantLogging: faker.datatype.boolean(),
        teamworksSchedules: faker.datatype.boolean(),
        mealPlanSuggestions: faker.datatype.boolean(),
        prepPlan: faker.datatype.boolean(),
        foodCategory: faker.datatype.boolean(),
        pk2MenuBuilder: faker.datatype.boolean(),
        orgGroupRecipes: faker.datatype.boolean(),
        orgGroupFoods: faker.datatype.boolean(),
        performanceKitchen: faker.datatype.boolean(),
        printableTags: faker.datatype.boolean(),
        hubMenuCheckIn: faker.datatype.boolean(),
        goalTracker: faker.datatype.boolean(),
        dietitianOnlyMenus: faker.datatype.boolean(),
        bulkOrdering: faker.datatype.boolean(),
        ukMealPlanOptionSuggestions: faker.datatype.boolean(),
        digitalDisplays: faker.datatype.boolean(),
        selfServiceOnboarding: faker.datatype.boolean(),
        messaging: faker.datatype.boolean(),
        eatingDisorderScreens: faker.datatype.boolean(),
        profilesV3Api: faker.datatype.boolean(),
        educationResources: faker.datatype.boolean(),
        diningOptionInMenu: faker.datatype.boolean(),
        dietitianSupportForms: faker.datatype.boolean(),
    };
};
export const RecipeFoodCategoryFragmentFactory = () => {
    return {
        category: faker.helpers.arrayElement(["carbohydrate", "protein", "fats", "combination"]),
    };
};
export const MenuItemFoodCategoryFragmentFactory = () => {
    return {
        category: faker.helpers.arrayElement(["carbohydrate", "protein", "fats", "combination"]),
    };
};
export const MealMenuWithTimesFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        timezone: "America/New_York",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        start: faker.datatype.datetime().toISOString(),
        durationInMinutes: faker.datatype.number(),
        prepTimeInMinutes: faker.datatype.number(),
        lastOrderTimeBeforeEndInMinutes: faker.datatype.number(),
        isViewOnlyForMe: faker.datatype.boolean(),
        theme: faker.internet.password(10, false, /[0-9A-Z]/),
        isDiningOptionEnabled: faker.datatype.boolean(),
    };
};
export const MealMenuDiningStationWithItemPreviewsFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        maxAmount: faker.datatype.number(),
        position: faker.datatype.number(),
        menuItemAppearances: [{
                ...MenuItemAppearancePreviewFragmentFactory(),
            }],
    };
};
export const MenuItemAppearancePreviewFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        position: faker.datatype.number(),
        maxAmount: faker.datatype.number(),
        availableForOrder: faker.datatype.boolean(),
        allowSpecialRequests: faker.datatype.boolean(),
        menuItem: {
            ...MenuItemPreviewFragmentFactory(),
        },
    };
};
export const MenuItemPreviewFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "MenuItem",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        servingName: faker.internet.password(10, false, /[0-9A-Z]/),
        description: faker.internet.password(10, false, /[0-9A-Z]/),
        imageUrl: faker.internet.password(10, false, /[0-9A-Z]/),
        isOneOff: faker.datatype.boolean(),
        defaultAvailableForOrder: faker.datatype.boolean(),
        defaultAllowSpecialRequests: faker.datatype.boolean(),
        defaultMaxAmount: faker.datatype.number(),
        isDeleted: faker.datatype.boolean(),
        servingAmounts: [{
                id: faker.datatype.uuid(),
                serving: {
                    id: faker.datatype.uuid(),
                    foodOrRecipe: {
                        ...FoodOrRecipePreferencesFragmentFactory(),
                    },
                },
            }],
        score: {
            ...ScoreAssignmentFragmentFactory(),
        },
        foodCategory: {
            ...FoodCategoryNameFragmentFactory(),
        },
    };
};
export const MenuOrderRateLimitRemainderFragmentFactory = () => {
    return {
        start: faker.datatype.datetime().toISOString(),
        remaining: faker.datatype.number(),
    };
};
export const MealMenuLogItemFormFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        ...MenuSelectionItemFormFragmentFactory(),
    };
};
export const ViewMealOptionFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "MealOption",
        note: faker.internet.password(10, false, /[0-9A-Z]/),
        position: faker.datatype.number(),
        servingAmounts: [{
                ...FullServingAmountFragmentFactory(),
            }],
    };
};
export const MealTemplateForTargetsFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        ...({
            __typename: "ExchangeMealTemplate",
            exchangeTargets: [{
                    ...ExchangeAmountFragmentFactory(),
                }],
        }),
    };
};
export const ExchangeMealTemplateViewFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ExchangeMealTemplate",
        mealOptions: [{
                ...ViewMealOptionFragmentFactory(),
            }],
        exchangeTargets: [{
                ...ExchangeAmountFragmentFactory(),
            }],
        meal: {
            ...MealFragmentFactory(),
        },
    };
};
export const MacroMealTemplateViewFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "MacroMealTemplate",
        mealOptions: [{
                ...ViewMealOptionFragmentFactory(),
            }],
        meal: {
            ...MealFragmentFactory(),
        },
        cho: faker.datatype.float(),
        pro: faker.datatype.float(),
        fat: faker.datatype.float(),
        kcal: faker.datatype.float(),
    };
};
export const MenuItemWithIdsFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        choices: [{
                id: faker.datatype.uuid(),
                options: [{
                        id: faker.datatype.uuid(),
                    }],
            }],
    };
};
export const MenuSelectionItemOptionWithIdsFragmentFactory = () => {
    return {
        amount: faker.datatype.float(),
        menuItemChoiceOption: {
            id: faker.datatype.uuid(),
        },
        percentConsumed: faker.datatype.float(),
    };
};
export const MenuItemFormFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        history: {
            fromCompass: faker.datatype.boolean(),
        },
        __typename: "MenuItem",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        servingName: faker.internet.password(10, false, /[0-9A-Z]/),
        description: faker.internet.password(10, false, /[0-9A-Z]/),
        isOneOff: faker.datatype.boolean(),
        servingAmounts: [{
                ...FullServingAmountFragmentFactory(),
            }],
        choices: [{
                ...MenuItemChoiceFormFragmentFactory(),
            }],
        imageUrl: faker.internet.password(10, false, /[0-9A-Z]/),
        suggestionCategory: faker.helpers.arrayElement(["combo", "main", "protein", "starch", "vegetable", "fruit", "other"]),
        defaultMaxAmount: faker.datatype.number(),
        defaultAvailableForOrder: faker.datatype.boolean(),
        defaultAllowSpecialRequests: faker.datatype.boolean(),
        isDeleted: faker.datatype.boolean(),
        score: {
            ...ScoreAssignmentFragmentFactory(),
        },
        foodCategory: {
            ...FoodCategoryNameFragmentFactory(),
        },
    };
};
export const MenuItemChoiceFormFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        position: faker.datatype.number(),
        required: faker.datatype.boolean(),
        maxOptionsCount: faker.datatype.number(),
        options: [{
                ...MenuItemChoiceOptionFormFragmentFactory(),
            }],
    };
};
export const MenuItemChoiceOptionFormFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        position: faker.datatype.number(),
        canEditAmount: faker.datatype.boolean(),
        defaultAmount: faker.datatype.float(),
        maxAmount: faker.datatype.float(),
        servingAmounts: [{
                ...FullServingAmountFragmentFactory(),
            }],
    };
};
export const FoodCategoryNameFragmentFactory = () => {
    return {
        category: faker.helpers.arrayElement(["carbohydrate", "protein", "fats", "combination"]),
    };
};
export const MenuOrderItemFormFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        forOrder: faker.datatype.boolean(),
        status: faker.helpers.arrayElement(["new", "cooking", "done", "cancelled"]),
        specialRequests: faker.internet.password(10, false, /[0-9A-Z]/),
        rating: {
            ...RatingFragmentFactory(),
        },
        ...MenuSelectionItemFormFragmentFactory(),
    };
};
export const RatingFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        review: faker.internet.password(10, false, /[0-9A-Z]/),
        value: faker.helpers.arrayElement(["one", "two", "three", "four", "five"]),
    };
};
export const MenuSelectionFormFragmentFactory = () => {
    return {
        items: [{
                ...MenuSelectionItemFormFragmentFactory(),
            }],
    };
};
export const MenuSelectionItemWithMacrosFragmentFactory = () => {
    return {
        amount: faker.datatype.float(),
        percentConsumed: faker.datatype.float(),
        menuItem: {
            id: faker.datatype.uuid(),
            servingAmounts: [{
                    ...FullServingAmountFragmentFactory(),
                }],
        },
        options: [{
                ...MenuSelectItemOptionWithMacrosFragmentFactory(),
            }],
    };
};
export const MenuSelectItemOptionWithMacrosFragmentFactory = () => {
    return {
        amount: faker.datatype.float(),
        percentConsumed: faker.datatype.float(),
        menuItemChoiceOption: {
            id: faker.datatype.uuid(),
            servingAmounts: [{
                    ...FullServingAmountFragmentFactory(),
                }],
        },
    };
};
export const MenuSelectionItemFormFragmentFactory = () => {
    return {
        amount: faker.datatype.float(),
        percentConsumed: faker.datatype.float(),
        menuItem: {
            ...MenuItemFormFragmentFactory(),
        },
        options: [{
                ...MenuSelectionItemOptionFormFragmentFactory(),
            }],
    };
};
export const MenuSelectionItemOptionFormFragmentFactory = () => {
    return {
        amount: faker.datatype.float(),
        percentConsumed: faker.datatype.float(),
        menuItemChoiceOption: {
            ...MenuItemChoiceOptionFormFragmentFactory(),
        },
    };
};
export const MenuOrderSuggestionFragmentFactory = () => {
    return {
        items: [{
                amount: faker.datatype.float(),
                percentConsumed: faker.datatype.float(),
                menuItem: {
                    ...MenuItemFormFragmentFactory(),
                },
                options: [{
                        amount: faker.datatype.float(),
                        percentConsumed: faker.datatype.float(),
                        menuItemChoiceOption: {
                            ...MenuItemChoiceOptionFormFragmentFactory(),
                        },
                    }],
            }],
    };
};
export const ServingWithNutrientAmountsFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        nutrientAmounts: [{
                ...NutrientAmountFragmentFactory(),
            }],
        foodOrRecipe: {
            ...({
                id: faker.datatype.uuid(),
                name: faker.internet.password(10, false, /[0-9A-Z]/),
            }),
        },
    };
};
export const NutrientAmountFragmentFactory = () => {
    return {
        amount: faker.datatype.float(),
        nutrient: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
    };
};
export const NutrientWithDriFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        unitName: faker.internet.password(10, false, /[0-9A-Z]/),
        defaultDietaryReferenceIntake: {
            id: faker.datatype.uuid(),
            type: faker.helpers.arrayElement(["RDA", "UL", "AI", "DGA", "unitsPerKcal"]),
            amount: faker.datatype.float(),
        },
    };
};
export const RestaurantMenuWithItemPreviewsFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        sections: [{
                id: faker.datatype.uuid(),
                name: faker.internet.password(10, false, /[0-9A-Z]/),
                position: faker.datatype.number(),
                menuItemAppearances: [{
                        ...MenuItemAppearancePreviewFragmentFactory(),
                    }],
            }],
    };
};
export const RestaurantMenuLinkWithMyOrdersFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        allowCustomOrders: faker.datatype.boolean(),
        allowPlateOrders: faker.datatype.boolean(),
        restaurant: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        order: {
            ...RestaurantMenuLinkOrderFragmentFactory(),
        },
        plateOrder: {
            ...RestaurantMenuLinkPlateOrderFragmentFactory(),
        },
    };
};
export const RestaurantMenuLinkWithOrdersForAthleteFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        allowCustomOrders: faker.datatype.boolean(),
        allowPlateOrders: faker.datatype.boolean(),
        restaurant: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        order: {
            ...RestaurantMenuLinkOrderFragmentFactory(),
        },
        plateOrder: {
            ...RestaurantMenuLinkPlateOrderFragmentFactory(),
        },
    };
};
export const RestaurantMenuLinkWithItemPreviewsFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        allowCustomOrders: faker.datatype.boolean(),
        allowPlateOrders: faker.datatype.boolean(),
        restaurant: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        sections: [{
                restaurantMenuSection: {
                    id: faker.datatype.uuid(),
                    name: faker.internet.password(10, false, /[0-9A-Z]/),
                    position: faker.datatype.number(),
                },
                maxAmount: faker.datatype.number(),
                menuItemAppearances: [{
                        ...MenuItemAppearancePreviewFragmentFactory(),
                    }],
            }],
        plates: [{
                ...RestaurantMenuLinkPlateFragmentFactory(),
            }],
    };
};
export const RestaurantMenuLinkPlateFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        items: [{
                ...RestaurantMenuLinkPlateItemFormFragmentFactory(),
            }],
        position: faker.datatype.number(),
    };
};
export const RestaurantMenuLinkOrderFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        items: [{
                ...RestaurantMenuLinkOrderItemFormFragmentFactory(),
            }],
    };
};
export const RestaurantMenuLinkOrderItemFormFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        specialRequests: faker.internet.password(10, false, /[0-9A-Z]/),
        ...MenuSelectionItemFormFragmentFactory(),
    };
};
export const RestaurantMenuLinkPlateItemFormFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        position: faker.datatype.number(),
        specialRequests: faker.internet.password(10, false, /[0-9A-Z]/),
        ...MenuSelectionItemFormFragmentFactory(),
    };
};
export const RestaurantMenuLinkPlateOrderFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        userFullName: faker.internet.password(10, false, /[0-9A-Z]/),
        items: [{
                ...RestaurantMenuLinkPlateOrderItemFormFragmentFactory(),
            }],
        plate: {
            id: faker.datatype.uuid(),
            items: [{
                    ...RestaurantMenuLinkPlateItemFormFragmentFactory(),
                }],
            position: faker.datatype.number(),
        },
        restaurantMenuLink: {
            id: faker.datatype.uuid(),
        },
    };
};
export const RestaurantMenuLinkPlateOrderItemFormFragmentFactory = () => {
    return {
        amount: faker.datatype.float(),
        percentConsumed: faker.datatype.float(),
        plateItem: {
            id: faker.datatype.uuid(),
        },
        menuItem: {
            ...MenuItemFormFragmentFactory(),
        },
        options: [{
                ...RestaurantMenuLinkPlateOrderItemOptionFormFragmentFactory(),
            }],
    };
};
export const RestaurantMenuLinkPlateOrderItemOptionFormFragmentFactory = () => {
    return {
        amount: faker.datatype.float(),
        percentConsumed: faker.datatype.float(),
        menuItemChoiceOption: {
            ...MenuItemChoiceOptionFormFragmentFactory(),
        },
    };
};
export const RestaurantMenuLogFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        mealTemplate: {
            id: faker.datatype.uuid(),
        },
        items: [{
                ...RestaurantMenuLogItemFormFragmentFactory(),
            }],
        restaurantMenu: {
            id: faker.datatype.uuid(),
        },
        dateTime: faker.datatype.datetime().toISOString(),
        timezone: "America/New_York",
        type: faker.helpers.arrayElement(["breakfast", "lunch", "dinner", "snack", "meal"]),
    };
};
export const RestaurantMenuLogItemFormFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        ...MenuSelectionItemFormFragmentFactory(),
    };
};
export const ScoreAssignmentFragmentFactory = () => {
    return {
        value: faker.datatype.float(),
        scoringSystem: {
            ...ScoringSystemAssignmentFragmentFactory(),
        },
    };
};
export const ScoringSystemAssignmentFragmentFactory = () => {
    return {
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        id: faker.datatype.uuid(),
    };
};
export const ScoringSystemFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const ServingWithFoodOrRecipeMacrosFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Serving",
        macros: {
            cho: faker.datatype.float(),
            pro: faker.datatype.float(),
            fat: faker.datatype.float(),
            kcal: faker.datatype.float(),
        },
        foodOrRecipe: {
            __typename: "BrandedFood",
            ...({
                id: faker.datatype.uuid(),
                name: faker.internet.password(10, false, /[0-9A-Z]/),
                usdaFdcDescription: faker.internet.password(10, false, /[0-9A-Z]/),
            }),
        },
    };
};
export const RecipeIngredientServingAmountFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        amount: faker.datatype.float(),
        position: faker.datatype.number(),
        serving: {
            ...RecipeIngredientServingFragmentFactory(),
        },
    };
};
export const TimelineItemForGroupByDateFragmentFactory = () => {
    return {
        ...({
            id: faker.datatype.uuid(),
            __typename: "FoodLogMeal",
        }),
    };
};
export const TimelineMealForGroupByDateFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        start: faker.datatype.datetime().toISOString(),
        timezone: "America/New_York",
        notifications: [{
                ...NotificationTimelineFragmentFactory(),
            }],
    };
};
export const NotificationTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "AthleteSelfOnboardedNotification",
        viewedAt: faker.datatype.datetime().toISOString(),
    };
};
export const MealMenuSharedTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "StandaloneMealMenu",
        mealType: faker.helpers.arrayElement(["breakfast", "lunch", "dinner", "snack", "meal"]),
        timezone: "America/New_York",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        start: faker.datatype.datetime().toISOString(),
        durationInMinutes: faker.datatype.number(),
        prepTimeInMinutes: faker.datatype.number(),
        lastOrderTimeBeforeEndInMinutes: faker.datatype.number(),
        isLogOnly: faker.datatype.boolean(),
        isInHouseMenuOrderable: faker.datatype.boolean(),
        isRestaurantMenuOrderable: faker.datatype.boolean(),
        isViewOnlyForMe: faker.datatype.boolean(),
        isDiningOptionEnabled: faker.datatype.boolean(),
        isBulkOrderable: faker.datatype.boolean(),
        restaurantMenuLinks: [{
                id: faker.datatype.uuid(),
                allowCustomOrders: faker.datatype.boolean(),
                allowPlateOrders: faker.datatype.boolean(),
                restaurant: {
                    id: faker.datatype.uuid(),
                    name: faker.internet.password(10, false, /[0-9A-Z]/),
                },
            }],
    };
};
export const RestaurantMenuLinkOrderSharedTimelineFragmentFactory = () => {
    return {
        ...RestaurantMenuLinkOrderFragmentFactory(),
        mealMenu: {
            id: faker.datatype.uuid(),
        },
        restaurantMenuLink: {
            id: faker.datatype.uuid(),
            restaurant: {
                id: faker.datatype.uuid(),
                name: faker.internet.password(10, false, /[0-9A-Z]/),
            },
        },
    };
};
export const RestaurantMenuLinkPlateOrderSharedTimelineFragmentFactory = () => {
    return {
        ...RestaurantMenuLinkPlateOrderFragmentFactory(),
        mealMenu: {
            ...MealMenuWithTimesFragmentFactory(),
        },
        restaurantMenuLink: {
            id: faker.datatype.uuid(),
            restaurant: {
                id: faker.datatype.uuid(),
                name: faker.internet.password(10, false, /[0-9A-Z]/),
            },
        },
    };
};
export const MenuOrderSharedTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "MenuOrder",
        mealMenu: {
            id: faker.datatype.uuid(),
        },
    };
};
export const MealMenuLogSharedTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "MealMenuLog",
        mealMenu: {
            id: faker.datatype.uuid(),
        },
    };
};
export const MealPlanDateSharedTimelineFragmentFactory = () => {
    return {
        __typename: "MealPlanDate",
        date: faker.datatype.datetime().toISOString().split("T")[0],
        timezone: "America/New_York",
        mealPlan: {
            ...MealPlanSharedTimelineFragmentFactory(),
        },
    };
};
export const MealPlanSharedTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        mealTemplates: [{
                ...MealTemplateSharedTimelineFragmentFactory(),
            }],
        activityTemplates: [{
                ...ActivityTemplateSharedTimelineFragmentFactory(),
            }],
    };
};
export const MealTemplateSharedTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        meal: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
            start: faker.datatype.datetime().toISOString().split("T")[1],
            end: faker.datatype.datetime().toISOString().split("T")[1],
            type: faker.helpers.arrayElement(["breakfast", "lunch", "dinner", "snack", "meal"]),
        },
        ...({
            __typename: "ExchangeMealTemplate",
        }),
    };
};
export const ActivityTemplateSharedTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ActivityTemplate",
        activity: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
            start: faker.datatype.datetime().toISOString().split("T")[1],
            end: faker.datatype.datetime().toISOString().split("T")[1],
            type: faker.helpers.arrayElement(["practice", "lift", "conditioning", "competition", "class"]),
        },
    };
};
export const TimelineMealSharedTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "TimelineMeal",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        type: faker.helpers.arrayElement(["breakfast", "lunch", "dinner", "snack", "meal"]),
        timezone: "America/New_York",
        start: faker.datatype.datetime().toISOString(),
        durationInMinutes: faker.datatype.number(),
        mealTemplate: {
            id: faker.datatype.uuid(),
        },
        mealMenus: [{
                ...MealMenuSharedTimelineFragmentFactory(),
            }],
        servingAmounts: [{
                ...FullServingAmountFragmentFactory(),
            }],
        restaurantMenuLogs: [{
                ...RestaurantMenuLogSharedTimelineFragmentFactory(),
            }],
        restaurantMenuLinkPlateOrders: [{
                ...RestaurantMenuLinkPlateOrderSharedTimelineFragmentFactory(),
            }],
        restaurantMenuLinkOrders: [{
                ...RestaurantMenuLinkOrderSharedTimelineFragmentFactory(),
            }],
        menuOrders: [{
                ...MenuOrderSharedTimelineFragmentFactory(),
            }],
        mealMenuLogs: [{
                ...MealMenuLogSharedTimelineFragmentFactory(),
            }],
    };
};
export const FoodLogActivitySharedTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "FoodLogActivity",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        activityType: faker.helpers.arrayElement(["practice", "lift", "conditioning", "competition", "class"]),
        startTime: faker.datatype.datetime().toISOString().split("T")[1],
        endTime: faker.datatype.datetime().toISOString().split("T")[1],
        timezone: "America/New_York",
        activityTemplate: {
            id: faker.datatype.uuid(),
        },
    };
};
export const RestaurantMenuLogSharedTimelineFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "RestaurantMenuLog",
        mealType: faker.helpers.arrayElement(["breakfast", "lunch", "dinner", "snack", "meal"]),
        dateTime: faker.datatype.datetime().toISOString(),
        timezone: "America/New_York",
        items: [{
                id: faker.datatype.uuid(),
                ...MenuSelectionItemFormFragmentFactory(),
            }],
    };
};
export const UnitFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const UnitWithConversionsFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        conversionsFrom: [{
                id: faker.datatype.uuid(),
                fromQuantity: faker.datatype.float(),
                toQuantity: faker.datatype.float(),
                toUnit: {
                    ...UnitFragmentFactory(),
                    isProductionOnly: faker.datatype.boolean(),
                },
            }],
    };
};
export const ActivityFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Activity",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        start: faker.datatype.datetime().toISOString().split("T")[1],
        end: faker.datatype.datetime().toISOString().split("T")[1],
        type: faker.helpers.arrayElement(["practice", "lift", "conditioning", "competition", "class"]),
    };
};
export const ActivityTemplateFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ActivityTemplate",
        activity: {
            ...ActivityFragmentFactory(),
        },
    };
};
export const AnthropometryEntryFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "AnthropometryEntry",
        height: faker.datatype.float(),
        weight: faker.datatype.float(),
        leanBodyMass: faker.datatype.float(),
        bodyFatMass: faker.datatype.float(),
        percentBodyFat: faker.datatype.float(),
        datetime: faker.datatype.datetime().toISOString(),
        type: faker.helpers.arrayElement(["estimate", "dexa", "bodpod", "bioelectricalImpedance", "isak", "weighIn"]),
        sex: faker.helpers.arrayElement(["male", "female"]),
        comment: faker.internet.password(10, false, /[0-9A-Z]/),
        boneMineralDensity: faker.datatype.float(),
        boneMineralDensityZScore: faker.datatype.float(),
        boneMineralDensityTScore: faker.datatype.float(),
        boneMineralContent: faker.datatype.float(),
        boneArea: faker.datatype.float(),
        boneMass: faker.datatype.float(),
        dryLeanMass: faker.datatype.float(),
        skeletalMuscleMass: faker.datatype.float(),
        trunkFat: faker.datatype.float(),
        visceralFatArea: faker.datatype.float(),
        heightInCm: faker.datatype.float(),
        weightInKg: faker.datatype.float(),
        leanBodyMassInKg: faker.datatype.float(),
        bodyFatMassInKg: faker.datatype.float(),
        skeletalMuscleMassInKg: faker.datatype.float(),
        trunkFatInKg: faker.datatype.float(),
        dryLeanMassInKg: faker.datatype.float(),
    };
};
export const AthleteFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Athlete",
        firstName: faker.internet.password(10, false, /[0-9A-Z]/),
        lastName: faker.internet.password(10, false, /[0-9A-Z]/),
        sex: faker.helpers.arrayElement(["male", "female"]),
        birthDate: faker.datatype.datetime().toISOString().split("T")[0],
        phoneNumber: faker.internet.password(10, false, /[0-9A-Z]/),
        email: faker.internet.password(10, false, /[0-9A-Z]/),
        headshotUrl: faker.internet.password(10, false, /[0-9A-Z]/),
        secaUid: faker.internet.password(10, false, /[0-9A-Z]/),
        inbodyUid: faker.internet.password(10, false, /[0-9A-Z]/),
        isArchived: faker.datatype.boolean(),
        activationLinkSent: faker.datatype.datetime().toISOString(),
        jerseyNumber: faker.internet.password(10, false, /[0-9A-Z]/),
        isProfileNotemealOnly: faker.datatype.boolean(),
    };
};
export const AthleteWithMealPlansFragmentFactory = () => {
    return {
        ...AthleteFragmentFactory(),
        mealPlans: [{
                ...MealPlanSearchFormFragmentFactory(),
            }],
    };
};
export const AthleteWithGoalAndAnthroFragmentFactory = () => {
    return {
        ...AthleteFragmentFactory(),
        position: {
            ...PositionFragmentFactory(),
        },
        mostRecentAnthropometryEntry: {
            ...AnthropometryEntryFragmentFactory(),
        },
        currentGoal: {
            ...FullGoalFragmentFactory(),
        },
    };
};
export const AthleteWithFoodPrefsFragmentFactory = () => {
    return {
        ...AthleteFragmentFactory(),
        likedFoods: [{
                ...FoodFragmentFactory(),
            }],
        dislikedFoods: [{
                ...FoodFragmentFactory(),
            }],
        likedFoodGroups: [{
                ...FullFoodGroupWithFoodsFragmentFactory(),
            }],
        dislikedFoodGroups: [{
                ...FullFoodGroupWithFoodsFragmentFactory(),
            }],
    };
};
export const BrandFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Brand",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaManufacturerName: faker.internet.password(10, false, /[0-9A-Z]/),
        foodCount: faker.datatype.number(),
    };
};
export const CalorieBudgetFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "CalorieBudget",
        rmrMethod: faker.helpers.arrayElement(["cunningham", "mifflin", "harrisBenedict", "average"]),
        rmrCalories: faker.datatype.number(),
        activityFactor: faker.datatype.float(),
        kcalOffset: faker.datatype.number(),
    };
};
export const FullCalorieBudgetFragmentFactory = () => {
    return {
        ...CalorieBudgetFragmentFactory(),
        goalSnapshot: {
            ...FullGoalFragmentFactory(),
        },
    };
};
export const ExchangeFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Exchange",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        shortName: faker.internet.password(10, false, /[0-9A-Z]/),
        type: faker.helpers.arrayElement(["starch", "fruit", "vegetable", "protein", "dairy", "fat"]),
        cho: faker.datatype.float(),
        pro: faker.datatype.float(),
        fat: faker.datatype.float(),
        kcal: faker.datatype.float(),
    };
};
export const FullExchangeFragmentFactory = () => {
    return {
        ...ExchangeFragmentFactory(),
        exchangeServingList: {
            ...FullExchangeServingListFragmentFactory(),
        },
    };
};
export const ExchangeAmountFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ExchangeAmount",
        amount: faker.datatype.float(),
        pickListServingIds: [faker.datatype.uuid()],
        exchange: {
            ...ExchangeFragmentFactory(),
        },
    };
};
export const EditExchangeAmountFragmentFactory = () => {
    return {
        ...ExchangeAmountFragmentFactory(),
        amountInput: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const ExchangeMealTemplateFragmentFactory = () => {
    return {
        ...MealTemplateFragmentFactory(),
        __typename: "ExchangeMealTemplate",
    };
};
export const FullExchangeMealTemplateFragmentFactory = () => {
    return {
        ...FullMealTemplateFragmentFactory(),
        ...ExchangeMealTemplateFragmentFactory(),
        exchangeTargets: [{
                ...ExchangeAmountFragmentFactory(),
            }],
    };
};
export const EditExchangeMealTemplateFragmentFactory = () => {
    return {
        ...EditMealTemplateFragmentFactory(),
        exchangeTargets: [{
                ...EditExchangeAmountFragmentFactory(),
            }],
    };
};
export const EditFullExchangeMealTemplateFragmentFactory = () => {
    return {
        ...EditFullMealTemplateFragmentFactory(),
        ...ExchangeMealTemplateFragmentFactory(),
        ...EditExchangeMealTemplateFragmentFactory(),
    };
};
export const ExchangeRatioFragmentFactory = () => {
    return {
        __typename: "ExchangeRatio",
        ratio: faker.datatype.float(),
        exchange: {
            ...ExchangeFragmentFactory(),
        },
    };
};
export const FoodOrRecipeExchangeRatiosFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "FoodOrRecipeExchangeRatios",
        foodOrRecipeId: faker.datatype.uuid(),
        exchangeRatios: [{
                ...ExchangeRatioFragmentFactory(),
            }],
    };
};
export const ExchangeServingListFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ExchangeServingList",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const FullExchangeServingListFragmentFactory = () => {
    return {
        ...ExchangeServingListFragmentFactory(),
        servingAmounts: [{
                ...FullServingAmountFragmentFactory(),
            }],
    };
};
export const ExchangeSetFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ExchangeSet",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        createdBy: {
            id: faker.datatype.uuid(),
            firstName: faker.internet.password(10, false, /[0-9A-Z]/),
            lastName: faker.internet.password(10, false, /[0-9A-Z]/),
        },
    };
};
export const ExchangeSetWithExchangesFragmentFactory = () => {
    return {
        ...ExchangeSetFragmentFactory(),
        exchanges: [{
                ...ExchangeFragmentFactory(),
            }],
    };
};
export const FullExchangeSetWithoutExchangeRatiosFragmentFactory = () => {
    return {
        ...ExchangeSetFragmentFactory(),
        exchanges: [{
                ...FullExchangeFragmentFactory(),
            }],
    };
};
export const FullExchangeSetFragmentFactory = () => {
    return {
        ...FullExchangeSetWithoutExchangeRatiosFragmentFactory(),
        foodOrRecipeExchangeRatios: [{
                id: faker.datatype.uuid(),
                foodOrRecipeId: faker.datatype.uuid(),
                __typename: "FoodOrRecipeExchangeRatios",
                exchangeRatios: [{
                        __typename: "ExchangeRatio",
                        ratio: faker.datatype.float(),
                        exchange: {
                            ...ExchangeFragmentFactory(),
                        },
                    }],
            }],
    };
};
export const FoodFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "BrandedFood",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        exchangeTypes: [faker.helpers.arrayElement(["starch", "fruit", "vegetable", "protein", "dairy", "fat"])],
        nixItemId: faker.internet.password(10, false, /[0-9A-Z]/),
        nixTagId: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaFdcDescription: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaFdcFoodCategoryId: faker.datatype.number(),
        usdaFdcDataType: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaFdcId: faker.datatype.number(),
        isRecipeIngredientOnly: faker.datatype.boolean(),
        choPer100g: faker.datatype.float(),
        proPer100g: faker.datatype.float(),
        fatPer100g: faker.datatype.float(),
        kcalPer100g: faker.datatype.float(),
        thumbnailUrl: faker.internet.password(10, false, /[0-9A-Z]/),
        locales: [faker.internet.password(10, false, /[0-9A-Z]/)],
    };
};
export const FoodLimitedAccessFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "BrandedFood",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaFdcDescription: faker.internet.password(10, false, /[0-9A-Z]/),
        exchangeTypes: [faker.helpers.arrayElement(["starch", "fruit", "vegetable", "protein", "dairy", "fat"])],
        thumbnailUrl: faker.internet.password(10, false, /[0-9A-Z]/),
        hasFullAccess: faker.datatype.boolean(),
        nixItemId: faker.internet.password(10, false, /[0-9A-Z]/),
        nixTagId: faker.internet.password(10, false, /[0-9A-Z]/),
        org: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        ...({
            brand: {
                id: faker.datatype.uuid(),
                name: faker.internet.password(10, false, /[0-9A-Z]/),
            },
        }),
    };
};
export const FoodPreviewFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const BrandedFoodFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "BrandedFood",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        exchangeTypes: [faker.helpers.arrayElement(["starch", "fruit", "vegetable", "protein", "dairy", "fat"])],
        usdaFdcDescription: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaFdcFoodCategoryId: faker.datatype.number(),
        usdaFdcDataType: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaFdcId: faker.datatype.number(),
        isRecipeIngredientOnly: faker.datatype.boolean(),
        nixItemId: faker.internet.password(10, false, /[0-9A-Z]/),
        nixTagId: faker.internet.password(10, false, /[0-9A-Z]/),
        choPer100g: faker.datatype.float(),
        proPer100g: faker.datatype.float(),
        fatPer100g: faker.datatype.float(),
        kcalPer100g: faker.datatype.float(),
        thumbnailUrl: faker.internet.password(10, false, /[0-9A-Z]/),
        groceryListCategory: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
    };
};
export const GenericFoodFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "GenericFood",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        exchangeTypes: [faker.helpers.arrayElement(["starch", "fruit", "vegetable", "protein", "dairy", "fat"])],
        nixItemId: faker.internet.password(10, false, /[0-9A-Z]/),
        nixTagId: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaFdcDescription: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaFdcFoodCategoryId: faker.datatype.number(),
        usdaFdcDataType: faker.internet.password(10, false, /[0-9A-Z]/),
        usdaFdcId: faker.datatype.number(),
        isRecipeIngredientOnly: faker.datatype.boolean(),
        choPer100g: faker.datatype.float(),
        proPer100g: faker.datatype.float(),
        fatPer100g: faker.datatype.float(),
        kcalPer100g: faker.datatype.float(),
        thumbnailUrl: faker.internet.password(10, false, /[0-9A-Z]/),
        groceryListCategory: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        owner: {
            id: faker.datatype.uuid(),
            firstName: faker.internet.password(10, false, /[0-9A-Z]/),
            lastName: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        orgGroup: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
    };
};
export const FoodWithDefaultServingFragmentFactory = () => {
    return {
        ...FoodFragmentFactory(),
        defaultServing: {
            ...FullServingFragmentFactory(),
        },
        hasFullAccess: faker.datatype.boolean(),
        org: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        ...({
            __typename: "BrandedFood",
            brand: {
                ...BrandFragmentFactory(),
            },
        }),
    };
};
export const FoodWithServingsFragmentFactory = () => {
    return {
        ...FoodFragmentFactory(),
        showGramServing: faker.datatype.boolean(),
        showOunceServing: faker.datatype.boolean(),
        servings: [{
                ...ServingWithFoodOrRecipeFragmentFactory(),
            }],
    };
};
export const FullFoodGroupFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "FoodGroup",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        source: faker.internet.password(10, false, /[0-9A-Z]/),
        foodsCount: faker.datatype.number(),
    };
};
export const FullFoodGroupWithFoodsFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "FoodGroup",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        source: faker.internet.password(10, false, /[0-9A-Z]/),
        foodsCount: faker.datatype.number(),
        foods: [{
                ...FoodLimitedAccessFragmentFactory(),
            }],
    };
};
export const FoodLogNotificationSettingsFragmentFactory = () => {
    return {
        edits: faker.datatype.boolean(),
        imageUploads: faker.datatype.boolean(),
        messages: faker.datatype.boolean(),
    };
};
export const GoalFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Goal",
        kcalOffset: faker.datatype.number(),
        start: faker.datatype.datetime().toISOString().split("T")[0],
        end: faker.datatype.datetime().toISOString().split("T")[0],
    };
};
export const FullGoalFragmentFactory = () => {
    return {
        ...GoalFragmentFactory(),
        type: {
            ...GoalTypeFragmentFactory(),
        },
    };
};
export const GoalTypeFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "GoalType",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        defaultKcalOffset: faker.datatype.number(),
    };
};
export const ImageFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        position: faker.datatype.number(),
        url: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const MacroMathFragmentFactory = () => {
    return {
        gPerKg: faker.datatype.float(),
        leftOverRatio: faker.datatype.float(),
    };
};
export const MacroMealTemplateFragmentFactory = () => {
    return {
        ...MealTemplateFragmentFactory(),
        __typename: "MacroMealTemplate",
        cho: faker.datatype.float(),
        pro: faker.datatype.float(),
        fat: faker.datatype.float(),
        kcal: faker.datatype.float(),
    };
};
export const FullMacroMealTemplateFragmentFactory = () => {
    return {
        ...FullMealTemplateFragmentFactory(),
        ...MacroMealTemplateFragmentFactory(),
    };
};
export const EditMacroMealTemplateFragmentFactory = () => {
    return {
        ...EditMealTemplateFragmentFactory(),
        choInput: faker.internet.password(10, false, /[0-9A-Z]/),
        proInput: faker.internet.password(10, false, /[0-9A-Z]/),
        fatInput: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const EditFullMacroMealTemplateFragmentFactory = () => {
    return {
        ...EditFullMealTemplateFragmentFactory(),
        ...MacroMealTemplateFragmentFactory(),
        ...EditMacroMealTemplateFragmentFactory(),
    };
};
export const MacroProtocolFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "MacroProtocol",
        cho: {
            ...MacroMathFragmentFactory(),
        },
        pro: {
            ...MacroMathFragmentFactory(),
        },
        fat: {
            ...MacroMathFragmentFactory(),
        },
        weightTarget: faker.datatype.float(),
        weightTargetInKg: faker.datatype.float(),
    };
};
export const FullMacroProtocolFragmentFactory = () => {
    return {
        ...MacroProtocolFragmentFactory(),
        anthropometrySnapshot: {
            ...AnthropometryEntryFragmentFactory(),
        },
        calorieBudget: {
            ...FullCalorieBudgetFragmentFactory(),
        },
    };
};
export const MealFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Meal",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        start: faker.datatype.datetime().toISOString().split("T")[1],
        end: faker.datatype.datetime().toISOString().split("T")[1],
        type: faker.helpers.arrayElement(["breakfast", "lunch", "dinner", "snack", "meal"]),
    };
};
export const MealOptionFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "MealOption",
        note: faker.internet.password(10, false, /[0-9A-Z]/),
        position: faker.datatype.number(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const EditMealOptionFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        isAutosaving: faker.datatype.boolean(),
    };
};
export const FullMealOptionFragmentFactory = () => {
    return {
        ...MealOptionFragmentFactory(),
        servingAmounts: [{
                ...FullServingAmountFragmentFactory(),
            }],
    };
};
export const EditFullMealOptionFragmentFactory = () => {
    return {
        ...FullMealOptionFragmentFactory(),
        ...EditMealOptionFragmentFactory(),
    };
};
export const MealOptionPendingFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "MealOptionPending",
        note: faker.internet.password(10, false, /[0-9A-Z]/),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const EditMealOptionPendingFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        isAutosaving: faker.datatype.boolean(),
    };
};
export const FullMealOptionPendingFragmentFactory = () => {
    return {
        ...MealOptionPendingFragmentFactory(),
        servingAmounts: [{
                ...FullServingAmountFragmentFactory(),
            }],
    };
};
export const EditFullMealOptionPendingFragmentFactory = () => {
    return {
        ...FullMealOptionPendingFragmentFactory(),
        ...EditMealOptionPendingFragmentFactory(),
    };
};
export const MealPlanFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "MealPlan",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        isShared: faker.datatype.boolean(),
        isAutoSuggestionsEnabled: faker.datatype.boolean(),
        description: faker.internet.password(10, false, /[0-9A-Z]/),
        usesDateRange: faker.datatype.boolean(),
        dates: [faker.datatype.datetime().toISOString().split("T")[0]],
        startDate: faker.datatype.datetime().toISOString().split("T")[0],
        endDate: faker.datatype.datetime().toISOString().split("T")[0],
        type: faker.helpers.arrayElement(["macro", "exchange"]),
        createdAt: faker.datatype.datetime().toISOString(),
        updatedAt: faker.datatype.datetime().toISOString(),
        exchangeSet: {
            id: faker.datatype.uuid(),
        },
    };
};
export const EditMealPlanFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        isAutosaving: faker.datatype.boolean(),
        exchangeTargets: [{
                ...EditExchangeAmountFragmentFactory(),
            }],
    };
};
export const MealPlanSearchFormFragmentFactory = () => {
    return {
        ...MealPlanFragmentFactory(),
        macroProtocol: {
            ...FullMacroProtocolFragmentFactory(),
        },
    };
};
export const BasicMealPlanFragmentFactory = () => {
    return {
        ...MealPlanFragmentFactory(),
        exchangeSet: {
            ...ExchangeSetWithExchangesFragmentFactory(),
        },
    };
};
export const PreviewMealPlanFragmentFactory = () => {
    return {
        ...BasicMealPlanFragmentFactory(),
        macroProtocol: {
            ...FullMacroProtocolFragmentFactory(),
        },
        schedule: {
            ...ScheduleFragmentFactory(),
        },
        avoidedFoodGroups: [{
                ...FullFoodGroupWithFoodsFragmentFactory(),
            }],
        promotedFoodGroups: [{
                ...FullFoodGroupWithFoodsFragmentFactory(),
            }],
        avoidedFoods: [{
                ...FoodLimitedAccessFragmentFactory(),
            }],
        promotedFoods: [{
                ...FoodLimitedAccessFragmentFactory(),
            }],
        mostRecentEvent: {
            ...EventFragmentFactory(),
        },
        exchangeTargets: [{
                ...EditExchangeAmountFragmentFactory(),
            }],
    };
};
export const CopyableMealPlanFragmentFactory = () => {
    return {
        ...BasicMealPlanFragmentFactory(),
        macroProtocol: {
            ...MacroProtocolFragmentFactory(),
            calorieBudget: {
                ...CalorieBudgetFragmentFactory(),
            },
        },
    };
};
export const EditFullMealPlanFragmentFactory = () => {
    return {
        ...PreviewMealPlanFragmentFactory(),
        ...EditMealPlanFragmentFactory(),
        athlete: {
            ...AthleteWithFoodPrefsFragmentFactory(),
            macroDisplaySettings: {
                ...MacroMealPlanDisplaySettingsFragmentFactory(),
            },
            exchangeDisplaySettings: {
                ...ExchangeMealPlanDisplaySettingsFragmentFactory(),
            },
        },
        exchangeSet: {
            ...FullExchangeSetFragmentFactory(),
        },
        activityTemplates: [{
                ...ActivityTemplateFragmentFactory(),
            }],
        events: [{
                ...EventFragmentFactory(),
            }],
        mealTemplates: [{
                ...({
                    ...EditFullExchangeMealTemplateFragmentFactory(),
                }),
            }],
    };
};
export const FullMealPlanFragmentFactory = () => {
    return {
        ...PreviewMealPlanFragmentFactory(),
        athlete: {
            ...AthleteWithFoodPrefsFragmentFactory(),
            macroDisplaySettings: {
                ...MacroMealPlanDisplaySettingsFragmentFactory(),
            },
            exchangeDisplaySettings: {
                ...ExchangeMealPlanDisplaySettingsFragmentFactory(),
            },
        },
        exchangeSet: {
            ...FullExchangeSetFragmentFactory(),
        },
        activityTemplates: [{
                ...ActivityTemplateFragmentFactory(),
            }],
        events: [{
                ...EventFragmentFactory(),
            }],
        mealTemplates: [{
                ...({
                    ...FullExchangeMealTemplateFragmentFactory(),
                }),
            }],
    };
};
export const EventFragmentFactory = () => {
    return {
        __typename: "Event",
        type: faker.internet.password(10, false, /[0-9A-Z]/),
        datetime: faker.datatype.datetime().toISOString(),
    };
};
export const MealTemplateFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ExchangeMealTemplate",
        meal: {
            ...MealFragmentFactory(),
        },
    };
};
export const EditMealTemplateFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        isAutosaving: faker.datatype.boolean(),
        selectedMealOptionId: faker.datatype.uuid(),
        newMealOptionIds: [faker.datatype.uuid()],
    };
};
export const FullMealTemplateFragmentFactory = () => {
    return {
        ...MealTemplateFragmentFactory(),
        mealOptions: [{
                ...FullMealOptionFragmentFactory(),
            }],
        pendingMealOptions: [{
                ...FullMealOptionPendingFragmentFactory(),
            }],
    };
};
export const ExportMealTemplateFragmentFactory = () => {
    return {
        ...MealTemplateFragmentFactory(),
        mealOptions: [{
                ...ViewMealOptionFragmentFactory(),
            }],
    };
};
export const EditFullMealTemplateFragmentFactory = () => {
    return {
        ...MealTemplateFragmentFactory(),
        ...EditMealTemplateFragmentFactory(),
        mealOptions: [{
                ...EditFullMealOptionFragmentFactory(),
            }],
        pendingMealOptions: [{
                ...EditFullMealOptionPendingFragmentFactory(),
            }],
    };
};
export const NoteFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Note",
        datetime: faker.datatype.datetime().toISOString(),
        content: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const NoteWithTypeFragmentFactory = () => {
    return {
        ...NoteFragmentFactory(),
        type: {
            ...NoteTypeFragmentFactory(),
        },
    };
};
export const FullNoteFragmentFactory = () => {
    return {
        ...NoteWithTypeFragmentFactory(),
        athlete: {
            ...AthleteFragmentFactory(),
        },
    };
};
export const NoteTypeFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "NoteType",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const NutrientDietaryReferenceIntakeFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        type: faker.helpers.arrayElement(["RDA", "UL", "AI", "DGA", "unitsPerKcal"]),
    };
};
export const PositionFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Position",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const RecipeFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Recipe",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        steps: [faker.internet.password(10, false, /[0-9A-Z]/)],
        note: faker.internet.password(10, false, /[0-9A-Z]/),
        exchangeTypes: [faker.helpers.arrayElement(["starch", "fruit", "vegetable", "protein", "dairy", "fat"])],
        cho: faker.datatype.float(),
        pro: faker.datatype.float(),
        fat: faker.datatype.float(),
        prepTimeInMinutes: faker.datatype.number(),
        cookTimeInMinutes: faker.datatype.number(),
        isCurrent: faker.datatype.boolean(),
        images: [{
                ...ImageFragmentFactory(),
            }],
        isShared: faker.datatype.boolean(),
        createdBy: {
            id: faker.datatype.uuid(),
            firstName: faker.internet.password(10, false, /[0-9A-Z]/),
            lastName: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        mealTypes: [faker.helpers.arrayElement(["breakfast", "lunch", "dinner", "snack", "meal"])],
        score: {
            ...ScoreAssignmentFragmentFactory(),
        },
        foodCategory: {
            ...RecipeFoodCategoryFragmentFactory(),
        },
    };
};
export const RecipeLimitedAccessFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Recipe",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        exchangeTypes: [faker.helpers.arrayElement(["starch", "fruit", "vegetable", "protein", "dairy", "fat"])],
        isCurrent: faker.datatype.boolean(),
        images: [{
                ...ImageFragmentFactory(),
            }],
        history: {
            fromCompass: faker.datatype.boolean(),
        },
        descendantFoods: [{
                id: faker.datatype.uuid(),
                name: faker.internet.password(10, false, /[0-9A-Z]/),
                nixItemId: faker.internet.password(10, false, /[0-9A-Z]/),
                nixTagId: faker.internet.password(10, false, /[0-9A-Z]/),
            }],
        createdBy: {
            id: faker.datatype.uuid(),
            firstName: faker.internet.password(10, false, /[0-9A-Z]/),
            lastName: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        hasFullAccess: faker.datatype.boolean(),
        org: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        score: {
            ...ScoreAssignmentFragmentFactory(),
        },
        ingredients: [{
                ...RecipeIngredientServingAmountFragmentFactory(),
            }],
    };
};
export const RecipeWithIngredientsFragmentFactory = () => {
    return {
        ...RecipeFragmentFactory(),
        ingredients: [{
                ...ServingAmountWithFoodOrRecipeFragmentFactory(),
            }],
    };
};
export const RecipeWithServingsFragmentFactory = () => {
    return {
        ...RecipeWithIngredientsFragmentFactory(),
        hasFullAccess: faker.datatype.boolean(),
        descendantRecipes: [{
                ...RecipeWithIngredientsFragmentFactory(),
            }],
        servings: [{
                ...ServingWithFoodOrRecipeFragmentFactory(),
            }],
    };
};
export const ScheduleFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Schedule",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        activityFactor: faker.datatype.float(),
    };
};
export const FullScheduleFragmentFactory = () => {
    return {
        ...ScheduleFragmentFactory(),
        meals: [{
                ...MealFragmentFactory(),
            }],
        activities: [{
                ...ActivityFragmentFactory(),
            }],
        mealPlans: [{
                ...MealPlanFragmentFactory(),
            }],
    };
};
export const ServingFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Serving",
        units: faker.internet.password(10, false, /[0-9A-Z]/),
        defaultAmount: faker.datatype.float(),
        isDefault: faker.datatype.boolean(),
        weight: faker.datatype.float(),
        usdaWeightSeq: faker.internet.password(10, false, /[0-9A-Z]/),
        perRecipeYield: faker.datatype.float(),
        isRecipeServingOnly: faker.datatype.boolean(),
        hasOwnNutrients: faker.datatype.boolean(),
    };
};
export const ServingWithMacrosFragmentFactory = () => {
    return {
        ...ServingFragmentFactory(),
        macros: {
            cho: faker.datatype.float(),
            pro: faker.datatype.float(),
            fat: faker.datatype.float(),
            kcal: faker.datatype.float(),
        },
    };
};
export const ServingWithFoodOrRecipeFragmentFactory = () => {
    return {
        ...ServingFragmentFactory(),
        macros: {
            cho: faker.datatype.float(),
            pro: faker.datatype.float(),
            fat: faker.datatype.float(),
            kcal: faker.datatype.float(),
        },
        customUnits: faker.internet.password(10, false, /[0-9A-Z]/),
        unitPrefix: faker.internet.password(10, false, /[0-9A-Z]/),
        unitSuffix: faker.internet.password(10, false, /[0-9A-Z]/),
        unit: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        foodOrRecipe: {
            ...({
                ...FoodFragmentFactory(),
                hasFullAccess: faker.datatype.boolean(),
                org: {
                    id: faker.datatype.uuid(),
                    name: faker.internet.password(10, false, /[0-9A-Z]/),
                },
                ...({
                    brand: {
                        id: faker.datatype.uuid(),
                        name: faker.internet.password(10, false, /[0-9A-Z]/),
                    },
                }),
            }),
        },
    };
};
export const RecipeIngredientServingFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Serving",
        defaultAmount: faker.datatype.float(),
        isDefault: faker.datatype.boolean(),
        weight: faker.datatype.float(),
        perRecipeYield: faker.datatype.float(),
        hasOwnNutrients: faker.datatype.boolean(),
        macros: {
            cho: faker.datatype.float(),
            pro: faker.datatype.float(),
            fat: faker.datatype.float(),
            kcal: faker.datatype.float(),
        },
        units: faker.internet.password(10, false, /[0-9A-Z]/),
        unit: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        foodOrRecipe: {
            ...({
                ...FoodLimitedAccessFragmentFactory(),
            }),
        },
    };
};
export const FullServingFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Serving",
        units: faker.internet.password(10, false, /[0-9A-Z]/),
        defaultAmount: faker.datatype.float(),
        isDefault: faker.datatype.boolean(),
        weight: faker.datatype.float(),
        perRecipeYield: faker.datatype.float(),
        hasOwnNutrients: faker.datatype.boolean(),
        macros: {
            cho: faker.datatype.float(),
            pro: faker.datatype.float(),
            fat: faker.datatype.float(),
            kcal: faker.datatype.float(),
        },
        unit: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        foodOrRecipe: {
            ...({
                ...FoodLimitedAccessFragmentFactory(),
            }),
        },
    };
};
export const ExcessiveServingFragmentFactory = () => {
    return {
        ...ServingFragmentFactory(),
        customUnits: faker.internet.password(10, false, /[0-9A-Z]/),
        unitPrefix: faker.internet.password(10, false, /[0-9A-Z]/),
        unitSuffix: faker.internet.password(10, false, /[0-9A-Z]/),
        unit: {
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        },
        macros: {
            cho: faker.datatype.float(),
            pro: faker.datatype.float(),
            fat: faker.datatype.float(),
            kcal: faker.datatype.float(),
        },
        foodOrRecipe: {
            ...({
                ...FoodFragmentFactory(),
                ...({
                    brand: {
                        id: faker.datatype.uuid(),
                        name: faker.internet.password(10, false, /[0-9A-Z]/),
                    },
                }),
            }),
        },
    };
};
export const ServingAmountWithFoodOrRecipeFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ServingAmount",
        amount: faker.datatype.float(),
        position: faker.datatype.number(),
        serving: {
            ...ServingWithFoodOrRecipeFragmentFactory(),
        },
    };
};
export const FullServingAmountFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ServingAmount",
        amount: faker.datatype.float(),
        position: faker.datatype.number(),
        serving: {
            ...FullServingFragmentFactory(),
        },
    };
};
export const ExcessiveServingAmountFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "ServingAmount",
        amount: faker.datatype.float(),
        position: faker.datatype.number(),
        serving: {
            ...ExcessiveServingFragmentFactory(),
        },
    };
};
export const SportFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Sport",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const FullSportFragmentFactory = () => {
    return {
        ...SportFragmentFactory(),
        positions: [{
                ...PositionFragmentFactory(),
            }],
    };
};
export const TeamFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "Team",
        gender: faker.internet.password(10, false, /[0-9A-Z]/),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const TeamWithSportFragmentFactory = () => {
    return {
        ...TeamFragmentFactory(),
        sport: {
            ...FullSportFragmentFactory(),
        },
    };
};
export const UsdaFoodFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "USDAFood",
        allHighlightFields: [faker.internet.password(10, false, /[0-9A-Z]/)],
        brandOwner: faker.internet.password(10, false, /[0-9A-Z]/),
        dataType: faker.helpers.arrayElement(["Branded", "Survey", "Legacy", "Foundation"]),
        description: faker.internet.password(10, false, /[0-9A-Z]/),
        gtinUpc: faker.internet.password(10, false, /[0-9A-Z]/),
        ingredients: [faker.internet.password(10, false, /[0-9A-Z]/)],
        publishedDate: faker.datatype.datetime().toISOString().split("T")[0],
        score: faker.datatype.float(),
    };
};
export const UsdaFoodDetailFragmentFactory = () => {
    return {
        __typename: "USDAFoodDetail",
        id: faker.datatype.uuid(),
        usdaFdcFoodCategoryId: faker.datatype.number(),
        usdaFdcDataType: faker.internet.password(10, false, /[0-9A-Z]/),
        cho: {
            ...UsdaFoodNutrientFragmentFactory(),
        },
        pro: {
            ...UsdaFoodNutrientFragmentFactory(),
        },
        fat: {
            ...UsdaFoodNutrientFragmentFactory(),
        },
        foodNutrients: [{
                ...UsdaFoodNutrientFragmentFactory(),
            }],
        servings: [{
                ...UsdaFoodServingFragmentFactory(),
            }],
    };
};
export const UsdaFoodNutrientFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        amount: faker.datatype.float(),
        dataPoints: faker.datatype.number(),
        unitName: faker.internet.password(10, false, /[0-9A-Z]/),
        max: faker.datatype.float(),
        min: faker.datatype.float(),
        median: faker.datatype.float(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        footnote: faker.internet.password(10, false, /[0-9A-Z]/),
        __typename: "USDAFoodNutrient",
    };
};
export const UsdaFoodServingFragmentFactory = () => {
    return {
        __typename: "USDAFoodServing",
        idx: faker.datatype.number(),
        cho: faker.datatype.float(),
        pro: faker.datatype.float(),
        fat: faker.datatype.float(),
        weight: faker.datatype.float(),
        defaultAmount: faker.datatype.float(),
        units: faker.internet.password(10, false, /[0-9A-Z]/),
        isDefault: faker.datatype.boolean(),
        usdaWeightSeq: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const AthleteWithAnthroFragmentFactory = () => {
    return {
        ...AthleteFragmentFactory(),
        position: {
            ...PositionFragmentFactory(),
        },
        mostRecentAnthropometryEntry: {
            ...AnthropometryEntryFragmentFactory(),
        },
    };
};
export const MealPlanWithAthleteFragmentFactory = () => {
    return {
        ...MealPlanSearchFormFragmentFactory(),
        athlete: {
            ...AthleteFragmentFactory(),
        },
    };
};
export const SimpleFoodGroupFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        name: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const MealPlanBulkCopyTeamPreviewFragmentFactory = () => {
    return {
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        id: faker.datatype.uuid(),
    };
};
export const NutritionixCommonFoodFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "NutritionixCommonFood",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        nixTagId: faker.internet.password(10, false, /[0-9A-Z]/),
        thumbnailUrl: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const NutritionixBrandedFoodFragmentFactory = () => {
    return {
        id: faker.datatype.uuid(),
        __typename: "NutritionixBrandedFood",
        name: faker.internet.password(10, false, /[0-9A-Z]/),
        nixItemId: faker.internet.password(10, false, /[0-9A-Z]/),
        brand: {
            id: faker.datatype.uuid(),
            __typename: "NutritionixBrand",
            name: faker.internet.password(10, false, /[0-9A-Z]/),
            type: faker.datatype.number(),
        },
        thumbnailUrl: faker.internet.password(10, false, /[0-9A-Z]/),
    };
};
export const FoodOrRecipePreferencesFragmentFactory = () => {
    return {
        ...({
            __typename: "BrandedFood",
            id: faker.datatype.uuid(),
            name: faker.internet.password(10, false, /[0-9A-Z]/),
        }),
    };
};
//# sourceMappingURL=index.js.map